/* eslint-disable */
/* tslint:disable */

/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
import {
  Benefit,
  McdType,
  McdSubtype,
  SlideType,
  NjmmisCheckResult,
} from './globalTypes' // ====================================================
// GraphQL query operation: Application
// ====================================================

import {ApplicationVariables as ApplicationVariablesOrig} from '../types/Application'
import {Application as ApplicationOrig} from '../types/Application'
import {Application_application as Application_applicationOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication as Application_application_RyanWhiteApplicationOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_accountOnDateOfService as Application_application_RyanWhiteApplication_accountOnDateOfServiceOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_benefitOutcomes as Application_application_RyanWhiteApplication_benefitOutcomesOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_benefitOutcomes_application as Application_application_RyanWhiteApplication_benefitOutcomes_applicationOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_benefitOutcomes_person as Application_application_RyanWhiteApplication_benefitOutcomes_personOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_documentFiles as Application_application_RyanWhiteApplication_documentFilesOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_documentFiles_documents as Application_application_RyanWhiteApplication_documentFiles_documentsOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_documents as Application_application_RyanWhiteApplication_documentsOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_documents_application as Application_application_RyanWhiteApplication_documents_applicationOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_documents_person as Application_application_RyanWhiteApplication_documents_personOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_documents_files as Application_application_RyanWhiteApplication_documents_filesOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_householdMembers as Application_application_RyanWhiteApplication_householdMembersOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_householdMembers_person as Application_application_RyanWhiteApplication_householdMembers_personOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_householdMembers_person_documentFiles as Application_application_RyanWhiteApplication_householdMembers_person_documentFilesOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_householdMembers_person_deductions as Application_application_RyanWhiteApplication_householdMembers_person_deductionsOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_householdMembers_person_incomeSources as Application_application_RyanWhiteApplication_householdMembers_person_incomeSourcesOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession as Application_application_RyanWhiteApplication_householdMembers_person_incomeSources_esignSessionOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession_esignWizards as Application_application_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession_esignWizardsOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes as Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomesOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application as Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_applicationOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_SlideApplication as Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_SlideApplicationOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication as Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication as Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_householdMembers_person_phoneNumbers as Application_application_RyanWhiteApplication_householdMembers_person_phoneNumbersOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession as Application_application_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSessionOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards as Application_application_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession_esignWizardsOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_assignedTo as Application_application_RyanWhiteApplication_assignedToOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_person as Application_application_RyanWhiteApplication_personOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_person_openHouseholdMemberApplications as Application_application_RyanWhiteApplication_person_openHouseholdMemberApplicationsOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_person_openApplications as Application_application_RyanWhiteApplication_person_openApplicationsOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_person_openApplications_RyanWhiteApplication as Application_application_RyanWhiteApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_person_openApplications_SlideApplication as Application_application_RyanWhiteApplication_person_openApplications_SlideApplicationOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_person_openApplications_CharityCareApplication as Application_application_RyanWhiteApplication_person_openApplications_CharityCareApplicationOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_person_openApplications_MedicaidApplication as Application_application_RyanWhiteApplication_person_openApplications_MedicaidApplicationOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_person_documentFiles as Application_application_RyanWhiteApplication_person_documentFilesOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_person_relationships as Application_application_RyanWhiteApplication_person_relationshipsOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_person_relationships_otherPerson as Application_application_RyanWhiteApplication_person_relationships_otherPersonOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_person_relationships_otherPerson_deductions as Application_application_RyanWhiteApplication_person_relationships_otherPerson_deductionsOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_person_relationships_otherPerson_incomeSources as Application_application_RyanWhiteApplication_person_relationships_otherPerson_incomeSourcesOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession as Application_application_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSessionOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards as Application_application_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizardsOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes as Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomesOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application as Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_applicationOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication as Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplicationOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication as Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication as Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers as Application_application_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbersOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession as Application_application_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSessionOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards as Application_application_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizardsOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_person_deductions as Application_application_RyanWhiteApplication_person_deductionsOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_person_incomeSources as Application_application_RyanWhiteApplication_person_incomeSourcesOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_person_incomeSources_esignSession as Application_application_RyanWhiteApplication_person_incomeSources_esignSessionOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_person_incomeSources_esignSession_esignWizards as Application_application_RyanWhiteApplication_person_incomeSources_esignSession_esignWizardsOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_person_benefitOutcomes as Application_application_RyanWhiteApplication_person_benefitOutcomesOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_person_benefitOutcomes_application as Application_application_RyanWhiteApplication_person_benefitOutcomes_applicationOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplication as Application_application_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplicationOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplication as Application_application_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplication as Application_application_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_person_phoneNumbers as Application_application_RyanWhiteApplication_person_phoneNumbersOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_person_phoneNumbers_esignSession as Application_application_RyanWhiteApplication_person_phoneNumbers_esignSessionOrig} from '../types/Application'
import {Application_application_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizards as Application_application_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizardsOrig} from '../types/Application'
import {Application_application_SlideApplication as Application_application_SlideApplicationOrig} from '../types/Application'
import {Application_application_SlideApplication_accountOnDateOfService as Application_application_SlideApplication_accountOnDateOfServiceOrig} from '../types/Application'
import {Application_application_SlideApplication_benefitOutcomes as Application_application_SlideApplication_benefitOutcomesOrig} from '../types/Application'
import {Application_application_SlideApplication_benefitOutcomes_application as Application_application_SlideApplication_benefitOutcomes_applicationOrig} from '../types/Application'
import {Application_application_SlideApplication_benefitOutcomes_person as Application_application_SlideApplication_benefitOutcomes_personOrig} from '../types/Application'
import {Application_application_SlideApplication_documentFiles as Application_application_SlideApplication_documentFilesOrig} from '../types/Application'
import {Application_application_SlideApplication_documentFiles_documents as Application_application_SlideApplication_documentFiles_documentsOrig} from '../types/Application'
import {Application_application_SlideApplication_documents as Application_application_SlideApplication_documentsOrig} from '../types/Application'
import {Application_application_SlideApplication_documents_application as Application_application_SlideApplication_documents_applicationOrig} from '../types/Application'
import {Application_application_SlideApplication_documents_person as Application_application_SlideApplication_documents_personOrig} from '../types/Application'
import {Application_application_SlideApplication_documents_files as Application_application_SlideApplication_documents_filesOrig} from '../types/Application'
import {Application_application_SlideApplication_householdMembers as Application_application_SlideApplication_householdMembersOrig} from '../types/Application'
import {Application_application_SlideApplication_householdMembers_person as Application_application_SlideApplication_householdMembers_personOrig} from '../types/Application'
import {Application_application_SlideApplication_householdMembers_person_documentFiles as Application_application_SlideApplication_householdMembers_person_documentFilesOrig} from '../types/Application'
import {Application_application_SlideApplication_householdMembers_person_deductions as Application_application_SlideApplication_householdMembers_person_deductionsOrig} from '../types/Application'
import {Application_application_SlideApplication_householdMembers_person_incomeSources as Application_application_SlideApplication_householdMembers_person_incomeSourcesOrig} from '../types/Application'
import {Application_application_SlideApplication_householdMembers_person_incomeSources_esignSession as Application_application_SlideApplication_householdMembers_person_incomeSources_esignSessionOrig} from '../types/Application'
import {Application_application_SlideApplication_householdMembers_person_incomeSources_esignSession_esignWizards as Application_application_SlideApplication_householdMembers_person_incomeSources_esignSession_esignWizardsOrig} from '../types/Application'
import {Application_application_SlideApplication_householdMembers_person_benefitOutcomes as Application_application_SlideApplication_householdMembers_person_benefitOutcomesOrig} from '../types/Application'
import {Application_application_SlideApplication_householdMembers_person_benefitOutcomes_application as Application_application_SlideApplication_householdMembers_person_benefitOutcomes_applicationOrig} from '../types/Application'
import {Application_application_SlideApplication_householdMembers_person_benefitOutcomes_application_SlideApplication as Application_application_SlideApplication_householdMembers_person_benefitOutcomes_application_SlideApplicationOrig} from '../types/Application'
import {Application_application_SlideApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication as Application_application_SlideApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/Application'
import {Application_application_SlideApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication as Application_application_SlideApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/Application'
import {Application_application_SlideApplication_householdMembers_person_phoneNumbers as Application_application_SlideApplication_householdMembers_person_phoneNumbersOrig} from '../types/Application'
import {Application_application_SlideApplication_householdMembers_person_phoneNumbers_esignSession as Application_application_SlideApplication_householdMembers_person_phoneNumbers_esignSessionOrig} from '../types/Application'
import {Application_application_SlideApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards as Application_application_SlideApplication_householdMembers_person_phoneNumbers_esignSession_esignWizardsOrig} from '../types/Application'
import {Application_application_SlideApplication_assignedTo as Application_application_SlideApplication_assignedToOrig} from '../types/Application'
import {Application_application_SlideApplication_person as Application_application_SlideApplication_personOrig} from '../types/Application'
import {Application_application_SlideApplication_person_openHouseholdMemberApplications as Application_application_SlideApplication_person_openHouseholdMemberApplicationsOrig} from '../types/Application'
import {Application_application_SlideApplication_person_openApplications as Application_application_SlideApplication_person_openApplicationsOrig} from '../types/Application'
import {Application_application_SlideApplication_person_openApplications_RyanWhiteApplication as Application_application_SlideApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/Application'
import {Application_application_SlideApplication_person_openApplications_SlideApplication as Application_application_SlideApplication_person_openApplications_SlideApplicationOrig} from '../types/Application'
import {Application_application_SlideApplication_person_openApplications_CharityCareApplication as Application_application_SlideApplication_person_openApplications_CharityCareApplicationOrig} from '../types/Application'
import {Application_application_SlideApplication_person_openApplications_MedicaidApplication as Application_application_SlideApplication_person_openApplications_MedicaidApplicationOrig} from '../types/Application'
import {Application_application_SlideApplication_person_documentFiles as Application_application_SlideApplication_person_documentFilesOrig} from '../types/Application'
import {Application_application_SlideApplication_person_relationships as Application_application_SlideApplication_person_relationshipsOrig} from '../types/Application'
import {Application_application_SlideApplication_person_relationships_otherPerson as Application_application_SlideApplication_person_relationships_otherPersonOrig} from '../types/Application'
import {Application_application_SlideApplication_person_relationships_otherPerson_deductions as Application_application_SlideApplication_person_relationships_otherPerson_deductionsOrig} from '../types/Application'
import {Application_application_SlideApplication_person_relationships_otherPerson_incomeSources as Application_application_SlideApplication_person_relationships_otherPerson_incomeSourcesOrig} from '../types/Application'
import {Application_application_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession as Application_application_SlideApplication_person_relationships_otherPerson_incomeSources_esignSessionOrig} from '../types/Application'
import {Application_application_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards as Application_application_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizardsOrig} from '../types/Application'
import {Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes as Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomesOrig} from '../types/Application'
import {Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application as Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_applicationOrig} from '../types/Application'
import {Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication as Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplicationOrig} from '../types/Application'
import {Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication as Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/Application'
import {Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication as Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/Application'
import {Application_application_SlideApplication_person_relationships_otherPerson_phoneNumbers as Application_application_SlideApplication_person_relationships_otherPerson_phoneNumbersOrig} from '../types/Application'
import {Application_application_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession as Application_application_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSessionOrig} from '../types/Application'
import {Application_application_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards as Application_application_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizardsOrig} from '../types/Application'
import {Application_application_SlideApplication_person_deductions as Application_application_SlideApplication_person_deductionsOrig} from '../types/Application'
import {Application_application_SlideApplication_person_incomeSources as Application_application_SlideApplication_person_incomeSourcesOrig} from '../types/Application'
import {Application_application_SlideApplication_person_incomeSources_esignSession as Application_application_SlideApplication_person_incomeSources_esignSessionOrig} from '../types/Application'
import {Application_application_SlideApplication_person_incomeSources_esignSession_esignWizards as Application_application_SlideApplication_person_incomeSources_esignSession_esignWizardsOrig} from '../types/Application'
import {Application_application_SlideApplication_person_benefitOutcomes as Application_application_SlideApplication_person_benefitOutcomesOrig} from '../types/Application'
import {Application_application_SlideApplication_person_benefitOutcomes_application as Application_application_SlideApplication_person_benefitOutcomes_applicationOrig} from '../types/Application'
import {Application_application_SlideApplication_person_benefitOutcomes_application_SlideApplication as Application_application_SlideApplication_person_benefitOutcomes_application_SlideApplicationOrig} from '../types/Application'
import {Application_application_SlideApplication_person_benefitOutcomes_application_CharityCareApplication as Application_application_SlideApplication_person_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/Application'
import {Application_application_SlideApplication_person_benefitOutcomes_application_MedicaidApplication as Application_application_SlideApplication_person_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/Application'
import {Application_application_SlideApplication_person_phoneNumbers as Application_application_SlideApplication_person_phoneNumbersOrig} from '../types/Application'
import {Application_application_SlideApplication_person_phoneNumbers_esignSession as Application_application_SlideApplication_person_phoneNumbers_esignSessionOrig} from '../types/Application'
import {Application_application_SlideApplication_person_phoneNumbers_esignSession_esignWizards as Application_application_SlideApplication_person_phoneNumbers_esignSession_esignWizardsOrig} from '../types/Application'
import {Application_application_CharityCareApplication as Application_application_CharityCareApplicationOrig} from '../types/Application'
import {Application_application_CharityCareApplication_accountOnDateOfService as Application_application_CharityCareApplication_accountOnDateOfServiceOrig} from '../types/Application'
import {Application_application_CharityCareApplication_benefitOutcomes as Application_application_CharityCareApplication_benefitOutcomesOrig} from '../types/Application'
import {Application_application_CharityCareApplication_benefitOutcomes_application as Application_application_CharityCareApplication_benefitOutcomes_applicationOrig} from '../types/Application'
import {Application_application_CharityCareApplication_benefitOutcomes_person as Application_application_CharityCareApplication_benefitOutcomes_personOrig} from '../types/Application'
import {Application_application_CharityCareApplication_documentFiles as Application_application_CharityCareApplication_documentFilesOrig} from '../types/Application'
import {Application_application_CharityCareApplication_documentFiles_documents as Application_application_CharityCareApplication_documentFiles_documentsOrig} from '../types/Application'
import {Application_application_CharityCareApplication_documents as Application_application_CharityCareApplication_documentsOrig} from '../types/Application'
import {Application_application_CharityCareApplication_documents_application as Application_application_CharityCareApplication_documents_applicationOrig} from '../types/Application'
import {Application_application_CharityCareApplication_documents_person as Application_application_CharityCareApplication_documents_personOrig} from '../types/Application'
import {Application_application_CharityCareApplication_documents_files as Application_application_CharityCareApplication_documents_filesOrig} from '../types/Application'
import {Application_application_CharityCareApplication_householdMembers as Application_application_CharityCareApplication_householdMembersOrig} from '../types/Application'
import {Application_application_CharityCareApplication_householdMembers_person as Application_application_CharityCareApplication_householdMembers_personOrig} from '../types/Application'
import {Application_application_CharityCareApplication_householdMembers_person_documentFiles as Application_application_CharityCareApplication_householdMembers_person_documentFilesOrig} from '../types/Application'
import {Application_application_CharityCareApplication_householdMembers_person_deductions as Application_application_CharityCareApplication_householdMembers_person_deductionsOrig} from '../types/Application'
import {Application_application_CharityCareApplication_householdMembers_person_incomeSources as Application_application_CharityCareApplication_householdMembers_person_incomeSourcesOrig} from '../types/Application'
import {Application_application_CharityCareApplication_householdMembers_person_incomeSources_esignSession as Application_application_CharityCareApplication_householdMembers_person_incomeSources_esignSessionOrig} from '../types/Application'
import {Application_application_CharityCareApplication_householdMembers_person_incomeSources_esignSession_esignWizards as Application_application_CharityCareApplication_householdMembers_person_incomeSources_esignSession_esignWizardsOrig} from '../types/Application'
import {Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes as Application_application_CharityCareApplication_householdMembers_person_benefitOutcomesOrig} from '../types/Application'
import {Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application as Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes_applicationOrig} from '../types/Application'
import {Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application_SlideApplication as Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application_SlideApplicationOrig} from '../types/Application'
import {Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication as Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/Application'
import {Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication as Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/Application'
import {Application_application_CharityCareApplication_householdMembers_person_phoneNumbers as Application_application_CharityCareApplication_householdMembers_person_phoneNumbersOrig} from '../types/Application'
import {Application_application_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession as Application_application_CharityCareApplication_householdMembers_person_phoneNumbers_esignSessionOrig} from '../types/Application'
import {Application_application_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards as Application_application_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession_esignWizardsOrig} from '../types/Application'
import {Application_application_CharityCareApplication_assignedTo as Application_application_CharityCareApplication_assignedToOrig} from '../types/Application'
import {Application_application_CharityCareApplication_person as Application_application_CharityCareApplication_personOrig} from '../types/Application'
import {Application_application_CharityCareApplication_person_openHouseholdMemberApplications as Application_application_CharityCareApplication_person_openHouseholdMemberApplicationsOrig} from '../types/Application'
import {Application_application_CharityCareApplication_person_openApplications as Application_application_CharityCareApplication_person_openApplicationsOrig} from '../types/Application'
import {Application_application_CharityCareApplication_person_openApplications_RyanWhiteApplication as Application_application_CharityCareApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/Application'
import {Application_application_CharityCareApplication_person_openApplications_SlideApplication as Application_application_CharityCareApplication_person_openApplications_SlideApplicationOrig} from '../types/Application'
import {Application_application_CharityCareApplication_person_openApplications_CharityCareApplication as Application_application_CharityCareApplication_person_openApplications_CharityCareApplicationOrig} from '../types/Application'
import {Application_application_CharityCareApplication_person_openApplications_MedicaidApplication as Application_application_CharityCareApplication_person_openApplications_MedicaidApplicationOrig} from '../types/Application'
import {Application_application_CharityCareApplication_person_documentFiles as Application_application_CharityCareApplication_person_documentFilesOrig} from '../types/Application'
import {Application_application_CharityCareApplication_person_relationships as Application_application_CharityCareApplication_person_relationshipsOrig} from '../types/Application'
import {Application_application_CharityCareApplication_person_relationships_otherPerson as Application_application_CharityCareApplication_person_relationships_otherPersonOrig} from '../types/Application'
import {Application_application_CharityCareApplication_person_relationships_otherPerson_deductions as Application_application_CharityCareApplication_person_relationships_otherPerson_deductionsOrig} from '../types/Application'
import {Application_application_CharityCareApplication_person_relationships_otherPerson_incomeSources as Application_application_CharityCareApplication_person_relationships_otherPerson_incomeSourcesOrig} from '../types/Application'
import {Application_application_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession as Application_application_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSessionOrig} from '../types/Application'
import {Application_application_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards as Application_application_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizardsOrig} from '../types/Application'
import {Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes as Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomesOrig} from '../types/Application'
import {Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application as Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_applicationOrig} from '../types/Application'
import {Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication as Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplicationOrig} from '../types/Application'
import {Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication as Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/Application'
import {Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication as Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/Application'
import {Application_application_CharityCareApplication_person_relationships_otherPerson_phoneNumbers as Application_application_CharityCareApplication_person_relationships_otherPerson_phoneNumbersOrig} from '../types/Application'
import {Application_application_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession as Application_application_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSessionOrig} from '../types/Application'
import {Application_application_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards as Application_application_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizardsOrig} from '../types/Application'
import {Application_application_CharityCareApplication_person_deductions as Application_application_CharityCareApplication_person_deductionsOrig} from '../types/Application'
import {Application_application_CharityCareApplication_person_incomeSources as Application_application_CharityCareApplication_person_incomeSourcesOrig} from '../types/Application'
import {Application_application_CharityCareApplication_person_incomeSources_esignSession as Application_application_CharityCareApplication_person_incomeSources_esignSessionOrig} from '../types/Application'
import {Application_application_CharityCareApplication_person_incomeSources_esignSession_esignWizards as Application_application_CharityCareApplication_person_incomeSources_esignSession_esignWizardsOrig} from '../types/Application'
import {Application_application_CharityCareApplication_person_benefitOutcomes as Application_application_CharityCareApplication_person_benefitOutcomesOrig} from '../types/Application'
import {Application_application_CharityCareApplication_person_benefitOutcomes_application as Application_application_CharityCareApplication_person_benefitOutcomes_applicationOrig} from '../types/Application'
import {Application_application_CharityCareApplication_person_benefitOutcomes_application_SlideApplication as Application_application_CharityCareApplication_person_benefitOutcomes_application_SlideApplicationOrig} from '../types/Application'
import {Application_application_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplication as Application_application_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/Application'
import {Application_application_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplication as Application_application_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/Application'
import {Application_application_CharityCareApplication_person_phoneNumbers as Application_application_CharityCareApplication_person_phoneNumbersOrig} from '../types/Application'
import {Application_application_CharityCareApplication_person_phoneNumbers_esignSession as Application_application_CharityCareApplication_person_phoneNumbers_esignSessionOrig} from '../types/Application'
import {Application_application_CharityCareApplication_person_phoneNumbers_esignSession_esignWizards as Application_application_CharityCareApplication_person_phoneNumbers_esignSession_esignWizardsOrig} from '../types/Application'
import {Application_application_MonitorApplication as Application_application_MonitorApplicationOrig} from '../types/Application'
import {Application_application_MonitorApplication_primaryPointOfContact as Application_application_MonitorApplication_primaryPointOfContactOrig} from '../types/Application'
import {Application_application_MonitorApplication_primaryPointOfContact_deductions as Application_application_MonitorApplication_primaryPointOfContact_deductionsOrig} from '../types/Application'
import {Application_application_MonitorApplication_primaryPointOfContact_incomeSources as Application_application_MonitorApplication_primaryPointOfContact_incomeSourcesOrig} from '../types/Application'
import {Application_application_MonitorApplication_primaryPointOfContact_incomeSources_esignSession as Application_application_MonitorApplication_primaryPointOfContact_incomeSources_esignSessionOrig} from '../types/Application'
import {Application_application_MonitorApplication_primaryPointOfContact_incomeSources_esignSession_esignWizards as Application_application_MonitorApplication_primaryPointOfContact_incomeSources_esignSession_esignWizardsOrig} from '../types/Application'
import {Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes as Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomesOrig} from '../types/Application'
import {Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application as Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_applicationOrig} from '../types/Application'
import {Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplication as Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplicationOrig} from '../types/Application'
import {Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplication as Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/Application'
import {Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplication as Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/Application'
import {Application_application_MonitorApplication_primaryPointOfContact_phoneNumbers as Application_application_MonitorApplication_primaryPointOfContact_phoneNumbersOrig} from '../types/Application'
import {Application_application_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession as Application_application_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSessionOrig} from '../types/Application'
import {Application_application_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizards as Application_application_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizardsOrig} from '../types/Application'
import {Application_application_MonitorApplication_accountOnDateOfService as Application_application_MonitorApplication_accountOnDateOfServiceOrig} from '../types/Application'
import {Application_application_MonitorApplication_benefitOutcomes as Application_application_MonitorApplication_benefitOutcomesOrig} from '../types/Application'
import {Application_application_MonitorApplication_benefitOutcomes_application as Application_application_MonitorApplication_benefitOutcomes_applicationOrig} from '../types/Application'
import {Application_application_MonitorApplication_benefitOutcomes_person as Application_application_MonitorApplication_benefitOutcomes_personOrig} from '../types/Application'
import {Application_application_MonitorApplication_documentFiles as Application_application_MonitorApplication_documentFilesOrig} from '../types/Application'
import {Application_application_MonitorApplication_documentFiles_documents as Application_application_MonitorApplication_documentFiles_documentsOrig} from '../types/Application'
import {Application_application_MonitorApplication_documents as Application_application_MonitorApplication_documentsOrig} from '../types/Application'
import {Application_application_MonitorApplication_documents_application as Application_application_MonitorApplication_documents_applicationOrig} from '../types/Application'
import {Application_application_MonitorApplication_documents_person as Application_application_MonitorApplication_documents_personOrig} from '../types/Application'
import {Application_application_MonitorApplication_documents_files as Application_application_MonitorApplication_documents_filesOrig} from '../types/Application'
import {Application_application_MonitorApplication_householdMembers as Application_application_MonitorApplication_householdMembersOrig} from '../types/Application'
import {Application_application_MonitorApplication_householdMembers_person as Application_application_MonitorApplication_householdMembers_personOrig} from '../types/Application'
import {Application_application_MonitorApplication_householdMembers_person_documentFiles as Application_application_MonitorApplication_householdMembers_person_documentFilesOrig} from '../types/Application'
import {Application_application_MonitorApplication_householdMembers_person_deductions as Application_application_MonitorApplication_householdMembers_person_deductionsOrig} from '../types/Application'
import {Application_application_MonitorApplication_householdMembers_person_incomeSources as Application_application_MonitorApplication_householdMembers_person_incomeSourcesOrig} from '../types/Application'
import {Application_application_MonitorApplication_householdMembers_person_incomeSources_esignSession as Application_application_MonitorApplication_householdMembers_person_incomeSources_esignSessionOrig} from '../types/Application'
import {Application_application_MonitorApplication_householdMembers_person_incomeSources_esignSession_esignWizards as Application_application_MonitorApplication_householdMembers_person_incomeSources_esignSession_esignWizardsOrig} from '../types/Application'
import {Application_application_MonitorApplication_householdMembers_person_benefitOutcomes as Application_application_MonitorApplication_householdMembers_person_benefitOutcomesOrig} from '../types/Application'
import {Application_application_MonitorApplication_householdMembers_person_benefitOutcomes_application as Application_application_MonitorApplication_householdMembers_person_benefitOutcomes_applicationOrig} from '../types/Application'
import {Application_application_MonitorApplication_householdMembers_person_benefitOutcomes_application_SlideApplication as Application_application_MonitorApplication_householdMembers_person_benefitOutcomes_application_SlideApplicationOrig} from '../types/Application'
import {Application_application_MonitorApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication as Application_application_MonitorApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/Application'
import {Application_application_MonitorApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication as Application_application_MonitorApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/Application'
import {Application_application_MonitorApplication_householdMembers_person_phoneNumbers as Application_application_MonitorApplication_householdMembers_person_phoneNumbersOrig} from '../types/Application'
import {Application_application_MonitorApplication_householdMembers_person_phoneNumbers_esignSession as Application_application_MonitorApplication_householdMembers_person_phoneNumbers_esignSessionOrig} from '../types/Application'
import {Application_application_MonitorApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards as Application_application_MonitorApplication_householdMembers_person_phoneNumbers_esignSession_esignWizardsOrig} from '../types/Application'
import {Application_application_MonitorApplication_assignedTo as Application_application_MonitorApplication_assignedToOrig} from '../types/Application'
import {Application_application_MonitorApplication_person as Application_application_MonitorApplication_personOrig} from '../types/Application'
import {Application_application_MonitorApplication_person_openHouseholdMemberApplications as Application_application_MonitorApplication_person_openHouseholdMemberApplicationsOrig} from '../types/Application'
import {Application_application_MonitorApplication_person_openApplications as Application_application_MonitorApplication_person_openApplicationsOrig} from '../types/Application'
import {Application_application_MonitorApplication_person_openApplications_RyanWhiteApplication as Application_application_MonitorApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/Application'
import {Application_application_MonitorApplication_person_openApplications_SlideApplication as Application_application_MonitorApplication_person_openApplications_SlideApplicationOrig} from '../types/Application'
import {Application_application_MonitorApplication_person_openApplications_CharityCareApplication as Application_application_MonitorApplication_person_openApplications_CharityCareApplicationOrig} from '../types/Application'
import {Application_application_MonitorApplication_person_openApplications_MedicaidApplication as Application_application_MonitorApplication_person_openApplications_MedicaidApplicationOrig} from '../types/Application'
import {Application_application_MonitorApplication_person_documentFiles as Application_application_MonitorApplication_person_documentFilesOrig} from '../types/Application'
import {Application_application_MonitorApplication_person_relationships as Application_application_MonitorApplication_person_relationshipsOrig} from '../types/Application'
import {Application_application_MonitorApplication_person_relationships_otherPerson as Application_application_MonitorApplication_person_relationships_otherPersonOrig} from '../types/Application'
import {Application_application_MonitorApplication_person_relationships_otherPerson_deductions as Application_application_MonitorApplication_person_relationships_otherPerson_deductionsOrig} from '../types/Application'
import {Application_application_MonitorApplication_person_relationships_otherPerson_incomeSources as Application_application_MonitorApplication_person_relationships_otherPerson_incomeSourcesOrig} from '../types/Application'
import {Application_application_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession as Application_application_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSessionOrig} from '../types/Application'
import {Application_application_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards as Application_application_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizardsOrig} from '../types/Application'
import {Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes as Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomesOrig} from '../types/Application'
import {Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application as Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_applicationOrig} from '../types/Application'
import {Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication as Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplicationOrig} from '../types/Application'
import {Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication as Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/Application'
import {Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication as Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/Application'
import {Application_application_MonitorApplication_person_relationships_otherPerson_phoneNumbers as Application_application_MonitorApplication_person_relationships_otherPerson_phoneNumbersOrig} from '../types/Application'
import {Application_application_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession as Application_application_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSessionOrig} from '../types/Application'
import {Application_application_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards as Application_application_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizardsOrig} from '../types/Application'
import {Application_application_MonitorApplication_person_deductions as Application_application_MonitorApplication_person_deductionsOrig} from '../types/Application'
import {Application_application_MonitorApplication_person_incomeSources as Application_application_MonitorApplication_person_incomeSourcesOrig} from '../types/Application'
import {Application_application_MonitorApplication_person_incomeSources_esignSession as Application_application_MonitorApplication_person_incomeSources_esignSessionOrig} from '../types/Application'
import {Application_application_MonitorApplication_person_incomeSources_esignSession_esignWizards as Application_application_MonitorApplication_person_incomeSources_esignSession_esignWizardsOrig} from '../types/Application'
import {Application_application_MonitorApplication_person_benefitOutcomes as Application_application_MonitorApplication_person_benefitOutcomesOrig} from '../types/Application'
import {Application_application_MonitorApplication_person_benefitOutcomes_application as Application_application_MonitorApplication_person_benefitOutcomes_applicationOrig} from '../types/Application'
import {Application_application_MonitorApplication_person_benefitOutcomes_application_SlideApplication as Application_application_MonitorApplication_person_benefitOutcomes_application_SlideApplicationOrig} from '../types/Application'
import {Application_application_MonitorApplication_person_benefitOutcomes_application_CharityCareApplication as Application_application_MonitorApplication_person_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/Application'
import {Application_application_MonitorApplication_person_benefitOutcomes_application_MedicaidApplication as Application_application_MonitorApplication_person_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/Application'
import {Application_application_MonitorApplication_person_phoneNumbers as Application_application_MonitorApplication_person_phoneNumbersOrig} from '../types/Application'
import {Application_application_MonitorApplication_person_phoneNumbers_esignSession as Application_application_MonitorApplication_person_phoneNumbers_esignSessionOrig} from '../types/Application'
import {Application_application_MonitorApplication_person_phoneNumbers_esignSession_esignWizards as Application_application_MonitorApplication_person_phoneNumbers_esignSession_esignWizardsOrig} from '../types/Application'
import {deserializeMcdSubtype} from 'graphql/converters'
import {serializeMcdSubtype} from 'graphql/converters'
import {deserializeMcdType} from 'graphql/converters'
import {serializeMcdType} from 'graphql/converters'
import {Application_application_MedicaidApplication as Application_application_MedicaidApplicationOrig} from '../types/Application'
import {Application_application_MedicaidApplication_primaryPointOfContact as Application_application_MedicaidApplication_primaryPointOfContactOrig} from '../types/Application'
import {Application_application_MedicaidApplication_primaryPointOfContact_deductions as Application_application_MedicaidApplication_primaryPointOfContact_deductionsOrig} from '../types/Application'
import {Application_application_MedicaidApplication_primaryPointOfContact_incomeSources as Application_application_MedicaidApplication_primaryPointOfContact_incomeSourcesOrig} from '../types/Application'
import {Application_application_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession as Application_application_MedicaidApplication_primaryPointOfContact_incomeSources_esignSessionOrig} from '../types/Application'
import {Application_application_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession_esignWizards as Application_application_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession_esignWizardsOrig} from '../types/Application'
import {Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes as Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomesOrig} from '../types/Application'
import {Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application as Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_applicationOrig} from '../types/Application'
import {Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplication as Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplicationOrig} from '../types/Application'
import {Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplication as Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/Application'
import {Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplication as Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/Application'
import {Application_application_MedicaidApplication_primaryPointOfContact_phoneNumbers as Application_application_MedicaidApplication_primaryPointOfContact_phoneNumbersOrig} from '../types/Application'
import {Application_application_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession as Application_application_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSessionOrig} from '../types/Application'
import {Application_application_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizards as Application_application_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizardsOrig} from '../types/Application'
import {deserializeNjmmisCheckResult} from 'graphql/converters'
import {serializeNjmmisCheckResult} from 'graphql/converters'
import {Application_application_MedicaidApplication_accountOnDateOfService as Application_application_MedicaidApplication_accountOnDateOfServiceOrig} from '../types/Application'
import {Application_application_MedicaidApplication_benefitOutcomes as Application_application_MedicaidApplication_benefitOutcomesOrig} from '../types/Application'
import {Application_application_MedicaidApplication_benefitOutcomes_application as Application_application_MedicaidApplication_benefitOutcomes_applicationOrig} from '../types/Application'
import {Application_application_MedicaidApplication_benefitOutcomes_person as Application_application_MedicaidApplication_benefitOutcomes_personOrig} from '../types/Application'
import {Application_application_MedicaidApplication_documentFiles as Application_application_MedicaidApplication_documentFilesOrig} from '../types/Application'
import {Application_application_MedicaidApplication_documentFiles_documents as Application_application_MedicaidApplication_documentFiles_documentsOrig} from '../types/Application'
import {Application_application_MedicaidApplication_documents as Application_application_MedicaidApplication_documentsOrig} from '../types/Application'
import {Application_application_MedicaidApplication_documents_application as Application_application_MedicaidApplication_documents_applicationOrig} from '../types/Application'
import {Application_application_MedicaidApplication_documents_person as Application_application_MedicaidApplication_documents_personOrig} from '../types/Application'
import {Application_application_MedicaidApplication_documents_files as Application_application_MedicaidApplication_documents_filesOrig} from '../types/Application'
import {Application_application_MedicaidApplication_householdMembers as Application_application_MedicaidApplication_householdMembersOrig} from '../types/Application'
import {Application_application_MedicaidApplication_householdMembers_person as Application_application_MedicaidApplication_householdMembers_personOrig} from '../types/Application'
import {Application_application_MedicaidApplication_householdMembers_person_documentFiles as Application_application_MedicaidApplication_householdMembers_person_documentFilesOrig} from '../types/Application'
import {Application_application_MedicaidApplication_householdMembers_person_deductions as Application_application_MedicaidApplication_householdMembers_person_deductionsOrig} from '../types/Application'
import {Application_application_MedicaidApplication_householdMembers_person_incomeSources as Application_application_MedicaidApplication_householdMembers_person_incomeSourcesOrig} from '../types/Application'
import {Application_application_MedicaidApplication_householdMembers_person_incomeSources_esignSession as Application_application_MedicaidApplication_householdMembers_person_incomeSources_esignSessionOrig} from '../types/Application'
import {Application_application_MedicaidApplication_householdMembers_person_incomeSources_esignSession_esignWizards as Application_application_MedicaidApplication_householdMembers_person_incomeSources_esignSession_esignWizardsOrig} from '../types/Application'
import {Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes as Application_application_MedicaidApplication_householdMembers_person_benefitOutcomesOrig} from '../types/Application'
import {Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application as Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes_applicationOrig} from '../types/Application'
import {Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application_SlideApplication as Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application_SlideApplicationOrig} from '../types/Application'
import {Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication as Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/Application'
import {Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication as Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/Application'
import {Application_application_MedicaidApplication_householdMembers_person_phoneNumbers as Application_application_MedicaidApplication_householdMembers_person_phoneNumbersOrig} from '../types/Application'
import {Application_application_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession as Application_application_MedicaidApplication_householdMembers_person_phoneNumbers_esignSessionOrig} from '../types/Application'
import {Application_application_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards as Application_application_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession_esignWizardsOrig} from '../types/Application'
import {Application_application_MedicaidApplication_assignedTo as Application_application_MedicaidApplication_assignedToOrig} from '../types/Application'
import {Application_application_MedicaidApplication_person as Application_application_MedicaidApplication_personOrig} from '../types/Application'
import {Application_application_MedicaidApplication_person_openHouseholdMemberApplications as Application_application_MedicaidApplication_person_openHouseholdMemberApplicationsOrig} from '../types/Application'
import {Application_application_MedicaidApplication_person_openApplications as Application_application_MedicaidApplication_person_openApplicationsOrig} from '../types/Application'
import {Application_application_MedicaidApplication_person_openApplications_RyanWhiteApplication as Application_application_MedicaidApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/Application'
import {Application_application_MedicaidApplication_person_openApplications_SlideApplication as Application_application_MedicaidApplication_person_openApplications_SlideApplicationOrig} from '../types/Application'
import {Application_application_MedicaidApplication_person_openApplications_CharityCareApplication as Application_application_MedicaidApplication_person_openApplications_CharityCareApplicationOrig} from '../types/Application'
import {BenefitType} from 'utils/benefits'
import {deserializeBenefit} from 'graphql/converters'
import {serializeBenefit} from 'graphql/converters'
import {Application_application_MedicaidApplication_person_openApplications_MedicaidApplication as Application_application_MedicaidApplication_person_openApplications_MedicaidApplicationOrig} from '../types/Application'
import {Application_application_MedicaidApplication_person_documentFiles as Application_application_MedicaidApplication_person_documentFilesOrig} from '../types/Application'
import {Application_application_MedicaidApplication_person_relationships as Application_application_MedicaidApplication_person_relationshipsOrig} from '../types/Application'
import {Application_application_MedicaidApplication_person_relationships_otherPerson as Application_application_MedicaidApplication_person_relationships_otherPersonOrig} from '../types/Application'
import {Application_application_MedicaidApplication_person_relationships_otherPerson_deductions as Application_application_MedicaidApplication_person_relationships_otherPerson_deductionsOrig} from '../types/Application'
import {Application_application_MedicaidApplication_person_relationships_otherPerson_incomeSources as Application_application_MedicaidApplication_person_relationships_otherPerson_incomeSourcesOrig} from '../types/Application'
import {Application_application_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession as Application_application_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSessionOrig} from '../types/Application'
import {Application_application_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards as Application_application_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizardsOrig} from '../types/Application'
import {Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes as Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomesOrig} from '../types/Application'
import {Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application as Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_applicationOrig} from '../types/Application'
import {Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication as Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplicationOrig} from '../types/Application'
import {Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication as Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/Application'
import {Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication as Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/Application'
import {Application_application_MedicaidApplication_person_relationships_otherPerson_phoneNumbers as Application_application_MedicaidApplication_person_relationships_otherPerson_phoneNumbersOrig} from '../types/Application'
import {Application_application_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession as Application_application_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSessionOrig} from '../types/Application'
import {Application_application_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards as Application_application_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizardsOrig} from '../types/Application'
import {Application_application_MedicaidApplication_person_deductions as Application_application_MedicaidApplication_person_deductionsOrig} from '../types/Application'
import {Application_application_MedicaidApplication_person_incomeSources as Application_application_MedicaidApplication_person_incomeSourcesOrig} from '../types/Application'
import {Application_application_MedicaidApplication_person_incomeSources_esignSession as Application_application_MedicaidApplication_person_incomeSources_esignSessionOrig} from '../types/Application'
import {Application_application_MedicaidApplication_person_incomeSources_esignSession_esignWizards as Application_application_MedicaidApplication_person_incomeSources_esignSession_esignWizardsOrig} from '../types/Application'
import {formatISODate} from 'utils/date'
import {Application_application_MedicaidApplication_person_benefitOutcomes as Application_application_MedicaidApplication_person_benefitOutcomesOrig} from '../types/Application'
import {Application_application_MedicaidApplication_person_benefitOutcomes_application as Application_application_MedicaidApplication_person_benefitOutcomes_applicationOrig} from '../types/Application'
import {deserializeSlideType} from 'graphql/converters'
import {serializeSlideType} from 'graphql/converters'
import {Application_application_MedicaidApplication_person_benefitOutcomes_application_SlideApplication as Application_application_MedicaidApplication_person_benefitOutcomes_application_SlideApplicationOrig} from '../types/Application'
import {Application_application_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplication as Application_application_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/Application'
import {Application_application_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplication as Application_application_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/Application'
import {Application_application_MedicaidApplication_person_phoneNumbers as Application_application_MedicaidApplication_person_phoneNumbersOrig} from '../types/Application'
import {Application_application_MedicaidApplication_person_phoneNumbers_esignSession as Application_application_MedicaidApplication_person_phoneNumbers_esignSessionOrig} from '../types/Application'
import {parseDate} from 'utils/form/fieldTypes'
import formatISO from 'date-fns/formatISO'
import {Application_application_MedicaidApplication_person_phoneNumbers_esignSession_esignWizards as Application_application_MedicaidApplication_person_phoneNumbers_esignSession_esignWizardsOrig} from '../types/Application'
export interface Application_application_MedicaidApplication_person_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeApplication_application_MedicaidApplication_person_phoneNumbers_esignSession_esignWizards = (
  serialized: Application_application_MedicaidApplication_person_phoneNumbers_esignSession_esignWizardsOrig
): Application_application_MedicaidApplication_person_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeApplication_application_MedicaidApplication_person_phoneNumbers_esignSession_esignWizards = (
  deserialized: Application_application_MedicaidApplication_person_phoneNumbers_esignSession_esignWizards
): Application_application_MedicaidApplication_person_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Application_application_MedicaidApplication_person_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Application_application_MedicaidApplication_person_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeApplication_application_MedicaidApplication_person_phoneNumbers_esignSession = (
  serialized: Application_application_MedicaidApplication_person_phoneNumbers_esignSessionOrig
): Application_application_MedicaidApplication_person_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeApplication_application_MedicaidApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeApplication_application_MedicaidApplication_person_phoneNumbers_esignSession = (
  deserialized: Application_application_MedicaidApplication_person_phoneNumbers_esignSession
): Application_application_MedicaidApplication_person_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeApplication_application_MedicaidApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export interface Application_application_MedicaidApplication_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: Application_application_MedicaidApplication_person_phoneNumbers_esignSession | null
}
export const deserializeApplication_application_MedicaidApplication_person_phoneNumbers = (
  serialized: Application_application_MedicaidApplication_person_phoneNumbersOrig
): Application_application_MedicaidApplication_person_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeApplication_application_MedicaidApplication_person_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeApplication_application_MedicaidApplication_person_phoneNumbers = (
  deserialized: Application_application_MedicaidApplication_person_phoneNumbers
): Application_application_MedicaidApplication_person_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeApplication_application_MedicaidApplication_person_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Application_application_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeApplication_application_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplication = (
  serialized: Application_application_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplicationOrig
): Application_application_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeApplication_application_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplication = (
  deserialized: Application_application_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplication
): Application_application_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface Application_application_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeApplication_application_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplication = (
  serialized: Application_application_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplicationOrig
): Application_application_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeApplication_application_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplication = (
  deserialized: Application_application_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplication
): Application_application_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface Application_application_MedicaidApplication_person_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeApplication_application_MedicaidApplication_person_benefitOutcomes_application_SlideApplication = (
  serialized: Application_application_MedicaidApplication_person_benefitOutcomes_application_SlideApplicationOrig
): Application_application_MedicaidApplication_person_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeApplication_application_MedicaidApplication_person_benefitOutcomes_application_SlideApplication = (
  deserialized: Application_application_MedicaidApplication_person_benefitOutcomes_application_SlideApplication
): Application_application_MedicaidApplication_person_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type Application_application_MedicaidApplication_person_benefitOutcomes_application =
  | Application_application_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplication
  | Application_application_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplication
  | Application_application_MedicaidApplication_person_benefitOutcomes_application_SlideApplication
export const deserializeApplication_application_MedicaidApplication_person_benefitOutcomes_application = (
  serialized: Application_application_MedicaidApplication_person_benefitOutcomes_applicationOrig
): Application_application_MedicaidApplication_person_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeApplication_application_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeApplication_application_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeApplication_application_MedicaidApplication_person_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Application_application_MedicaidApplication_person_benefitOutcomes_application'
  )
}
export const serializeApplication_application_MedicaidApplication_person_benefitOutcomes_application = (
  deserialized: Application_application_MedicaidApplication_person_benefitOutcomes_application
): Application_application_MedicaidApplication_person_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeApplication_application_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeApplication_application_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeApplication_application_MedicaidApplication_person_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Application_application_MedicaidApplication_person_benefitOutcomes_application'
  )
}
export interface Application_application_MedicaidApplication_person_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: Application_application_MedicaidApplication_person_benefitOutcomes_application | null
}
export const deserializeApplication_application_MedicaidApplication_person_benefitOutcomes = (
  serialized: Application_application_MedicaidApplication_person_benefitOutcomesOrig
): Application_application_MedicaidApplication_person_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeApplication_application_MedicaidApplication_person_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeApplication_application_MedicaidApplication_person_benefitOutcomes = (
  deserialized: Application_application_MedicaidApplication_person_benefitOutcomes
): Application_application_MedicaidApplication_person_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeApplication_application_MedicaidApplication_person_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface Application_application_MedicaidApplication_person_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeApplication_application_MedicaidApplication_person_incomeSources_esignSession_esignWizards = (
  serialized: Application_application_MedicaidApplication_person_incomeSources_esignSession_esignWizardsOrig
): Application_application_MedicaidApplication_person_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeApplication_application_MedicaidApplication_person_incomeSources_esignSession_esignWizards = (
  deserialized: Application_application_MedicaidApplication_person_incomeSources_esignSession_esignWizards
): Application_application_MedicaidApplication_person_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Application_application_MedicaidApplication_person_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Application_application_MedicaidApplication_person_incomeSources_esignSession_esignWizards[]
}
export const deserializeApplication_application_MedicaidApplication_person_incomeSources_esignSession = (
  serialized: Application_application_MedicaidApplication_person_incomeSources_esignSessionOrig
): Application_application_MedicaidApplication_person_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeApplication_application_MedicaidApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export const serializeApplication_application_MedicaidApplication_person_incomeSources_esignSession = (
  deserialized: Application_application_MedicaidApplication_person_incomeSources_esignSession
): Application_application_MedicaidApplication_person_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeApplication_application_MedicaidApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export interface Application_application_MedicaidApplication_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: Application_application_MedicaidApplication_person_incomeSources_esignSession | null
}
export const deserializeApplication_application_MedicaidApplication_person_incomeSources = (
  serialized: Application_application_MedicaidApplication_person_incomeSourcesOrig
): Application_application_MedicaidApplication_person_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeApplication_application_MedicaidApplication_person_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeApplication_application_MedicaidApplication_person_incomeSources = (
  deserialized: Application_application_MedicaidApplication_person_incomeSources
): Application_application_MedicaidApplication_person_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeApplication_application_MedicaidApplication_person_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Application_application_MedicaidApplication_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeApplication_application_MedicaidApplication_person_deductions = (
  serialized: Application_application_MedicaidApplication_person_deductionsOrig
): Application_application_MedicaidApplication_person_deductions => ({
  ...serialized,
})
export const serializeApplication_application_MedicaidApplication_person_deductions = (
  deserialized: Application_application_MedicaidApplication_person_deductions
): Application_application_MedicaidApplication_person_deductionsOrig => ({
  ...deserialized,
})
export interface Application_application_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeApplication_application_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards = (
  serialized: Application_application_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizardsOrig
): Application_application_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeApplication_application_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards = (
  deserialized: Application_application_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards
): Application_application_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Application_application_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Application_application_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeApplication_application_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession = (
  serialized: Application_application_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSessionOrig
): Application_application_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeApplication_application_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeApplication_application_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession = (
  deserialized: Application_application_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession
): Application_application_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeApplication_application_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards
  ),
})
export interface Application_application_MedicaidApplication_person_relationships_otherPerson_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: Application_application_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession | null
}
export const deserializeApplication_application_MedicaidApplication_person_relationships_otherPerson_phoneNumbers = (
  serialized: Application_application_MedicaidApplication_person_relationships_otherPerson_phoneNumbersOrig
): Application_application_MedicaidApplication_person_relationships_otherPerson_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeApplication_application_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeApplication_application_MedicaidApplication_person_relationships_otherPerson_phoneNumbers = (
  deserialized: Application_application_MedicaidApplication_person_relationships_otherPerson_phoneNumbers
): Application_application_MedicaidApplication_person_relationships_otherPerson_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeApplication_application_MedicaidApplication_person_relationships_otherPerson_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeApplication_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication = (
  serialized: Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplicationOrig
): Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeApplication_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication = (
  deserialized: Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication
): Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeApplication_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication = (
  serialized: Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplicationOrig
): Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeApplication_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication = (
  deserialized: Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication
): Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeApplication_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication = (
  serialized: Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplicationOrig
): Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeApplication_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication = (
  deserialized: Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication
): Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application =
  | Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication
  | Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication
  | Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication
export const deserializeApplication_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application = (
  serialized: Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_applicationOrig
): Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeApplication_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeApplication_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeApplication_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application'
  )
}
export const serializeApplication_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application = (
  deserialized: Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application
): Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeApplication_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeApplication_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeApplication_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application'
  )
}
export interface Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application | null
}
export const deserializeApplication_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes = (
  serialized: Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomesOrig
): Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeApplication_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeApplication_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes = (
  deserialized: Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes
): Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeApplication_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface Application_application_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeApplication_application_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards = (
  serialized: Application_application_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizardsOrig
): Application_application_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeApplication_application_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards = (
  deserialized: Application_application_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards
): Application_application_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Application_application_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Application_application_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards[]
}
export const deserializeApplication_application_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession = (
  serialized: Application_application_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSessionOrig
): Application_application_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeApplication_application_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards
  ),
})
export const serializeApplication_application_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession = (
  deserialized: Application_application_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession
): Application_application_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeApplication_application_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards
  ),
})
export interface Application_application_MedicaidApplication_person_relationships_otherPerson_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: Application_application_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession | null
}
export const deserializeApplication_application_MedicaidApplication_person_relationships_otherPerson_incomeSources = (
  serialized: Application_application_MedicaidApplication_person_relationships_otherPerson_incomeSourcesOrig
): Application_application_MedicaidApplication_person_relationships_otherPerson_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeApplication_application_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeApplication_application_MedicaidApplication_person_relationships_otherPerson_incomeSources = (
  deserialized: Application_application_MedicaidApplication_person_relationships_otherPerson_incomeSources
): Application_application_MedicaidApplication_person_relationships_otherPerson_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeApplication_application_MedicaidApplication_person_relationships_otherPerson_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Application_application_MedicaidApplication_person_relationships_otherPerson_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeApplication_application_MedicaidApplication_person_relationships_otherPerson_deductions = (
  serialized: Application_application_MedicaidApplication_person_relationships_otherPerson_deductionsOrig
): Application_application_MedicaidApplication_person_relationships_otherPerson_deductions => ({
  ...serialized,
})
export const serializeApplication_application_MedicaidApplication_person_relationships_otherPerson_deductions = (
  deserialized: Application_application_MedicaidApplication_person_relationships_otherPerson_deductions
): Application_application_MedicaidApplication_person_relationships_otherPerson_deductionsOrig => ({
  ...deserialized,
})
export interface Application_application_MedicaidApplication_person_relationships_otherPerson {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: Application_application_MedicaidApplication_person_relationships_otherPerson_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: Application_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes[]
  incomeSources: Application_application_MedicaidApplication_person_relationships_otherPerson_incomeSources[]
  deductions: Application_application_MedicaidApplication_person_relationships_otherPerson_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
}
export const deserializeApplication_application_MedicaidApplication_person_relationships_otherPerson = (
  serialized: Application_application_MedicaidApplication_person_relationships_otherPersonOrig
): Application_application_MedicaidApplication_person_relationships_otherPerson => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeApplication_application_MedicaidApplication_person_relationships_otherPerson_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeApplication_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeApplication_application_MedicaidApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeApplication_application_MedicaidApplication_person_relationships_otherPerson_deductions
  ),
})
export const serializeApplication_application_MedicaidApplication_person_relationships_otherPerson = (
  deserialized: Application_application_MedicaidApplication_person_relationships_otherPerson
): Application_application_MedicaidApplication_person_relationships_otherPersonOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeApplication_application_MedicaidApplication_person_relationships_otherPerson_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeApplication_application_MedicaidApplication_person_relationships_otherPerson_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeApplication_application_MedicaidApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeApplication_application_MedicaidApplication_person_relationships_otherPerson_deductions
  ),
})
export interface Application_application_MedicaidApplication_person_relationships {
  __typename: 'Relationship'
  id: string
  relationshipType: string | null
  reverseRelationshipType: string | null
  liveTogether: boolean | null
  otherPerson: Application_application_MedicaidApplication_person_relationships_otherPerson
}
export const deserializeApplication_application_MedicaidApplication_person_relationships = (
  serialized: Application_application_MedicaidApplication_person_relationshipsOrig
): Application_application_MedicaidApplication_person_relationships => ({
  ...serialized,
  otherPerson: deserializeApplication_application_MedicaidApplication_person_relationships_otherPerson(
    serialized.otherPerson
  ),
})
export const serializeApplication_application_MedicaidApplication_person_relationships = (
  deserialized: Application_application_MedicaidApplication_person_relationships
): Application_application_MedicaidApplication_person_relationshipsOrig => ({
  ...deserialized,
  otherPerson: serializeApplication_application_MedicaidApplication_person_relationships_otherPerson(
    deserialized.otherPerson
  ),
})
export interface Application_application_MedicaidApplication_person_documentFiles {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeApplication_application_MedicaidApplication_person_documentFiles = (
  serialized: Application_application_MedicaidApplication_person_documentFilesOrig
): Application_application_MedicaidApplication_person_documentFiles => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeApplication_application_MedicaidApplication_person_documentFiles = (
  deserialized: Application_application_MedicaidApplication_person_documentFiles
): Application_application_MedicaidApplication_person_documentFilesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface Application_application_MedicaidApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializeApplication_application_MedicaidApplication_person_openApplications_MedicaidApplication = (
  serialized: Application_application_MedicaidApplication_person_openApplications_MedicaidApplicationOrig
): Application_application_MedicaidApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeApplication_application_MedicaidApplication_person_openApplications_MedicaidApplication = (
  deserialized: Application_application_MedicaidApplication_person_openApplications_MedicaidApplication
): Application_application_MedicaidApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Application_application_MedicaidApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeApplication_application_MedicaidApplication_person_openApplications_CharityCareApplication = (
  serialized: Application_application_MedicaidApplication_person_openApplications_CharityCareApplicationOrig
): Application_application_MedicaidApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeApplication_application_MedicaidApplication_person_openApplications_CharityCareApplication = (
  deserialized: Application_application_MedicaidApplication_person_openApplications_CharityCareApplication
): Application_application_MedicaidApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Application_application_MedicaidApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeApplication_application_MedicaidApplication_person_openApplications_SlideApplication = (
  serialized: Application_application_MedicaidApplication_person_openApplications_SlideApplicationOrig
): Application_application_MedicaidApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeApplication_application_MedicaidApplication_person_openApplications_SlideApplication = (
  deserialized: Application_application_MedicaidApplication_person_openApplications_SlideApplication
): Application_application_MedicaidApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Application_application_MedicaidApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeApplication_application_MedicaidApplication_person_openApplications_RyanWhiteApplication = (
  serialized: Application_application_MedicaidApplication_person_openApplications_RyanWhiteApplicationOrig
): Application_application_MedicaidApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeApplication_application_MedicaidApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: Application_application_MedicaidApplication_person_openApplications_RyanWhiteApplication
): Application_application_MedicaidApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type Application_application_MedicaidApplication_person_openApplications =
  | Application_application_MedicaidApplication_person_openApplications_MedicaidApplication
  | Application_application_MedicaidApplication_person_openApplications_CharityCareApplication
  | Application_application_MedicaidApplication_person_openApplications_SlideApplication
  | Application_application_MedicaidApplication_person_openApplications_RyanWhiteApplication
export const deserializeApplication_application_MedicaidApplication_person_openApplications = (
  serialized: Application_application_MedicaidApplication_person_openApplicationsOrig
): Application_application_MedicaidApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializeApplication_application_MedicaidApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeApplication_application_MedicaidApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeApplication_application_MedicaidApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeApplication_application_MedicaidApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Application_application_MedicaidApplication_person_openApplications'
  )
}
export const serializeApplication_application_MedicaidApplication_person_openApplications = (
  deserialized: Application_application_MedicaidApplication_person_openApplications
): Application_application_MedicaidApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializeApplication_application_MedicaidApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeApplication_application_MedicaidApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeApplication_application_MedicaidApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeApplication_application_MedicaidApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Application_application_MedicaidApplication_person_openApplications'
  )
}
export interface Application_application_MedicaidApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializeApplication_application_MedicaidApplication_person_openHouseholdMemberApplications = (
  serialized: Application_application_MedicaidApplication_person_openHouseholdMemberApplicationsOrig
): Application_application_MedicaidApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeApplication_application_MedicaidApplication_person_openHouseholdMemberApplications = (
  deserialized: Application_application_MedicaidApplication_person_openHouseholdMemberApplications
): Application_application_MedicaidApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Application_application_MedicaidApplication_person {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: Application_application_MedicaidApplication_person_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: Application_application_MedicaidApplication_person_benefitOutcomes[]
  incomeSources: Application_application_MedicaidApplication_person_incomeSources[]
  deductions: Application_application_MedicaidApplication_person_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
  relationships: Application_application_MedicaidApplication_person_relationships[]
  documentFiles: Application_application_MedicaidApplication_person_documentFiles[]
  openApplications: Application_application_MedicaidApplication_person_openApplications[]
  openHouseholdMemberApplications: Application_application_MedicaidApplication_person_openHouseholdMemberApplications[]
}
export const deserializeApplication_application_MedicaidApplication_person = (
  serialized: Application_application_MedicaidApplication_personOrig
): Application_application_MedicaidApplication_person => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeApplication_application_MedicaidApplication_person_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeApplication_application_MedicaidApplication_person_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeApplication_application_MedicaidApplication_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeApplication_application_MedicaidApplication_person_deductions
  ),
  relationships: serialized.relationships.map(
    deserializeApplication_application_MedicaidApplication_person_relationships
  ),
  documentFiles: serialized.documentFiles.map(
    deserializeApplication_application_MedicaidApplication_person_documentFiles
  ),
  openApplications: serialized.openApplications.map(
    deserializeApplication_application_MedicaidApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializeApplication_application_MedicaidApplication_person_openHouseholdMemberApplications
  ),
})
export const serializeApplication_application_MedicaidApplication_person = (
  deserialized: Application_application_MedicaidApplication_person
): Application_application_MedicaidApplication_personOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeApplication_application_MedicaidApplication_person_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeApplication_application_MedicaidApplication_person_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeApplication_application_MedicaidApplication_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeApplication_application_MedicaidApplication_person_deductions
  ),
  relationships: deserialized.relationships.map(
    serializeApplication_application_MedicaidApplication_person_relationships
  ),
  documentFiles: deserialized.documentFiles.map(
    serializeApplication_application_MedicaidApplication_person_documentFiles
  ),
  openApplications: deserialized.openApplications.map(
    serializeApplication_application_MedicaidApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializeApplication_application_MedicaidApplication_person_openHouseholdMemberApplications
  ),
})
export interface Application_application_MedicaidApplication_assignedTo {
  __typename: 'User'
  id: string
  email: string
  name: string | null
  isCurrentUser: boolean
}
export const deserializeApplication_application_MedicaidApplication_assignedTo = (
  serialized: Application_application_MedicaidApplication_assignedToOrig
): Application_application_MedicaidApplication_assignedTo => ({...serialized})
export const serializeApplication_application_MedicaidApplication_assignedTo = (
  deserialized: Application_application_MedicaidApplication_assignedTo
): Application_application_MedicaidApplication_assignedToOrig => ({
  ...deserialized,
})
export interface Application_application_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeApplication_application_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards = (
  serialized: Application_application_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession_esignWizardsOrig
): Application_application_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeApplication_application_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards = (
  deserialized: Application_application_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards
): Application_application_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Application_application_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Application_application_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeApplication_application_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession = (
  serialized: Application_application_MedicaidApplication_householdMembers_person_phoneNumbers_esignSessionOrig
): Application_application_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeApplication_application_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeApplication_application_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession = (
  deserialized: Application_application_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession
): Application_application_MedicaidApplication_householdMembers_person_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeApplication_application_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards
  ),
})
export interface Application_application_MedicaidApplication_householdMembers_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: Application_application_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession | null
}
export const deserializeApplication_application_MedicaidApplication_householdMembers_person_phoneNumbers = (
  serialized: Application_application_MedicaidApplication_householdMembers_person_phoneNumbersOrig
): Application_application_MedicaidApplication_householdMembers_person_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeApplication_application_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeApplication_application_MedicaidApplication_householdMembers_person_phoneNumbers = (
  deserialized: Application_application_MedicaidApplication_householdMembers_person_phoneNumbers
): Application_application_MedicaidApplication_householdMembers_person_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeApplication_application_MedicaidApplication_householdMembers_person_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeApplication_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication = (
  serialized: Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplicationOrig
): Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeApplication_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication = (
  deserialized: Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication
): Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeApplication_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication = (
  serialized: Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplicationOrig
): Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeApplication_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication = (
  deserialized: Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication
): Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeApplication_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application_SlideApplication = (
  serialized: Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application_SlideApplicationOrig
): Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeApplication_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application_SlideApplication = (
  deserialized: Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application_SlideApplication
): Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application =
  | Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication
  | Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication
  | Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application_SlideApplication
export const deserializeApplication_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application = (
  serialized: Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes_applicationOrig
): Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeApplication_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeApplication_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeApplication_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application'
  )
}
export const serializeApplication_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application = (
  deserialized: Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application
): Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeApplication_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeApplication_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeApplication_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application'
  )
}
export interface Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application | null
}
export const deserializeApplication_application_MedicaidApplication_householdMembers_person_benefitOutcomes = (
  serialized: Application_application_MedicaidApplication_householdMembers_person_benefitOutcomesOrig
): Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeApplication_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeApplication_application_MedicaidApplication_householdMembers_person_benefitOutcomes = (
  deserialized: Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes
): Application_application_MedicaidApplication_householdMembers_person_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeApplication_application_MedicaidApplication_householdMembers_person_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface Application_application_MedicaidApplication_householdMembers_person_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeApplication_application_MedicaidApplication_householdMembers_person_incomeSources_esignSession_esignWizards = (
  serialized: Application_application_MedicaidApplication_householdMembers_person_incomeSources_esignSession_esignWizardsOrig
): Application_application_MedicaidApplication_householdMembers_person_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeApplication_application_MedicaidApplication_householdMembers_person_incomeSources_esignSession_esignWizards = (
  deserialized: Application_application_MedicaidApplication_householdMembers_person_incomeSources_esignSession_esignWizards
): Application_application_MedicaidApplication_householdMembers_person_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Application_application_MedicaidApplication_householdMembers_person_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Application_application_MedicaidApplication_householdMembers_person_incomeSources_esignSession_esignWizards[]
}
export const deserializeApplication_application_MedicaidApplication_householdMembers_person_incomeSources_esignSession = (
  serialized: Application_application_MedicaidApplication_householdMembers_person_incomeSources_esignSessionOrig
): Application_application_MedicaidApplication_householdMembers_person_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeApplication_application_MedicaidApplication_householdMembers_person_incomeSources_esignSession_esignWizards
  ),
})
export const serializeApplication_application_MedicaidApplication_householdMembers_person_incomeSources_esignSession = (
  deserialized: Application_application_MedicaidApplication_householdMembers_person_incomeSources_esignSession
): Application_application_MedicaidApplication_householdMembers_person_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeApplication_application_MedicaidApplication_householdMembers_person_incomeSources_esignSession_esignWizards
  ),
})
export interface Application_application_MedicaidApplication_householdMembers_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: Application_application_MedicaidApplication_householdMembers_person_incomeSources_esignSession | null
}
export const deserializeApplication_application_MedicaidApplication_householdMembers_person_incomeSources = (
  serialized: Application_application_MedicaidApplication_householdMembers_person_incomeSourcesOrig
): Application_application_MedicaidApplication_householdMembers_person_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeApplication_application_MedicaidApplication_householdMembers_person_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeApplication_application_MedicaidApplication_householdMembers_person_incomeSources = (
  deserialized: Application_application_MedicaidApplication_householdMembers_person_incomeSources
): Application_application_MedicaidApplication_householdMembers_person_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeApplication_application_MedicaidApplication_householdMembers_person_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Application_application_MedicaidApplication_householdMembers_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeApplication_application_MedicaidApplication_householdMembers_person_deductions = (
  serialized: Application_application_MedicaidApplication_householdMembers_person_deductionsOrig
): Application_application_MedicaidApplication_householdMembers_person_deductions => ({
  ...serialized,
})
export const serializeApplication_application_MedicaidApplication_householdMembers_person_deductions = (
  deserialized: Application_application_MedicaidApplication_householdMembers_person_deductions
): Application_application_MedicaidApplication_householdMembers_person_deductionsOrig => ({
  ...deserialized,
})
export interface Application_application_MedicaidApplication_householdMembers_person_documentFiles {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeApplication_application_MedicaidApplication_householdMembers_person_documentFiles = (
  serialized: Application_application_MedicaidApplication_householdMembers_person_documentFilesOrig
): Application_application_MedicaidApplication_householdMembers_person_documentFiles => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeApplication_application_MedicaidApplication_householdMembers_person_documentFiles = (
  deserialized: Application_application_MedicaidApplication_householdMembers_person_documentFiles
): Application_application_MedicaidApplication_householdMembers_person_documentFilesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface Application_application_MedicaidApplication_householdMembers_person {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: Application_application_MedicaidApplication_householdMembers_person_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: Application_application_MedicaidApplication_householdMembers_person_benefitOutcomes[]
  incomeSources: Application_application_MedicaidApplication_householdMembers_person_incomeSources[]
  deductions: Application_application_MedicaidApplication_householdMembers_person_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
  documentFiles: Application_application_MedicaidApplication_householdMembers_person_documentFiles[]
}
export const deserializeApplication_application_MedicaidApplication_householdMembers_person = (
  serialized: Application_application_MedicaidApplication_householdMembers_personOrig
): Application_application_MedicaidApplication_householdMembers_person => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeApplication_application_MedicaidApplication_householdMembers_person_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeApplication_application_MedicaidApplication_householdMembers_person_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeApplication_application_MedicaidApplication_householdMembers_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeApplication_application_MedicaidApplication_householdMembers_person_deductions
  ),
  documentFiles: serialized.documentFiles.map(
    deserializeApplication_application_MedicaidApplication_householdMembers_person_documentFiles
  ),
})
export const serializeApplication_application_MedicaidApplication_householdMembers_person = (
  deserialized: Application_application_MedicaidApplication_householdMembers_person
): Application_application_MedicaidApplication_householdMembers_personOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeApplication_application_MedicaidApplication_householdMembers_person_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeApplication_application_MedicaidApplication_householdMembers_person_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeApplication_application_MedicaidApplication_householdMembers_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeApplication_application_MedicaidApplication_householdMembers_person_deductions
  ),
  documentFiles: deserialized.documentFiles.map(
    serializeApplication_application_MedicaidApplication_householdMembers_person_documentFiles
  ),
})
export interface Application_application_MedicaidApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  wantsCoverage: boolean | null
  person: Application_application_MedicaidApplication_householdMembers_person
  createdAt: Date
}
export const deserializeApplication_application_MedicaidApplication_householdMembers = (
  serialized: Application_application_MedicaidApplication_householdMembersOrig
): Application_application_MedicaidApplication_householdMembers => ({
  ...serialized,
  person: deserializeApplication_application_MedicaidApplication_householdMembers_person(
    serialized.person
  ),
  createdAt: parseDate(serialized.createdAt),
})
export const serializeApplication_application_MedicaidApplication_householdMembers = (
  deserialized: Application_application_MedicaidApplication_householdMembers
): Application_application_MedicaidApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializeApplication_application_MedicaidApplication_householdMembers_person(
    deserialized.person
  ),
  createdAt: formatISO(deserialized.createdAt),
})
export interface Application_application_MedicaidApplication_documents_files {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeApplication_application_MedicaidApplication_documents_files = (
  serialized: Application_application_MedicaidApplication_documents_filesOrig
): Application_application_MedicaidApplication_documents_files => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeApplication_application_MedicaidApplication_documents_files = (
  deserialized: Application_application_MedicaidApplication_documents_files
): Application_application_MedicaidApplication_documents_filesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface Application_application_MedicaidApplication_documents_person {
  __typename: 'Person'
  id: string
}
export const deserializeApplication_application_MedicaidApplication_documents_person = (
  serialized: Application_application_MedicaidApplication_documents_personOrig
): Application_application_MedicaidApplication_documents_person => ({
  ...serialized,
})
export const serializeApplication_application_MedicaidApplication_documents_person = (
  deserialized: Application_application_MedicaidApplication_documents_person
): Application_application_MedicaidApplication_documents_personOrig => ({
  ...deserialized,
})
export interface Application_application_MedicaidApplication_documents_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializeApplication_application_MedicaidApplication_documents_application = (
  serialized: Application_application_MedicaidApplication_documents_applicationOrig
): Application_application_MedicaidApplication_documents_application => ({
  ...serialized,
})
export const serializeApplication_application_MedicaidApplication_documents_application = (
  deserialized: Application_application_MedicaidApplication_documents_application
): Application_application_MedicaidApplication_documents_applicationOrig => ({
  ...deserialized,
})
export interface Application_application_MedicaidApplication_documents {
  __typename: 'Document'
  id: string
  documentType: string
  complete: boolean | null
  files: Application_application_MedicaidApplication_documents_files[]
  updatedAt: Date
  notes: string | null
  person: Application_application_MedicaidApplication_documents_person | null
  application: Application_application_MedicaidApplication_documents_application
}
export const deserializeApplication_application_MedicaidApplication_documents = (
  serialized: Application_application_MedicaidApplication_documentsOrig
): Application_application_MedicaidApplication_documents => ({
  ...serialized,
  files: serialized.files.map(
    deserializeApplication_application_MedicaidApplication_documents_files
  ),
  updatedAt: parseDate(serialized.updatedAt),
  person:
    serialized.person != null
      ? deserializeApplication_application_MedicaidApplication_documents_person(
          serialized.person
        )
      : serialized.person,
  application: deserializeApplication_application_MedicaidApplication_documents_application(
    serialized.application
  ),
})
export const serializeApplication_application_MedicaidApplication_documents = (
  deserialized: Application_application_MedicaidApplication_documents
): Application_application_MedicaidApplication_documentsOrig => ({
  ...deserialized,
  files: deserialized.files.map(
    serializeApplication_application_MedicaidApplication_documents_files
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  person:
    deserialized.person != null
      ? serializeApplication_application_MedicaidApplication_documents_person(
          deserialized.person
        )
      : deserialized.person,
  application: serializeApplication_application_MedicaidApplication_documents_application(
    deserialized.application
  ),
})
export interface Application_application_MedicaidApplication_documentFiles_documents {
  __typename: 'Document'
  id: string
}
export const deserializeApplication_application_MedicaidApplication_documentFiles_documents = (
  serialized: Application_application_MedicaidApplication_documentFiles_documentsOrig
): Application_application_MedicaidApplication_documentFiles_documents => ({
  ...serialized,
})
export const serializeApplication_application_MedicaidApplication_documentFiles_documents = (
  deserialized: Application_application_MedicaidApplication_documentFiles_documents
): Application_application_MedicaidApplication_documentFiles_documentsOrig => ({
  ...deserialized,
})
export interface Application_application_MedicaidApplication_documentFiles {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
  documents: Application_application_MedicaidApplication_documentFiles_documents[]
}
export const deserializeApplication_application_MedicaidApplication_documentFiles = (
  serialized: Application_application_MedicaidApplication_documentFilesOrig
): Application_application_MedicaidApplication_documentFiles => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
  documents: serialized.documents.map(
    deserializeApplication_application_MedicaidApplication_documentFiles_documents
  ),
})
export const serializeApplication_application_MedicaidApplication_documentFiles = (
  deserialized: Application_application_MedicaidApplication_documentFiles
): Application_application_MedicaidApplication_documentFilesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
  documents: deserialized.documents.map(
    serializeApplication_application_MedicaidApplication_documentFiles_documents
  ),
})
export interface Application_application_MedicaidApplication_benefitOutcomes_person {
  __typename: 'Person'
  id: string
}
export const deserializeApplication_application_MedicaidApplication_benefitOutcomes_person = (
  serialized: Application_application_MedicaidApplication_benefitOutcomes_personOrig
): Application_application_MedicaidApplication_benefitOutcomes_person => ({
  ...serialized,
})
export const serializeApplication_application_MedicaidApplication_benefitOutcomes_person = (
  deserialized: Application_application_MedicaidApplication_benefitOutcomes_person
): Application_application_MedicaidApplication_benefitOutcomes_personOrig => ({
  ...deserialized,
})
export interface Application_application_MedicaidApplication_benefitOutcomes_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializeApplication_application_MedicaidApplication_benefitOutcomes_application = (
  serialized: Application_application_MedicaidApplication_benefitOutcomes_applicationOrig
): Application_application_MedicaidApplication_benefitOutcomes_application => ({
  ...serialized,
})
export const serializeApplication_application_MedicaidApplication_benefitOutcomes_application = (
  deserialized: Application_application_MedicaidApplication_benefitOutcomes_application
): Application_application_MedicaidApplication_benefitOutcomes_applicationOrig => ({
  ...deserialized,
})
export interface Application_application_MedicaidApplication_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  person: Application_application_MedicaidApplication_benefitOutcomes_person
  application: Application_application_MedicaidApplication_benefitOutcomes_application | null
}
export const deserializeApplication_application_MedicaidApplication_benefitOutcomes = (
  serialized: Application_application_MedicaidApplication_benefitOutcomesOrig
): Application_application_MedicaidApplication_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  person: deserializeApplication_application_MedicaidApplication_benefitOutcomes_person(
    serialized.person
  ),
  application:
    serialized.application != null
      ? deserializeApplication_application_MedicaidApplication_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeApplication_application_MedicaidApplication_benefitOutcomes = (
  deserialized: Application_application_MedicaidApplication_benefitOutcomes
): Application_application_MedicaidApplication_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  person: serializeApplication_application_MedicaidApplication_benefitOutcomes_person(
    deserialized.person
  ),
  application:
    deserialized.application != null
      ? serializeApplication_application_MedicaidApplication_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface Application_application_MedicaidApplication_accountOnDateOfService {
  __typename: 'Account'
  id: string
  hospitalAccountId: string | null
  dateOfService: Date
  timeOfService: string | null
  serviceTimeZone: string
  facility: string
  department: string
  location: string | null
  insuranceType: string
  status: string
  createdAt: Date
  updatedAt: Date
  notes: string | null
  accountAmount: number | null
  njmmisCheck: string | null
  previousInsurance: string | null
  invoiceMonth: string | null
  invoiceYear: string | null
  dischargeDate: Date | null
  isScheduled: boolean
}
export const deserializeApplication_application_MedicaidApplication_accountOnDateOfService = (
  serialized: Application_application_MedicaidApplication_accountOnDateOfServiceOrig
): Application_application_MedicaidApplication_accountOnDateOfService => ({
  ...serialized,
  dateOfService: parseDate(serialized.dateOfService),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  njmmisCheck:
    serialized.njmmisCheck != null
      ? deserializeNjmmisCheckResult(serialized.njmmisCheck)
      : serialized.njmmisCheck,
  dischargeDate:
    serialized.dischargeDate != null
      ? parseDate(serialized.dischargeDate)
      : serialized.dischargeDate,
})
export const serializeApplication_application_MedicaidApplication_accountOnDateOfService = (
  deserialized: Application_application_MedicaidApplication_accountOnDateOfService
): Application_application_MedicaidApplication_accountOnDateOfServiceOrig => ({
  ...deserialized,
  dateOfService: formatISODate(deserialized.dateOfService),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  njmmisCheck:
    deserialized.njmmisCheck != null
      ? serializeNjmmisCheckResult(deserialized.njmmisCheck)
      : deserialized.njmmisCheck,
  dischargeDate:
    deserialized.dischargeDate != null
      ? formatISODate(deserialized.dischargeDate)
      : deserialized.dischargeDate,
})
export interface Application_application_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeApplication_application_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizards = (
  serialized: Application_application_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizardsOrig
): Application_application_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeApplication_application_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizards = (
  deserialized: Application_application_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizards
): Application_application_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Application_application_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Application_application_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeApplication_application_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession = (
  serialized: Application_application_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSessionOrig
): Application_application_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeApplication_application_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeApplication_application_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession = (
  deserialized: Application_application_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession
): Application_application_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeApplication_application_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizards
  ),
})
export interface Application_application_MedicaidApplication_primaryPointOfContact_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: Application_application_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession | null
}
export const deserializeApplication_application_MedicaidApplication_primaryPointOfContact_phoneNumbers = (
  serialized: Application_application_MedicaidApplication_primaryPointOfContact_phoneNumbersOrig
): Application_application_MedicaidApplication_primaryPointOfContact_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeApplication_application_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeApplication_application_MedicaidApplication_primaryPointOfContact_phoneNumbers = (
  deserialized: Application_application_MedicaidApplication_primaryPointOfContact_phoneNumbers
): Application_application_MedicaidApplication_primaryPointOfContact_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeApplication_application_MedicaidApplication_primaryPointOfContact_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeApplication_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplication = (
  serialized: Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplicationOrig
): Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeApplication_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplication = (
  deserialized: Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplication
): Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeApplication_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplication = (
  serialized: Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplicationOrig
): Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeApplication_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplication = (
  deserialized: Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplication
): Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeApplication_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplication = (
  serialized: Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplicationOrig
): Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeApplication_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplication = (
  deserialized: Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplication
): Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application =
  | Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplication
  | Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplication
  | Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplication
export const deserializeApplication_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application = (
  serialized: Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_applicationOrig
): Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeApplication_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeApplication_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeApplication_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application'
  )
}
export const serializeApplication_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application = (
  deserialized: Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application
): Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeApplication_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeApplication_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeApplication_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application'
  )
}
export interface Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application | null
}
export const deserializeApplication_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes = (
  serialized: Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomesOrig
): Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeApplication_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeApplication_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes = (
  deserialized: Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes
): Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeApplication_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface Application_application_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeApplication_application_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession_esignWizards = (
  serialized: Application_application_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession_esignWizardsOrig
): Application_application_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeApplication_application_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession_esignWizards = (
  deserialized: Application_application_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession_esignWizards
): Application_application_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Application_application_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Application_application_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession_esignWizards[]
}
export const deserializeApplication_application_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession = (
  serialized: Application_application_MedicaidApplication_primaryPointOfContact_incomeSources_esignSessionOrig
): Application_application_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeApplication_application_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession_esignWizards
  ),
})
export const serializeApplication_application_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession = (
  deserialized: Application_application_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession
): Application_application_MedicaidApplication_primaryPointOfContact_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeApplication_application_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession_esignWizards
  ),
})
export interface Application_application_MedicaidApplication_primaryPointOfContact_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: Application_application_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession | null
}
export const deserializeApplication_application_MedicaidApplication_primaryPointOfContact_incomeSources = (
  serialized: Application_application_MedicaidApplication_primaryPointOfContact_incomeSourcesOrig
): Application_application_MedicaidApplication_primaryPointOfContact_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeApplication_application_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeApplication_application_MedicaidApplication_primaryPointOfContact_incomeSources = (
  deserialized: Application_application_MedicaidApplication_primaryPointOfContact_incomeSources
): Application_application_MedicaidApplication_primaryPointOfContact_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeApplication_application_MedicaidApplication_primaryPointOfContact_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Application_application_MedicaidApplication_primaryPointOfContact_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeApplication_application_MedicaidApplication_primaryPointOfContact_deductions = (
  serialized: Application_application_MedicaidApplication_primaryPointOfContact_deductionsOrig
): Application_application_MedicaidApplication_primaryPointOfContact_deductions => ({
  ...serialized,
})
export const serializeApplication_application_MedicaidApplication_primaryPointOfContact_deductions = (
  deserialized: Application_application_MedicaidApplication_primaryPointOfContact_deductions
): Application_application_MedicaidApplication_primaryPointOfContact_deductionsOrig => ({
  ...deserialized,
})
export interface Application_application_MedicaidApplication_primaryPointOfContact {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: Application_application_MedicaidApplication_primaryPointOfContact_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: Application_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes[]
  incomeSources: Application_application_MedicaidApplication_primaryPointOfContact_incomeSources[]
  deductions: Application_application_MedicaidApplication_primaryPointOfContact_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
}
export const deserializeApplication_application_MedicaidApplication_primaryPointOfContact = (
  serialized: Application_application_MedicaidApplication_primaryPointOfContactOrig
): Application_application_MedicaidApplication_primaryPointOfContact => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeApplication_application_MedicaidApplication_primaryPointOfContact_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeApplication_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeApplication_application_MedicaidApplication_primaryPointOfContact_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeApplication_application_MedicaidApplication_primaryPointOfContact_deductions
  ),
})
export const serializeApplication_application_MedicaidApplication_primaryPointOfContact = (
  deserialized: Application_application_MedicaidApplication_primaryPointOfContact
): Application_application_MedicaidApplication_primaryPointOfContactOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeApplication_application_MedicaidApplication_primaryPointOfContact_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeApplication_application_MedicaidApplication_primaryPointOfContact_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeApplication_application_MedicaidApplication_primaryPointOfContact_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeApplication_application_MedicaidApplication_primaryPointOfContact_deductions
  ),
})
export interface Application_application_MedicaidApplication {
  __typename: 'MedicaidApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  person: Application_application_MedicaidApplication_person
  assignedTo: Application_application_MedicaidApplication_assignedTo | null
  householdMembers: Application_application_MedicaidApplication_householdMembers[]
  documents: Application_application_MedicaidApplication_documents[]
  documentFiles: Application_application_MedicaidApplication_documentFiles[]
  benefitOutcomes: Application_application_MedicaidApplication_benefitOutcomes[]
  accountOnDateOfService: Application_application_MedicaidApplication_accountOnDateOfService | null
  submitDate: Date | null
  submitMethod: string | null
  location: string | null
  countyName: string | null
  confirmationNumber: string | null
  policyId: string | null
  notes: string | null
  initialDateOfService: Date | null
  mcdType: string
  mcdSubtype: string | null
  primaryPointOfContact: Application_application_MedicaidApplication_primaryPointOfContact | null
}
export const deserializeApplication_application_MedicaidApplication = (
  serialized: Application_application_MedicaidApplicationOrig
): Application_application_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  person: deserializeApplication_application_MedicaidApplication_person(
    serialized.person
  ),
  assignedTo:
    serialized.assignedTo != null
      ? deserializeApplication_application_MedicaidApplication_assignedTo(
          serialized.assignedTo
        )
      : serialized.assignedTo,
  householdMembers: serialized.householdMembers.map(
    deserializeApplication_application_MedicaidApplication_householdMembers
  ),
  documents: serialized.documents.map(
    deserializeApplication_application_MedicaidApplication_documents
  ),
  documentFiles: serialized.documentFiles.map(
    deserializeApplication_application_MedicaidApplication_documentFiles
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeApplication_application_MedicaidApplication_benefitOutcomes
  ),
  accountOnDateOfService:
    serialized.accountOnDateOfService != null
      ? deserializeApplication_application_MedicaidApplication_accountOnDateOfService(
          serialized.accountOnDateOfService
        )
      : serialized.accountOnDateOfService,
  submitDate:
    serialized.submitDate != null
      ? parseDate(serialized.submitDate)
      : serialized.submitDate,
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  mcdType: deserializeMcdType(serialized.mcdType),
  mcdSubtype:
    serialized.mcdSubtype != null
      ? deserializeMcdSubtype(serialized.mcdSubtype)
      : serialized.mcdSubtype,
  primaryPointOfContact:
    serialized.primaryPointOfContact != null
      ? deserializeApplication_application_MedicaidApplication_primaryPointOfContact(
          serialized.primaryPointOfContact
        )
      : serialized.primaryPointOfContact,
})
export const serializeApplication_application_MedicaidApplication = (
  deserialized: Application_application_MedicaidApplication
): Application_application_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  person: serializeApplication_application_MedicaidApplication_person(
    deserialized.person
  ),
  assignedTo:
    deserialized.assignedTo != null
      ? serializeApplication_application_MedicaidApplication_assignedTo(
          deserialized.assignedTo
        )
      : deserialized.assignedTo,
  householdMembers: deserialized.householdMembers.map(
    serializeApplication_application_MedicaidApplication_householdMembers
  ),
  documents: deserialized.documents.map(
    serializeApplication_application_MedicaidApplication_documents
  ),
  documentFiles: deserialized.documentFiles.map(
    serializeApplication_application_MedicaidApplication_documentFiles
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeApplication_application_MedicaidApplication_benefitOutcomes
  ),
  accountOnDateOfService:
    deserialized.accountOnDateOfService != null
      ? serializeApplication_application_MedicaidApplication_accountOnDateOfService(
          deserialized.accountOnDateOfService
        )
      : deserialized.accountOnDateOfService,
  submitDate:
    deserialized.submitDate != null
      ? formatISODate(deserialized.submitDate)
      : deserialized.submitDate,
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  mcdType: serializeMcdType(deserialized.mcdType),
  mcdSubtype:
    deserialized.mcdSubtype != null
      ? serializeMcdSubtype(deserialized.mcdSubtype)
      : deserialized.mcdSubtype,
  primaryPointOfContact:
    deserialized.primaryPointOfContact != null
      ? serializeApplication_application_MedicaidApplication_primaryPointOfContact(
          deserialized.primaryPointOfContact
        )
      : deserialized.primaryPointOfContact,
})
export interface Application_application_MonitorApplication_person_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeApplication_application_MonitorApplication_person_phoneNumbers_esignSession_esignWizards = (
  serialized: Application_application_MonitorApplication_person_phoneNumbers_esignSession_esignWizardsOrig
): Application_application_MonitorApplication_person_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeApplication_application_MonitorApplication_person_phoneNumbers_esignSession_esignWizards = (
  deserialized: Application_application_MonitorApplication_person_phoneNumbers_esignSession_esignWizards
): Application_application_MonitorApplication_person_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Application_application_MonitorApplication_person_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Application_application_MonitorApplication_person_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeApplication_application_MonitorApplication_person_phoneNumbers_esignSession = (
  serialized: Application_application_MonitorApplication_person_phoneNumbers_esignSessionOrig
): Application_application_MonitorApplication_person_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeApplication_application_MonitorApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeApplication_application_MonitorApplication_person_phoneNumbers_esignSession = (
  deserialized: Application_application_MonitorApplication_person_phoneNumbers_esignSession
): Application_application_MonitorApplication_person_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeApplication_application_MonitorApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export interface Application_application_MonitorApplication_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: Application_application_MonitorApplication_person_phoneNumbers_esignSession | null
}
export const deserializeApplication_application_MonitorApplication_person_phoneNumbers = (
  serialized: Application_application_MonitorApplication_person_phoneNumbersOrig
): Application_application_MonitorApplication_person_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeApplication_application_MonitorApplication_person_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeApplication_application_MonitorApplication_person_phoneNumbers = (
  deserialized: Application_application_MonitorApplication_person_phoneNumbers
): Application_application_MonitorApplication_person_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeApplication_application_MonitorApplication_person_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Application_application_MonitorApplication_person_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeApplication_application_MonitorApplication_person_benefitOutcomes_application_MedicaidApplication = (
  serialized: Application_application_MonitorApplication_person_benefitOutcomes_application_MedicaidApplicationOrig
): Application_application_MonitorApplication_person_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeApplication_application_MonitorApplication_person_benefitOutcomes_application_MedicaidApplication = (
  deserialized: Application_application_MonitorApplication_person_benefitOutcomes_application_MedicaidApplication
): Application_application_MonitorApplication_person_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface Application_application_MonitorApplication_person_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeApplication_application_MonitorApplication_person_benefitOutcomes_application_CharityCareApplication = (
  serialized: Application_application_MonitorApplication_person_benefitOutcomes_application_CharityCareApplicationOrig
): Application_application_MonitorApplication_person_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeApplication_application_MonitorApplication_person_benefitOutcomes_application_CharityCareApplication = (
  deserialized: Application_application_MonitorApplication_person_benefitOutcomes_application_CharityCareApplication
): Application_application_MonitorApplication_person_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface Application_application_MonitorApplication_person_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeApplication_application_MonitorApplication_person_benefitOutcomes_application_SlideApplication = (
  serialized: Application_application_MonitorApplication_person_benefitOutcomes_application_SlideApplicationOrig
): Application_application_MonitorApplication_person_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeApplication_application_MonitorApplication_person_benefitOutcomes_application_SlideApplication = (
  deserialized: Application_application_MonitorApplication_person_benefitOutcomes_application_SlideApplication
): Application_application_MonitorApplication_person_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type Application_application_MonitorApplication_person_benefitOutcomes_application =
  | Application_application_MonitorApplication_person_benefitOutcomes_application_MedicaidApplication
  | Application_application_MonitorApplication_person_benefitOutcomes_application_CharityCareApplication
  | Application_application_MonitorApplication_person_benefitOutcomes_application_SlideApplication
export const deserializeApplication_application_MonitorApplication_person_benefitOutcomes_application = (
  serialized: Application_application_MonitorApplication_person_benefitOutcomes_applicationOrig
): Application_application_MonitorApplication_person_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeApplication_application_MonitorApplication_person_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeApplication_application_MonitorApplication_person_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeApplication_application_MonitorApplication_person_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Application_application_MonitorApplication_person_benefitOutcomes_application'
  )
}
export const serializeApplication_application_MonitorApplication_person_benefitOutcomes_application = (
  deserialized: Application_application_MonitorApplication_person_benefitOutcomes_application
): Application_application_MonitorApplication_person_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeApplication_application_MonitorApplication_person_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeApplication_application_MonitorApplication_person_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeApplication_application_MonitorApplication_person_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Application_application_MonitorApplication_person_benefitOutcomes_application'
  )
}
export interface Application_application_MonitorApplication_person_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: Application_application_MonitorApplication_person_benefitOutcomes_application | null
}
export const deserializeApplication_application_MonitorApplication_person_benefitOutcomes = (
  serialized: Application_application_MonitorApplication_person_benefitOutcomesOrig
): Application_application_MonitorApplication_person_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeApplication_application_MonitorApplication_person_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeApplication_application_MonitorApplication_person_benefitOutcomes = (
  deserialized: Application_application_MonitorApplication_person_benefitOutcomes
): Application_application_MonitorApplication_person_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeApplication_application_MonitorApplication_person_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface Application_application_MonitorApplication_person_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeApplication_application_MonitorApplication_person_incomeSources_esignSession_esignWizards = (
  serialized: Application_application_MonitorApplication_person_incomeSources_esignSession_esignWizardsOrig
): Application_application_MonitorApplication_person_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeApplication_application_MonitorApplication_person_incomeSources_esignSession_esignWizards = (
  deserialized: Application_application_MonitorApplication_person_incomeSources_esignSession_esignWizards
): Application_application_MonitorApplication_person_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Application_application_MonitorApplication_person_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Application_application_MonitorApplication_person_incomeSources_esignSession_esignWizards[]
}
export const deserializeApplication_application_MonitorApplication_person_incomeSources_esignSession = (
  serialized: Application_application_MonitorApplication_person_incomeSources_esignSessionOrig
): Application_application_MonitorApplication_person_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeApplication_application_MonitorApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export const serializeApplication_application_MonitorApplication_person_incomeSources_esignSession = (
  deserialized: Application_application_MonitorApplication_person_incomeSources_esignSession
): Application_application_MonitorApplication_person_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeApplication_application_MonitorApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export interface Application_application_MonitorApplication_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: Application_application_MonitorApplication_person_incomeSources_esignSession | null
}
export const deserializeApplication_application_MonitorApplication_person_incomeSources = (
  serialized: Application_application_MonitorApplication_person_incomeSourcesOrig
): Application_application_MonitorApplication_person_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeApplication_application_MonitorApplication_person_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeApplication_application_MonitorApplication_person_incomeSources = (
  deserialized: Application_application_MonitorApplication_person_incomeSources
): Application_application_MonitorApplication_person_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeApplication_application_MonitorApplication_person_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Application_application_MonitorApplication_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeApplication_application_MonitorApplication_person_deductions = (
  serialized: Application_application_MonitorApplication_person_deductionsOrig
): Application_application_MonitorApplication_person_deductions => ({
  ...serialized,
})
export const serializeApplication_application_MonitorApplication_person_deductions = (
  deserialized: Application_application_MonitorApplication_person_deductions
): Application_application_MonitorApplication_person_deductionsOrig => ({
  ...deserialized,
})
export interface Application_application_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeApplication_application_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards = (
  serialized: Application_application_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizardsOrig
): Application_application_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeApplication_application_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards = (
  deserialized: Application_application_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards
): Application_application_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Application_application_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Application_application_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeApplication_application_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession = (
  serialized: Application_application_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSessionOrig
): Application_application_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeApplication_application_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeApplication_application_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession = (
  deserialized: Application_application_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession
): Application_application_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeApplication_application_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards
  ),
})
export interface Application_application_MonitorApplication_person_relationships_otherPerson_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: Application_application_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession | null
}
export const deserializeApplication_application_MonitorApplication_person_relationships_otherPerson_phoneNumbers = (
  serialized: Application_application_MonitorApplication_person_relationships_otherPerson_phoneNumbersOrig
): Application_application_MonitorApplication_person_relationships_otherPerson_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeApplication_application_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeApplication_application_MonitorApplication_person_relationships_otherPerson_phoneNumbers = (
  deserialized: Application_application_MonitorApplication_person_relationships_otherPerson_phoneNumbers
): Application_application_MonitorApplication_person_relationships_otherPerson_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeApplication_application_MonitorApplication_person_relationships_otherPerson_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeApplication_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication = (
  serialized: Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplicationOrig
): Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeApplication_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication = (
  deserialized: Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication
): Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeApplication_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication = (
  serialized: Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplicationOrig
): Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeApplication_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication = (
  deserialized: Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication
): Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeApplication_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication = (
  serialized: Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplicationOrig
): Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeApplication_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication = (
  deserialized: Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication
): Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application =
  | Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication
  | Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication
  | Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication
export const deserializeApplication_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application = (
  serialized: Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_applicationOrig
): Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeApplication_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeApplication_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeApplication_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application'
  )
}
export const serializeApplication_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application = (
  deserialized: Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application
): Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeApplication_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeApplication_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeApplication_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application'
  )
}
export interface Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application | null
}
export const deserializeApplication_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes = (
  serialized: Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomesOrig
): Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeApplication_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeApplication_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes = (
  deserialized: Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes
): Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeApplication_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface Application_application_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeApplication_application_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards = (
  serialized: Application_application_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizardsOrig
): Application_application_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeApplication_application_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards = (
  deserialized: Application_application_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards
): Application_application_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Application_application_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Application_application_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards[]
}
export const deserializeApplication_application_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession = (
  serialized: Application_application_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSessionOrig
): Application_application_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeApplication_application_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards
  ),
})
export const serializeApplication_application_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession = (
  deserialized: Application_application_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession
): Application_application_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeApplication_application_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards
  ),
})
export interface Application_application_MonitorApplication_person_relationships_otherPerson_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: Application_application_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession | null
}
export const deserializeApplication_application_MonitorApplication_person_relationships_otherPerson_incomeSources = (
  serialized: Application_application_MonitorApplication_person_relationships_otherPerson_incomeSourcesOrig
): Application_application_MonitorApplication_person_relationships_otherPerson_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeApplication_application_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeApplication_application_MonitorApplication_person_relationships_otherPerson_incomeSources = (
  deserialized: Application_application_MonitorApplication_person_relationships_otherPerson_incomeSources
): Application_application_MonitorApplication_person_relationships_otherPerson_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeApplication_application_MonitorApplication_person_relationships_otherPerson_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Application_application_MonitorApplication_person_relationships_otherPerson_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeApplication_application_MonitorApplication_person_relationships_otherPerson_deductions = (
  serialized: Application_application_MonitorApplication_person_relationships_otherPerson_deductionsOrig
): Application_application_MonitorApplication_person_relationships_otherPerson_deductions => ({
  ...serialized,
})
export const serializeApplication_application_MonitorApplication_person_relationships_otherPerson_deductions = (
  deserialized: Application_application_MonitorApplication_person_relationships_otherPerson_deductions
): Application_application_MonitorApplication_person_relationships_otherPerson_deductionsOrig => ({
  ...deserialized,
})
export interface Application_application_MonitorApplication_person_relationships_otherPerson {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: Application_application_MonitorApplication_person_relationships_otherPerson_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: Application_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes[]
  incomeSources: Application_application_MonitorApplication_person_relationships_otherPerson_incomeSources[]
  deductions: Application_application_MonitorApplication_person_relationships_otherPerson_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
}
export const deserializeApplication_application_MonitorApplication_person_relationships_otherPerson = (
  serialized: Application_application_MonitorApplication_person_relationships_otherPersonOrig
): Application_application_MonitorApplication_person_relationships_otherPerson => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeApplication_application_MonitorApplication_person_relationships_otherPerson_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeApplication_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeApplication_application_MonitorApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeApplication_application_MonitorApplication_person_relationships_otherPerson_deductions
  ),
})
export const serializeApplication_application_MonitorApplication_person_relationships_otherPerson = (
  deserialized: Application_application_MonitorApplication_person_relationships_otherPerson
): Application_application_MonitorApplication_person_relationships_otherPersonOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeApplication_application_MonitorApplication_person_relationships_otherPerson_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeApplication_application_MonitorApplication_person_relationships_otherPerson_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeApplication_application_MonitorApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeApplication_application_MonitorApplication_person_relationships_otherPerson_deductions
  ),
})
export interface Application_application_MonitorApplication_person_relationships {
  __typename: 'Relationship'
  id: string
  relationshipType: string | null
  reverseRelationshipType: string | null
  liveTogether: boolean | null
  otherPerson: Application_application_MonitorApplication_person_relationships_otherPerson
}
export const deserializeApplication_application_MonitorApplication_person_relationships = (
  serialized: Application_application_MonitorApplication_person_relationshipsOrig
): Application_application_MonitorApplication_person_relationships => ({
  ...serialized,
  otherPerson: deserializeApplication_application_MonitorApplication_person_relationships_otherPerson(
    serialized.otherPerson
  ),
})
export const serializeApplication_application_MonitorApplication_person_relationships = (
  deserialized: Application_application_MonitorApplication_person_relationships
): Application_application_MonitorApplication_person_relationshipsOrig => ({
  ...deserialized,
  otherPerson: serializeApplication_application_MonitorApplication_person_relationships_otherPerson(
    deserialized.otherPerson
  ),
})
export interface Application_application_MonitorApplication_person_documentFiles {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeApplication_application_MonitorApplication_person_documentFiles = (
  serialized: Application_application_MonitorApplication_person_documentFilesOrig
): Application_application_MonitorApplication_person_documentFiles => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeApplication_application_MonitorApplication_person_documentFiles = (
  deserialized: Application_application_MonitorApplication_person_documentFiles
): Application_application_MonitorApplication_person_documentFilesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface Application_application_MonitorApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializeApplication_application_MonitorApplication_person_openApplications_MedicaidApplication = (
  serialized: Application_application_MonitorApplication_person_openApplications_MedicaidApplicationOrig
): Application_application_MonitorApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeApplication_application_MonitorApplication_person_openApplications_MedicaidApplication = (
  deserialized: Application_application_MonitorApplication_person_openApplications_MedicaidApplication
): Application_application_MonitorApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Application_application_MonitorApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeApplication_application_MonitorApplication_person_openApplications_CharityCareApplication = (
  serialized: Application_application_MonitorApplication_person_openApplications_CharityCareApplicationOrig
): Application_application_MonitorApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeApplication_application_MonitorApplication_person_openApplications_CharityCareApplication = (
  deserialized: Application_application_MonitorApplication_person_openApplications_CharityCareApplication
): Application_application_MonitorApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Application_application_MonitorApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeApplication_application_MonitorApplication_person_openApplications_SlideApplication = (
  serialized: Application_application_MonitorApplication_person_openApplications_SlideApplicationOrig
): Application_application_MonitorApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeApplication_application_MonitorApplication_person_openApplications_SlideApplication = (
  deserialized: Application_application_MonitorApplication_person_openApplications_SlideApplication
): Application_application_MonitorApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Application_application_MonitorApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeApplication_application_MonitorApplication_person_openApplications_RyanWhiteApplication = (
  serialized: Application_application_MonitorApplication_person_openApplications_RyanWhiteApplicationOrig
): Application_application_MonitorApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeApplication_application_MonitorApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: Application_application_MonitorApplication_person_openApplications_RyanWhiteApplication
): Application_application_MonitorApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type Application_application_MonitorApplication_person_openApplications =
  | Application_application_MonitorApplication_person_openApplications_MedicaidApplication
  | Application_application_MonitorApplication_person_openApplications_CharityCareApplication
  | Application_application_MonitorApplication_person_openApplications_SlideApplication
  | Application_application_MonitorApplication_person_openApplications_RyanWhiteApplication
export const deserializeApplication_application_MonitorApplication_person_openApplications = (
  serialized: Application_application_MonitorApplication_person_openApplicationsOrig
): Application_application_MonitorApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializeApplication_application_MonitorApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeApplication_application_MonitorApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeApplication_application_MonitorApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeApplication_application_MonitorApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Application_application_MonitorApplication_person_openApplications'
  )
}
export const serializeApplication_application_MonitorApplication_person_openApplications = (
  deserialized: Application_application_MonitorApplication_person_openApplications
): Application_application_MonitorApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializeApplication_application_MonitorApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeApplication_application_MonitorApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeApplication_application_MonitorApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeApplication_application_MonitorApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Application_application_MonitorApplication_person_openApplications'
  )
}
export interface Application_application_MonitorApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializeApplication_application_MonitorApplication_person_openHouseholdMemberApplications = (
  serialized: Application_application_MonitorApplication_person_openHouseholdMemberApplicationsOrig
): Application_application_MonitorApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeApplication_application_MonitorApplication_person_openHouseholdMemberApplications = (
  deserialized: Application_application_MonitorApplication_person_openHouseholdMemberApplications
): Application_application_MonitorApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Application_application_MonitorApplication_person {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: Application_application_MonitorApplication_person_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: Application_application_MonitorApplication_person_benefitOutcomes[]
  incomeSources: Application_application_MonitorApplication_person_incomeSources[]
  deductions: Application_application_MonitorApplication_person_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
  relationships: Application_application_MonitorApplication_person_relationships[]
  documentFiles: Application_application_MonitorApplication_person_documentFiles[]
  openApplications: Application_application_MonitorApplication_person_openApplications[]
  openHouseholdMemberApplications: Application_application_MonitorApplication_person_openHouseholdMemberApplications[]
}
export const deserializeApplication_application_MonitorApplication_person = (
  serialized: Application_application_MonitorApplication_personOrig
): Application_application_MonitorApplication_person => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeApplication_application_MonitorApplication_person_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeApplication_application_MonitorApplication_person_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeApplication_application_MonitorApplication_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeApplication_application_MonitorApplication_person_deductions
  ),
  relationships: serialized.relationships.map(
    deserializeApplication_application_MonitorApplication_person_relationships
  ),
  documentFiles: serialized.documentFiles.map(
    deserializeApplication_application_MonitorApplication_person_documentFiles
  ),
  openApplications: serialized.openApplications.map(
    deserializeApplication_application_MonitorApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializeApplication_application_MonitorApplication_person_openHouseholdMemberApplications
  ),
})
export const serializeApplication_application_MonitorApplication_person = (
  deserialized: Application_application_MonitorApplication_person
): Application_application_MonitorApplication_personOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeApplication_application_MonitorApplication_person_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeApplication_application_MonitorApplication_person_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeApplication_application_MonitorApplication_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeApplication_application_MonitorApplication_person_deductions
  ),
  relationships: deserialized.relationships.map(
    serializeApplication_application_MonitorApplication_person_relationships
  ),
  documentFiles: deserialized.documentFiles.map(
    serializeApplication_application_MonitorApplication_person_documentFiles
  ),
  openApplications: deserialized.openApplications.map(
    serializeApplication_application_MonitorApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializeApplication_application_MonitorApplication_person_openHouseholdMemberApplications
  ),
})
export interface Application_application_MonitorApplication_assignedTo {
  __typename: 'User'
  id: string
  email: string
  name: string | null
  isCurrentUser: boolean
}
export const deserializeApplication_application_MonitorApplication_assignedTo = (
  serialized: Application_application_MonitorApplication_assignedToOrig
): Application_application_MonitorApplication_assignedTo => ({...serialized})
export const serializeApplication_application_MonitorApplication_assignedTo = (
  deserialized: Application_application_MonitorApplication_assignedTo
): Application_application_MonitorApplication_assignedToOrig => ({
  ...deserialized,
})
export interface Application_application_MonitorApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeApplication_application_MonitorApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards = (
  serialized: Application_application_MonitorApplication_householdMembers_person_phoneNumbers_esignSession_esignWizardsOrig
): Application_application_MonitorApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeApplication_application_MonitorApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards = (
  deserialized: Application_application_MonitorApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards
): Application_application_MonitorApplication_householdMembers_person_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Application_application_MonitorApplication_householdMembers_person_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Application_application_MonitorApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeApplication_application_MonitorApplication_householdMembers_person_phoneNumbers_esignSession = (
  serialized: Application_application_MonitorApplication_householdMembers_person_phoneNumbers_esignSessionOrig
): Application_application_MonitorApplication_householdMembers_person_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeApplication_application_MonitorApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeApplication_application_MonitorApplication_householdMembers_person_phoneNumbers_esignSession = (
  deserialized: Application_application_MonitorApplication_householdMembers_person_phoneNumbers_esignSession
): Application_application_MonitorApplication_householdMembers_person_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeApplication_application_MonitorApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards
  ),
})
export interface Application_application_MonitorApplication_householdMembers_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: Application_application_MonitorApplication_householdMembers_person_phoneNumbers_esignSession | null
}
export const deserializeApplication_application_MonitorApplication_householdMembers_person_phoneNumbers = (
  serialized: Application_application_MonitorApplication_householdMembers_person_phoneNumbersOrig
): Application_application_MonitorApplication_householdMembers_person_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeApplication_application_MonitorApplication_householdMembers_person_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeApplication_application_MonitorApplication_householdMembers_person_phoneNumbers = (
  deserialized: Application_application_MonitorApplication_householdMembers_person_phoneNumbers
): Application_application_MonitorApplication_householdMembers_person_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeApplication_application_MonitorApplication_householdMembers_person_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Application_application_MonitorApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeApplication_application_MonitorApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication = (
  serialized: Application_application_MonitorApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplicationOrig
): Application_application_MonitorApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeApplication_application_MonitorApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication = (
  deserialized: Application_application_MonitorApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication
): Application_application_MonitorApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface Application_application_MonitorApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeApplication_application_MonitorApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication = (
  serialized: Application_application_MonitorApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplicationOrig
): Application_application_MonitorApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeApplication_application_MonitorApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication = (
  deserialized: Application_application_MonitorApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication
): Application_application_MonitorApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface Application_application_MonitorApplication_householdMembers_person_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeApplication_application_MonitorApplication_householdMembers_person_benefitOutcomes_application_SlideApplication = (
  serialized: Application_application_MonitorApplication_householdMembers_person_benefitOutcomes_application_SlideApplicationOrig
): Application_application_MonitorApplication_householdMembers_person_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeApplication_application_MonitorApplication_householdMembers_person_benefitOutcomes_application_SlideApplication = (
  deserialized: Application_application_MonitorApplication_householdMembers_person_benefitOutcomes_application_SlideApplication
): Application_application_MonitorApplication_householdMembers_person_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type Application_application_MonitorApplication_householdMembers_person_benefitOutcomes_application =
  | Application_application_MonitorApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication
  | Application_application_MonitorApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication
  | Application_application_MonitorApplication_householdMembers_person_benefitOutcomes_application_SlideApplication
export const deserializeApplication_application_MonitorApplication_householdMembers_person_benefitOutcomes_application = (
  serialized: Application_application_MonitorApplication_householdMembers_person_benefitOutcomes_applicationOrig
): Application_application_MonitorApplication_householdMembers_person_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeApplication_application_MonitorApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeApplication_application_MonitorApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeApplication_application_MonitorApplication_householdMembers_person_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Application_application_MonitorApplication_householdMembers_person_benefitOutcomes_application'
  )
}
export const serializeApplication_application_MonitorApplication_householdMembers_person_benefitOutcomes_application = (
  deserialized: Application_application_MonitorApplication_householdMembers_person_benefitOutcomes_application
): Application_application_MonitorApplication_householdMembers_person_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeApplication_application_MonitorApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeApplication_application_MonitorApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeApplication_application_MonitorApplication_householdMembers_person_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Application_application_MonitorApplication_householdMembers_person_benefitOutcomes_application'
  )
}
export interface Application_application_MonitorApplication_householdMembers_person_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: Application_application_MonitorApplication_householdMembers_person_benefitOutcomes_application | null
}
export const deserializeApplication_application_MonitorApplication_householdMembers_person_benefitOutcomes = (
  serialized: Application_application_MonitorApplication_householdMembers_person_benefitOutcomesOrig
): Application_application_MonitorApplication_householdMembers_person_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeApplication_application_MonitorApplication_householdMembers_person_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeApplication_application_MonitorApplication_householdMembers_person_benefitOutcomes = (
  deserialized: Application_application_MonitorApplication_householdMembers_person_benefitOutcomes
): Application_application_MonitorApplication_householdMembers_person_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeApplication_application_MonitorApplication_householdMembers_person_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface Application_application_MonitorApplication_householdMembers_person_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeApplication_application_MonitorApplication_householdMembers_person_incomeSources_esignSession_esignWizards = (
  serialized: Application_application_MonitorApplication_householdMembers_person_incomeSources_esignSession_esignWizardsOrig
): Application_application_MonitorApplication_householdMembers_person_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeApplication_application_MonitorApplication_householdMembers_person_incomeSources_esignSession_esignWizards = (
  deserialized: Application_application_MonitorApplication_householdMembers_person_incomeSources_esignSession_esignWizards
): Application_application_MonitorApplication_householdMembers_person_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Application_application_MonitorApplication_householdMembers_person_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Application_application_MonitorApplication_householdMembers_person_incomeSources_esignSession_esignWizards[]
}
export const deserializeApplication_application_MonitorApplication_householdMembers_person_incomeSources_esignSession = (
  serialized: Application_application_MonitorApplication_householdMembers_person_incomeSources_esignSessionOrig
): Application_application_MonitorApplication_householdMembers_person_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeApplication_application_MonitorApplication_householdMembers_person_incomeSources_esignSession_esignWizards
  ),
})
export const serializeApplication_application_MonitorApplication_householdMembers_person_incomeSources_esignSession = (
  deserialized: Application_application_MonitorApplication_householdMembers_person_incomeSources_esignSession
): Application_application_MonitorApplication_householdMembers_person_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeApplication_application_MonitorApplication_householdMembers_person_incomeSources_esignSession_esignWizards
  ),
})
export interface Application_application_MonitorApplication_householdMembers_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: Application_application_MonitorApplication_householdMembers_person_incomeSources_esignSession | null
}
export const deserializeApplication_application_MonitorApplication_householdMembers_person_incomeSources = (
  serialized: Application_application_MonitorApplication_householdMembers_person_incomeSourcesOrig
): Application_application_MonitorApplication_householdMembers_person_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeApplication_application_MonitorApplication_householdMembers_person_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeApplication_application_MonitorApplication_householdMembers_person_incomeSources = (
  deserialized: Application_application_MonitorApplication_householdMembers_person_incomeSources
): Application_application_MonitorApplication_householdMembers_person_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeApplication_application_MonitorApplication_householdMembers_person_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Application_application_MonitorApplication_householdMembers_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeApplication_application_MonitorApplication_householdMembers_person_deductions = (
  serialized: Application_application_MonitorApplication_householdMembers_person_deductionsOrig
): Application_application_MonitorApplication_householdMembers_person_deductions => ({
  ...serialized,
})
export const serializeApplication_application_MonitorApplication_householdMembers_person_deductions = (
  deserialized: Application_application_MonitorApplication_householdMembers_person_deductions
): Application_application_MonitorApplication_householdMembers_person_deductionsOrig => ({
  ...deserialized,
})
export interface Application_application_MonitorApplication_householdMembers_person_documentFiles {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeApplication_application_MonitorApplication_householdMembers_person_documentFiles = (
  serialized: Application_application_MonitorApplication_householdMembers_person_documentFilesOrig
): Application_application_MonitorApplication_householdMembers_person_documentFiles => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeApplication_application_MonitorApplication_householdMembers_person_documentFiles = (
  deserialized: Application_application_MonitorApplication_householdMembers_person_documentFiles
): Application_application_MonitorApplication_householdMembers_person_documentFilesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface Application_application_MonitorApplication_householdMembers_person {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: Application_application_MonitorApplication_householdMembers_person_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: Application_application_MonitorApplication_householdMembers_person_benefitOutcomes[]
  incomeSources: Application_application_MonitorApplication_householdMembers_person_incomeSources[]
  deductions: Application_application_MonitorApplication_householdMembers_person_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
  documentFiles: Application_application_MonitorApplication_householdMembers_person_documentFiles[]
}
export const deserializeApplication_application_MonitorApplication_householdMembers_person = (
  serialized: Application_application_MonitorApplication_householdMembers_personOrig
): Application_application_MonitorApplication_householdMembers_person => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeApplication_application_MonitorApplication_householdMembers_person_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeApplication_application_MonitorApplication_householdMembers_person_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeApplication_application_MonitorApplication_householdMembers_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeApplication_application_MonitorApplication_householdMembers_person_deductions
  ),
  documentFiles: serialized.documentFiles.map(
    deserializeApplication_application_MonitorApplication_householdMembers_person_documentFiles
  ),
})
export const serializeApplication_application_MonitorApplication_householdMembers_person = (
  deserialized: Application_application_MonitorApplication_householdMembers_person
): Application_application_MonitorApplication_householdMembers_personOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeApplication_application_MonitorApplication_householdMembers_person_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeApplication_application_MonitorApplication_householdMembers_person_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeApplication_application_MonitorApplication_householdMembers_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeApplication_application_MonitorApplication_householdMembers_person_deductions
  ),
  documentFiles: deserialized.documentFiles.map(
    serializeApplication_application_MonitorApplication_householdMembers_person_documentFiles
  ),
})
export interface Application_application_MonitorApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  wantsCoverage: boolean | null
  person: Application_application_MonitorApplication_householdMembers_person
  createdAt: Date
}
export const deserializeApplication_application_MonitorApplication_householdMembers = (
  serialized: Application_application_MonitorApplication_householdMembersOrig
): Application_application_MonitorApplication_householdMembers => ({
  ...serialized,
  person: deserializeApplication_application_MonitorApplication_householdMembers_person(
    serialized.person
  ),
  createdAt: parseDate(serialized.createdAt),
})
export const serializeApplication_application_MonitorApplication_householdMembers = (
  deserialized: Application_application_MonitorApplication_householdMembers
): Application_application_MonitorApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializeApplication_application_MonitorApplication_householdMembers_person(
    deserialized.person
  ),
  createdAt: formatISO(deserialized.createdAt),
})
export interface Application_application_MonitorApplication_documents_files {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeApplication_application_MonitorApplication_documents_files = (
  serialized: Application_application_MonitorApplication_documents_filesOrig
): Application_application_MonitorApplication_documents_files => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeApplication_application_MonitorApplication_documents_files = (
  deserialized: Application_application_MonitorApplication_documents_files
): Application_application_MonitorApplication_documents_filesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface Application_application_MonitorApplication_documents_person {
  __typename: 'Person'
  id: string
}
export const deserializeApplication_application_MonitorApplication_documents_person = (
  serialized: Application_application_MonitorApplication_documents_personOrig
): Application_application_MonitorApplication_documents_person => ({
  ...serialized,
})
export const serializeApplication_application_MonitorApplication_documents_person = (
  deserialized: Application_application_MonitorApplication_documents_person
): Application_application_MonitorApplication_documents_personOrig => ({
  ...deserialized,
})
export interface Application_application_MonitorApplication_documents_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializeApplication_application_MonitorApplication_documents_application = (
  serialized: Application_application_MonitorApplication_documents_applicationOrig
): Application_application_MonitorApplication_documents_application => ({
  ...serialized,
})
export const serializeApplication_application_MonitorApplication_documents_application = (
  deserialized: Application_application_MonitorApplication_documents_application
): Application_application_MonitorApplication_documents_applicationOrig => ({
  ...deserialized,
})
export interface Application_application_MonitorApplication_documents {
  __typename: 'Document'
  id: string
  documentType: string
  complete: boolean | null
  files: Application_application_MonitorApplication_documents_files[]
  updatedAt: Date
  notes: string | null
  person: Application_application_MonitorApplication_documents_person | null
  application: Application_application_MonitorApplication_documents_application
}
export const deserializeApplication_application_MonitorApplication_documents = (
  serialized: Application_application_MonitorApplication_documentsOrig
): Application_application_MonitorApplication_documents => ({
  ...serialized,
  files: serialized.files.map(
    deserializeApplication_application_MonitorApplication_documents_files
  ),
  updatedAt: parseDate(serialized.updatedAt),
  person:
    serialized.person != null
      ? deserializeApplication_application_MonitorApplication_documents_person(
          serialized.person
        )
      : serialized.person,
  application: deserializeApplication_application_MonitorApplication_documents_application(
    serialized.application
  ),
})
export const serializeApplication_application_MonitorApplication_documents = (
  deserialized: Application_application_MonitorApplication_documents
): Application_application_MonitorApplication_documentsOrig => ({
  ...deserialized,
  files: deserialized.files.map(
    serializeApplication_application_MonitorApplication_documents_files
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  person:
    deserialized.person != null
      ? serializeApplication_application_MonitorApplication_documents_person(
          deserialized.person
        )
      : deserialized.person,
  application: serializeApplication_application_MonitorApplication_documents_application(
    deserialized.application
  ),
})
export interface Application_application_MonitorApplication_documentFiles_documents {
  __typename: 'Document'
  id: string
}
export const deserializeApplication_application_MonitorApplication_documentFiles_documents = (
  serialized: Application_application_MonitorApplication_documentFiles_documentsOrig
): Application_application_MonitorApplication_documentFiles_documents => ({
  ...serialized,
})
export const serializeApplication_application_MonitorApplication_documentFiles_documents = (
  deserialized: Application_application_MonitorApplication_documentFiles_documents
): Application_application_MonitorApplication_documentFiles_documentsOrig => ({
  ...deserialized,
})
export interface Application_application_MonitorApplication_documentFiles {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
  documents: Application_application_MonitorApplication_documentFiles_documents[]
}
export const deserializeApplication_application_MonitorApplication_documentFiles = (
  serialized: Application_application_MonitorApplication_documentFilesOrig
): Application_application_MonitorApplication_documentFiles => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
  documents: serialized.documents.map(
    deserializeApplication_application_MonitorApplication_documentFiles_documents
  ),
})
export const serializeApplication_application_MonitorApplication_documentFiles = (
  deserialized: Application_application_MonitorApplication_documentFiles
): Application_application_MonitorApplication_documentFilesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
  documents: deserialized.documents.map(
    serializeApplication_application_MonitorApplication_documentFiles_documents
  ),
})
export interface Application_application_MonitorApplication_benefitOutcomes_person {
  __typename: 'Person'
  id: string
}
export const deserializeApplication_application_MonitorApplication_benefitOutcomes_person = (
  serialized: Application_application_MonitorApplication_benefitOutcomes_personOrig
): Application_application_MonitorApplication_benefitOutcomes_person => ({
  ...serialized,
})
export const serializeApplication_application_MonitorApplication_benefitOutcomes_person = (
  deserialized: Application_application_MonitorApplication_benefitOutcomes_person
): Application_application_MonitorApplication_benefitOutcomes_personOrig => ({
  ...deserialized,
})
export interface Application_application_MonitorApplication_benefitOutcomes_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializeApplication_application_MonitorApplication_benefitOutcomes_application = (
  serialized: Application_application_MonitorApplication_benefitOutcomes_applicationOrig
): Application_application_MonitorApplication_benefitOutcomes_application => ({
  ...serialized,
})
export const serializeApplication_application_MonitorApplication_benefitOutcomes_application = (
  deserialized: Application_application_MonitorApplication_benefitOutcomes_application
): Application_application_MonitorApplication_benefitOutcomes_applicationOrig => ({
  ...deserialized,
})
export interface Application_application_MonitorApplication_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  person: Application_application_MonitorApplication_benefitOutcomes_person
  application: Application_application_MonitorApplication_benefitOutcomes_application | null
}
export const deserializeApplication_application_MonitorApplication_benefitOutcomes = (
  serialized: Application_application_MonitorApplication_benefitOutcomesOrig
): Application_application_MonitorApplication_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  person: deserializeApplication_application_MonitorApplication_benefitOutcomes_person(
    serialized.person
  ),
  application:
    serialized.application != null
      ? deserializeApplication_application_MonitorApplication_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeApplication_application_MonitorApplication_benefitOutcomes = (
  deserialized: Application_application_MonitorApplication_benefitOutcomes
): Application_application_MonitorApplication_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  person: serializeApplication_application_MonitorApplication_benefitOutcomes_person(
    deserialized.person
  ),
  application:
    deserialized.application != null
      ? serializeApplication_application_MonitorApplication_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface Application_application_MonitorApplication_accountOnDateOfService {
  __typename: 'Account'
  id: string
  hospitalAccountId: string | null
  dateOfService: Date
  timeOfService: string | null
  serviceTimeZone: string
  facility: string
  department: string
  location: string | null
  insuranceType: string
  status: string
  createdAt: Date
  updatedAt: Date
  notes: string | null
  accountAmount: number | null
  njmmisCheck: string | null
  previousInsurance: string | null
  invoiceMonth: string | null
  invoiceYear: string | null
  dischargeDate: Date | null
  isScheduled: boolean
}
export const deserializeApplication_application_MonitorApplication_accountOnDateOfService = (
  serialized: Application_application_MonitorApplication_accountOnDateOfServiceOrig
): Application_application_MonitorApplication_accountOnDateOfService => ({
  ...serialized,
  dateOfService: parseDate(serialized.dateOfService),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  njmmisCheck:
    serialized.njmmisCheck != null
      ? deserializeNjmmisCheckResult(serialized.njmmisCheck)
      : serialized.njmmisCheck,
  dischargeDate:
    serialized.dischargeDate != null
      ? parseDate(serialized.dischargeDate)
      : serialized.dischargeDate,
})
export const serializeApplication_application_MonitorApplication_accountOnDateOfService = (
  deserialized: Application_application_MonitorApplication_accountOnDateOfService
): Application_application_MonitorApplication_accountOnDateOfServiceOrig => ({
  ...deserialized,
  dateOfService: formatISODate(deserialized.dateOfService),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  njmmisCheck:
    deserialized.njmmisCheck != null
      ? serializeNjmmisCheckResult(deserialized.njmmisCheck)
      : deserialized.njmmisCheck,
  dischargeDate:
    deserialized.dischargeDate != null
      ? formatISODate(deserialized.dischargeDate)
      : deserialized.dischargeDate,
})
export interface Application_application_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeApplication_application_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizards = (
  serialized: Application_application_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizardsOrig
): Application_application_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeApplication_application_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizards = (
  deserialized: Application_application_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizards
): Application_application_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Application_application_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Application_application_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeApplication_application_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession = (
  serialized: Application_application_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSessionOrig
): Application_application_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeApplication_application_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeApplication_application_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession = (
  deserialized: Application_application_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession
): Application_application_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeApplication_application_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession_esignWizards
  ),
})
export interface Application_application_MonitorApplication_primaryPointOfContact_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: Application_application_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession | null
}
export const deserializeApplication_application_MonitorApplication_primaryPointOfContact_phoneNumbers = (
  serialized: Application_application_MonitorApplication_primaryPointOfContact_phoneNumbersOrig
): Application_application_MonitorApplication_primaryPointOfContact_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeApplication_application_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeApplication_application_MonitorApplication_primaryPointOfContact_phoneNumbers = (
  deserialized: Application_application_MonitorApplication_primaryPointOfContact_phoneNumbers
): Application_application_MonitorApplication_primaryPointOfContact_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeApplication_application_MonitorApplication_primaryPointOfContact_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeApplication_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplication = (
  serialized: Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplicationOrig
): Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeApplication_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplication = (
  deserialized: Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplication
): Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeApplication_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplication = (
  serialized: Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplicationOrig
): Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeApplication_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplication = (
  deserialized: Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplication
): Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeApplication_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplication = (
  serialized: Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplicationOrig
): Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeApplication_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplication = (
  deserialized: Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplication
): Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application =
  | Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplication
  | Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplication
  | Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplication
export const deserializeApplication_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application = (
  serialized: Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_applicationOrig
): Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeApplication_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeApplication_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeApplication_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application'
  )
}
export const serializeApplication_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application = (
  deserialized: Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application
): Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeApplication_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeApplication_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeApplication_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application'
  )
}
export interface Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application | null
}
export const deserializeApplication_application_MonitorApplication_primaryPointOfContact_benefitOutcomes = (
  serialized: Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomesOrig
): Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeApplication_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeApplication_application_MonitorApplication_primaryPointOfContact_benefitOutcomes = (
  deserialized: Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes
): Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeApplication_application_MonitorApplication_primaryPointOfContact_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface Application_application_MonitorApplication_primaryPointOfContact_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeApplication_application_MonitorApplication_primaryPointOfContact_incomeSources_esignSession_esignWizards = (
  serialized: Application_application_MonitorApplication_primaryPointOfContact_incomeSources_esignSession_esignWizardsOrig
): Application_application_MonitorApplication_primaryPointOfContact_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeApplication_application_MonitorApplication_primaryPointOfContact_incomeSources_esignSession_esignWizards = (
  deserialized: Application_application_MonitorApplication_primaryPointOfContact_incomeSources_esignSession_esignWizards
): Application_application_MonitorApplication_primaryPointOfContact_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Application_application_MonitorApplication_primaryPointOfContact_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Application_application_MonitorApplication_primaryPointOfContact_incomeSources_esignSession_esignWizards[]
}
export const deserializeApplication_application_MonitorApplication_primaryPointOfContact_incomeSources_esignSession = (
  serialized: Application_application_MonitorApplication_primaryPointOfContact_incomeSources_esignSessionOrig
): Application_application_MonitorApplication_primaryPointOfContact_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeApplication_application_MonitorApplication_primaryPointOfContact_incomeSources_esignSession_esignWizards
  ),
})
export const serializeApplication_application_MonitorApplication_primaryPointOfContact_incomeSources_esignSession = (
  deserialized: Application_application_MonitorApplication_primaryPointOfContact_incomeSources_esignSession
): Application_application_MonitorApplication_primaryPointOfContact_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeApplication_application_MonitorApplication_primaryPointOfContact_incomeSources_esignSession_esignWizards
  ),
})
export interface Application_application_MonitorApplication_primaryPointOfContact_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: Application_application_MonitorApplication_primaryPointOfContact_incomeSources_esignSession | null
}
export const deserializeApplication_application_MonitorApplication_primaryPointOfContact_incomeSources = (
  serialized: Application_application_MonitorApplication_primaryPointOfContact_incomeSourcesOrig
): Application_application_MonitorApplication_primaryPointOfContact_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeApplication_application_MonitorApplication_primaryPointOfContact_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeApplication_application_MonitorApplication_primaryPointOfContact_incomeSources = (
  deserialized: Application_application_MonitorApplication_primaryPointOfContact_incomeSources
): Application_application_MonitorApplication_primaryPointOfContact_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeApplication_application_MonitorApplication_primaryPointOfContact_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Application_application_MonitorApplication_primaryPointOfContact_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeApplication_application_MonitorApplication_primaryPointOfContact_deductions = (
  serialized: Application_application_MonitorApplication_primaryPointOfContact_deductionsOrig
): Application_application_MonitorApplication_primaryPointOfContact_deductions => ({
  ...serialized,
})
export const serializeApplication_application_MonitorApplication_primaryPointOfContact_deductions = (
  deserialized: Application_application_MonitorApplication_primaryPointOfContact_deductions
): Application_application_MonitorApplication_primaryPointOfContact_deductionsOrig => ({
  ...deserialized,
})
export interface Application_application_MonitorApplication_primaryPointOfContact {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: Application_application_MonitorApplication_primaryPointOfContact_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: Application_application_MonitorApplication_primaryPointOfContact_benefitOutcomes[]
  incomeSources: Application_application_MonitorApplication_primaryPointOfContact_incomeSources[]
  deductions: Application_application_MonitorApplication_primaryPointOfContact_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
}
export const deserializeApplication_application_MonitorApplication_primaryPointOfContact = (
  serialized: Application_application_MonitorApplication_primaryPointOfContactOrig
): Application_application_MonitorApplication_primaryPointOfContact => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeApplication_application_MonitorApplication_primaryPointOfContact_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeApplication_application_MonitorApplication_primaryPointOfContact_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeApplication_application_MonitorApplication_primaryPointOfContact_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeApplication_application_MonitorApplication_primaryPointOfContact_deductions
  ),
})
export const serializeApplication_application_MonitorApplication_primaryPointOfContact = (
  deserialized: Application_application_MonitorApplication_primaryPointOfContact
): Application_application_MonitorApplication_primaryPointOfContactOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeApplication_application_MonitorApplication_primaryPointOfContact_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeApplication_application_MonitorApplication_primaryPointOfContact_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeApplication_application_MonitorApplication_primaryPointOfContact_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeApplication_application_MonitorApplication_primaryPointOfContact_deductions
  ),
})
export interface Application_application_MonitorApplication {
  __typename: 'MonitorApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  person: Application_application_MonitorApplication_person
  assignedTo: Application_application_MonitorApplication_assignedTo | null
  householdMembers: Application_application_MonitorApplication_householdMembers[]
  documents: Application_application_MonitorApplication_documents[]
  documentFiles: Application_application_MonitorApplication_documentFiles[]
  benefitOutcomes: Application_application_MonitorApplication_benefitOutcomes[]
  accountOnDateOfService: Application_application_MonitorApplication_accountOnDateOfService | null
  submitDate: Date | null
  applicationType: string | null
  submitMethod: string | null
  location: string | null
  countyName: string | null
  darSubmitDate: Date | null
  confirmationNumber: string | null
  policyId: string | null
  notes: string | null
  primaryPointOfContact: Application_application_MonitorApplication_primaryPointOfContact | null
  initialDateOfService: Date | null
}
export const deserializeApplication_application_MonitorApplication = (
  serialized: Application_application_MonitorApplicationOrig
): Application_application_MonitorApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  person: deserializeApplication_application_MonitorApplication_person(
    serialized.person
  ),
  assignedTo:
    serialized.assignedTo != null
      ? deserializeApplication_application_MonitorApplication_assignedTo(
          serialized.assignedTo
        )
      : serialized.assignedTo,
  householdMembers: serialized.householdMembers.map(
    deserializeApplication_application_MonitorApplication_householdMembers
  ),
  documents: serialized.documents.map(
    deserializeApplication_application_MonitorApplication_documents
  ),
  documentFiles: serialized.documentFiles.map(
    deserializeApplication_application_MonitorApplication_documentFiles
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeApplication_application_MonitorApplication_benefitOutcomes
  ),
  accountOnDateOfService:
    serialized.accountOnDateOfService != null
      ? deserializeApplication_application_MonitorApplication_accountOnDateOfService(
          serialized.accountOnDateOfService
        )
      : serialized.accountOnDateOfService,
  submitDate:
    serialized.submitDate != null
      ? parseDate(serialized.submitDate)
      : serialized.submitDate,
  darSubmitDate:
    serialized.darSubmitDate != null
      ? parseDate(serialized.darSubmitDate)
      : serialized.darSubmitDate,
  primaryPointOfContact:
    serialized.primaryPointOfContact != null
      ? deserializeApplication_application_MonitorApplication_primaryPointOfContact(
          serialized.primaryPointOfContact
        )
      : serialized.primaryPointOfContact,
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
})
export const serializeApplication_application_MonitorApplication = (
  deserialized: Application_application_MonitorApplication
): Application_application_MonitorApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  person: serializeApplication_application_MonitorApplication_person(
    deserialized.person
  ),
  assignedTo:
    deserialized.assignedTo != null
      ? serializeApplication_application_MonitorApplication_assignedTo(
          deserialized.assignedTo
        )
      : deserialized.assignedTo,
  householdMembers: deserialized.householdMembers.map(
    serializeApplication_application_MonitorApplication_householdMembers
  ),
  documents: deserialized.documents.map(
    serializeApplication_application_MonitorApplication_documents
  ),
  documentFiles: deserialized.documentFiles.map(
    serializeApplication_application_MonitorApplication_documentFiles
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeApplication_application_MonitorApplication_benefitOutcomes
  ),
  accountOnDateOfService:
    deserialized.accountOnDateOfService != null
      ? serializeApplication_application_MonitorApplication_accountOnDateOfService(
          deserialized.accountOnDateOfService
        )
      : deserialized.accountOnDateOfService,
  submitDate:
    deserialized.submitDate != null
      ? formatISODate(deserialized.submitDate)
      : deserialized.submitDate,
  darSubmitDate:
    deserialized.darSubmitDate != null
      ? formatISODate(deserialized.darSubmitDate)
      : deserialized.darSubmitDate,
  primaryPointOfContact:
    deserialized.primaryPointOfContact != null
      ? serializeApplication_application_MonitorApplication_primaryPointOfContact(
          deserialized.primaryPointOfContact
        )
      : deserialized.primaryPointOfContact,
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
})
export interface Application_application_CharityCareApplication_person_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeApplication_application_CharityCareApplication_person_phoneNumbers_esignSession_esignWizards = (
  serialized: Application_application_CharityCareApplication_person_phoneNumbers_esignSession_esignWizardsOrig
): Application_application_CharityCareApplication_person_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeApplication_application_CharityCareApplication_person_phoneNumbers_esignSession_esignWizards = (
  deserialized: Application_application_CharityCareApplication_person_phoneNumbers_esignSession_esignWizards
): Application_application_CharityCareApplication_person_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Application_application_CharityCareApplication_person_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Application_application_CharityCareApplication_person_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeApplication_application_CharityCareApplication_person_phoneNumbers_esignSession = (
  serialized: Application_application_CharityCareApplication_person_phoneNumbers_esignSessionOrig
): Application_application_CharityCareApplication_person_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeApplication_application_CharityCareApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeApplication_application_CharityCareApplication_person_phoneNumbers_esignSession = (
  deserialized: Application_application_CharityCareApplication_person_phoneNumbers_esignSession
): Application_application_CharityCareApplication_person_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeApplication_application_CharityCareApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export interface Application_application_CharityCareApplication_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: Application_application_CharityCareApplication_person_phoneNumbers_esignSession | null
}
export const deserializeApplication_application_CharityCareApplication_person_phoneNumbers = (
  serialized: Application_application_CharityCareApplication_person_phoneNumbersOrig
): Application_application_CharityCareApplication_person_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeApplication_application_CharityCareApplication_person_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeApplication_application_CharityCareApplication_person_phoneNumbers = (
  deserialized: Application_application_CharityCareApplication_person_phoneNumbers
): Application_application_CharityCareApplication_person_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeApplication_application_CharityCareApplication_person_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Application_application_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeApplication_application_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplication = (
  serialized: Application_application_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplicationOrig
): Application_application_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeApplication_application_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplication = (
  deserialized: Application_application_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplication
): Application_application_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface Application_application_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeApplication_application_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplication = (
  serialized: Application_application_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplicationOrig
): Application_application_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeApplication_application_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplication = (
  deserialized: Application_application_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplication
): Application_application_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface Application_application_CharityCareApplication_person_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeApplication_application_CharityCareApplication_person_benefitOutcomes_application_SlideApplication = (
  serialized: Application_application_CharityCareApplication_person_benefitOutcomes_application_SlideApplicationOrig
): Application_application_CharityCareApplication_person_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeApplication_application_CharityCareApplication_person_benefitOutcomes_application_SlideApplication = (
  deserialized: Application_application_CharityCareApplication_person_benefitOutcomes_application_SlideApplication
): Application_application_CharityCareApplication_person_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type Application_application_CharityCareApplication_person_benefitOutcomes_application =
  | Application_application_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplication
  | Application_application_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplication
  | Application_application_CharityCareApplication_person_benefitOutcomes_application_SlideApplication
export const deserializeApplication_application_CharityCareApplication_person_benefitOutcomes_application = (
  serialized: Application_application_CharityCareApplication_person_benefitOutcomes_applicationOrig
): Application_application_CharityCareApplication_person_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeApplication_application_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeApplication_application_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeApplication_application_CharityCareApplication_person_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Application_application_CharityCareApplication_person_benefitOutcomes_application'
  )
}
export const serializeApplication_application_CharityCareApplication_person_benefitOutcomes_application = (
  deserialized: Application_application_CharityCareApplication_person_benefitOutcomes_application
): Application_application_CharityCareApplication_person_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeApplication_application_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeApplication_application_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeApplication_application_CharityCareApplication_person_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Application_application_CharityCareApplication_person_benefitOutcomes_application'
  )
}
export interface Application_application_CharityCareApplication_person_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: Application_application_CharityCareApplication_person_benefitOutcomes_application | null
}
export const deserializeApplication_application_CharityCareApplication_person_benefitOutcomes = (
  serialized: Application_application_CharityCareApplication_person_benefitOutcomesOrig
): Application_application_CharityCareApplication_person_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeApplication_application_CharityCareApplication_person_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeApplication_application_CharityCareApplication_person_benefitOutcomes = (
  deserialized: Application_application_CharityCareApplication_person_benefitOutcomes
): Application_application_CharityCareApplication_person_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeApplication_application_CharityCareApplication_person_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface Application_application_CharityCareApplication_person_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeApplication_application_CharityCareApplication_person_incomeSources_esignSession_esignWizards = (
  serialized: Application_application_CharityCareApplication_person_incomeSources_esignSession_esignWizardsOrig
): Application_application_CharityCareApplication_person_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeApplication_application_CharityCareApplication_person_incomeSources_esignSession_esignWizards = (
  deserialized: Application_application_CharityCareApplication_person_incomeSources_esignSession_esignWizards
): Application_application_CharityCareApplication_person_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Application_application_CharityCareApplication_person_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Application_application_CharityCareApplication_person_incomeSources_esignSession_esignWizards[]
}
export const deserializeApplication_application_CharityCareApplication_person_incomeSources_esignSession = (
  serialized: Application_application_CharityCareApplication_person_incomeSources_esignSessionOrig
): Application_application_CharityCareApplication_person_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeApplication_application_CharityCareApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export const serializeApplication_application_CharityCareApplication_person_incomeSources_esignSession = (
  deserialized: Application_application_CharityCareApplication_person_incomeSources_esignSession
): Application_application_CharityCareApplication_person_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeApplication_application_CharityCareApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export interface Application_application_CharityCareApplication_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: Application_application_CharityCareApplication_person_incomeSources_esignSession | null
}
export const deserializeApplication_application_CharityCareApplication_person_incomeSources = (
  serialized: Application_application_CharityCareApplication_person_incomeSourcesOrig
): Application_application_CharityCareApplication_person_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeApplication_application_CharityCareApplication_person_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeApplication_application_CharityCareApplication_person_incomeSources = (
  deserialized: Application_application_CharityCareApplication_person_incomeSources
): Application_application_CharityCareApplication_person_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeApplication_application_CharityCareApplication_person_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Application_application_CharityCareApplication_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeApplication_application_CharityCareApplication_person_deductions = (
  serialized: Application_application_CharityCareApplication_person_deductionsOrig
): Application_application_CharityCareApplication_person_deductions => ({
  ...serialized,
})
export const serializeApplication_application_CharityCareApplication_person_deductions = (
  deserialized: Application_application_CharityCareApplication_person_deductions
): Application_application_CharityCareApplication_person_deductionsOrig => ({
  ...deserialized,
})
export interface Application_application_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeApplication_application_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards = (
  serialized: Application_application_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizardsOrig
): Application_application_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeApplication_application_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards = (
  deserialized: Application_application_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards
): Application_application_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Application_application_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Application_application_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeApplication_application_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession = (
  serialized: Application_application_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSessionOrig
): Application_application_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeApplication_application_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeApplication_application_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession = (
  deserialized: Application_application_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession
): Application_application_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeApplication_application_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards
  ),
})
export interface Application_application_CharityCareApplication_person_relationships_otherPerson_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: Application_application_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession | null
}
export const deserializeApplication_application_CharityCareApplication_person_relationships_otherPerson_phoneNumbers = (
  serialized: Application_application_CharityCareApplication_person_relationships_otherPerson_phoneNumbersOrig
): Application_application_CharityCareApplication_person_relationships_otherPerson_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeApplication_application_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeApplication_application_CharityCareApplication_person_relationships_otherPerson_phoneNumbers = (
  deserialized: Application_application_CharityCareApplication_person_relationships_otherPerson_phoneNumbers
): Application_application_CharityCareApplication_person_relationships_otherPerson_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeApplication_application_CharityCareApplication_person_relationships_otherPerson_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeApplication_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication = (
  serialized: Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplicationOrig
): Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeApplication_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication = (
  deserialized: Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication
): Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeApplication_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication = (
  serialized: Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplicationOrig
): Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeApplication_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication = (
  deserialized: Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication
): Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeApplication_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication = (
  serialized: Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplicationOrig
): Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeApplication_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication = (
  deserialized: Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication
): Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application =
  | Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication
  | Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication
  | Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication
export const deserializeApplication_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application = (
  serialized: Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_applicationOrig
): Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeApplication_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeApplication_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeApplication_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application'
  )
}
export const serializeApplication_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application = (
  deserialized: Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application
): Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeApplication_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeApplication_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeApplication_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application'
  )
}
export interface Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application | null
}
export const deserializeApplication_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes = (
  serialized: Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomesOrig
): Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeApplication_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeApplication_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes = (
  deserialized: Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes
): Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeApplication_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface Application_application_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeApplication_application_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards = (
  serialized: Application_application_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizardsOrig
): Application_application_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeApplication_application_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards = (
  deserialized: Application_application_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards
): Application_application_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Application_application_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Application_application_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards[]
}
export const deserializeApplication_application_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession = (
  serialized: Application_application_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSessionOrig
): Application_application_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeApplication_application_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards
  ),
})
export const serializeApplication_application_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession = (
  deserialized: Application_application_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession
): Application_application_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeApplication_application_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards
  ),
})
export interface Application_application_CharityCareApplication_person_relationships_otherPerson_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: Application_application_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession | null
}
export const deserializeApplication_application_CharityCareApplication_person_relationships_otherPerson_incomeSources = (
  serialized: Application_application_CharityCareApplication_person_relationships_otherPerson_incomeSourcesOrig
): Application_application_CharityCareApplication_person_relationships_otherPerson_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeApplication_application_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeApplication_application_CharityCareApplication_person_relationships_otherPerson_incomeSources = (
  deserialized: Application_application_CharityCareApplication_person_relationships_otherPerson_incomeSources
): Application_application_CharityCareApplication_person_relationships_otherPerson_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeApplication_application_CharityCareApplication_person_relationships_otherPerson_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Application_application_CharityCareApplication_person_relationships_otherPerson_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeApplication_application_CharityCareApplication_person_relationships_otherPerson_deductions = (
  serialized: Application_application_CharityCareApplication_person_relationships_otherPerson_deductionsOrig
): Application_application_CharityCareApplication_person_relationships_otherPerson_deductions => ({
  ...serialized,
})
export const serializeApplication_application_CharityCareApplication_person_relationships_otherPerson_deductions = (
  deserialized: Application_application_CharityCareApplication_person_relationships_otherPerson_deductions
): Application_application_CharityCareApplication_person_relationships_otherPerson_deductionsOrig => ({
  ...deserialized,
})
export interface Application_application_CharityCareApplication_person_relationships_otherPerson {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: Application_application_CharityCareApplication_person_relationships_otherPerson_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: Application_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes[]
  incomeSources: Application_application_CharityCareApplication_person_relationships_otherPerson_incomeSources[]
  deductions: Application_application_CharityCareApplication_person_relationships_otherPerson_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
}
export const deserializeApplication_application_CharityCareApplication_person_relationships_otherPerson = (
  serialized: Application_application_CharityCareApplication_person_relationships_otherPersonOrig
): Application_application_CharityCareApplication_person_relationships_otherPerson => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeApplication_application_CharityCareApplication_person_relationships_otherPerson_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeApplication_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeApplication_application_CharityCareApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeApplication_application_CharityCareApplication_person_relationships_otherPerson_deductions
  ),
})
export const serializeApplication_application_CharityCareApplication_person_relationships_otherPerson = (
  deserialized: Application_application_CharityCareApplication_person_relationships_otherPerson
): Application_application_CharityCareApplication_person_relationships_otherPersonOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeApplication_application_CharityCareApplication_person_relationships_otherPerson_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeApplication_application_CharityCareApplication_person_relationships_otherPerson_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeApplication_application_CharityCareApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeApplication_application_CharityCareApplication_person_relationships_otherPerson_deductions
  ),
})
export interface Application_application_CharityCareApplication_person_relationships {
  __typename: 'Relationship'
  id: string
  relationshipType: string | null
  reverseRelationshipType: string | null
  liveTogether: boolean | null
  otherPerson: Application_application_CharityCareApplication_person_relationships_otherPerson
}
export const deserializeApplication_application_CharityCareApplication_person_relationships = (
  serialized: Application_application_CharityCareApplication_person_relationshipsOrig
): Application_application_CharityCareApplication_person_relationships => ({
  ...serialized,
  otherPerson: deserializeApplication_application_CharityCareApplication_person_relationships_otherPerson(
    serialized.otherPerson
  ),
})
export const serializeApplication_application_CharityCareApplication_person_relationships = (
  deserialized: Application_application_CharityCareApplication_person_relationships
): Application_application_CharityCareApplication_person_relationshipsOrig => ({
  ...deserialized,
  otherPerson: serializeApplication_application_CharityCareApplication_person_relationships_otherPerson(
    deserialized.otherPerson
  ),
})
export interface Application_application_CharityCareApplication_person_documentFiles {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeApplication_application_CharityCareApplication_person_documentFiles = (
  serialized: Application_application_CharityCareApplication_person_documentFilesOrig
): Application_application_CharityCareApplication_person_documentFiles => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeApplication_application_CharityCareApplication_person_documentFiles = (
  deserialized: Application_application_CharityCareApplication_person_documentFiles
): Application_application_CharityCareApplication_person_documentFilesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface Application_application_CharityCareApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializeApplication_application_CharityCareApplication_person_openApplications_MedicaidApplication = (
  serialized: Application_application_CharityCareApplication_person_openApplications_MedicaidApplicationOrig
): Application_application_CharityCareApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeApplication_application_CharityCareApplication_person_openApplications_MedicaidApplication = (
  deserialized: Application_application_CharityCareApplication_person_openApplications_MedicaidApplication
): Application_application_CharityCareApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Application_application_CharityCareApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeApplication_application_CharityCareApplication_person_openApplications_CharityCareApplication = (
  serialized: Application_application_CharityCareApplication_person_openApplications_CharityCareApplicationOrig
): Application_application_CharityCareApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeApplication_application_CharityCareApplication_person_openApplications_CharityCareApplication = (
  deserialized: Application_application_CharityCareApplication_person_openApplications_CharityCareApplication
): Application_application_CharityCareApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Application_application_CharityCareApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeApplication_application_CharityCareApplication_person_openApplications_SlideApplication = (
  serialized: Application_application_CharityCareApplication_person_openApplications_SlideApplicationOrig
): Application_application_CharityCareApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeApplication_application_CharityCareApplication_person_openApplications_SlideApplication = (
  deserialized: Application_application_CharityCareApplication_person_openApplications_SlideApplication
): Application_application_CharityCareApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Application_application_CharityCareApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeApplication_application_CharityCareApplication_person_openApplications_RyanWhiteApplication = (
  serialized: Application_application_CharityCareApplication_person_openApplications_RyanWhiteApplicationOrig
): Application_application_CharityCareApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeApplication_application_CharityCareApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: Application_application_CharityCareApplication_person_openApplications_RyanWhiteApplication
): Application_application_CharityCareApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type Application_application_CharityCareApplication_person_openApplications =
  | Application_application_CharityCareApplication_person_openApplications_MedicaidApplication
  | Application_application_CharityCareApplication_person_openApplications_CharityCareApplication
  | Application_application_CharityCareApplication_person_openApplications_SlideApplication
  | Application_application_CharityCareApplication_person_openApplications_RyanWhiteApplication
export const deserializeApplication_application_CharityCareApplication_person_openApplications = (
  serialized: Application_application_CharityCareApplication_person_openApplicationsOrig
): Application_application_CharityCareApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializeApplication_application_CharityCareApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeApplication_application_CharityCareApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeApplication_application_CharityCareApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeApplication_application_CharityCareApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Application_application_CharityCareApplication_person_openApplications'
  )
}
export const serializeApplication_application_CharityCareApplication_person_openApplications = (
  deserialized: Application_application_CharityCareApplication_person_openApplications
): Application_application_CharityCareApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializeApplication_application_CharityCareApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeApplication_application_CharityCareApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeApplication_application_CharityCareApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeApplication_application_CharityCareApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Application_application_CharityCareApplication_person_openApplications'
  )
}
export interface Application_application_CharityCareApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializeApplication_application_CharityCareApplication_person_openHouseholdMemberApplications = (
  serialized: Application_application_CharityCareApplication_person_openHouseholdMemberApplicationsOrig
): Application_application_CharityCareApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeApplication_application_CharityCareApplication_person_openHouseholdMemberApplications = (
  deserialized: Application_application_CharityCareApplication_person_openHouseholdMemberApplications
): Application_application_CharityCareApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Application_application_CharityCareApplication_person {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: Application_application_CharityCareApplication_person_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: Application_application_CharityCareApplication_person_benefitOutcomes[]
  incomeSources: Application_application_CharityCareApplication_person_incomeSources[]
  deductions: Application_application_CharityCareApplication_person_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
  relationships: Application_application_CharityCareApplication_person_relationships[]
  documentFiles: Application_application_CharityCareApplication_person_documentFiles[]
  openApplications: Application_application_CharityCareApplication_person_openApplications[]
  openHouseholdMemberApplications: Application_application_CharityCareApplication_person_openHouseholdMemberApplications[]
}
export const deserializeApplication_application_CharityCareApplication_person = (
  serialized: Application_application_CharityCareApplication_personOrig
): Application_application_CharityCareApplication_person => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeApplication_application_CharityCareApplication_person_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeApplication_application_CharityCareApplication_person_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeApplication_application_CharityCareApplication_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeApplication_application_CharityCareApplication_person_deductions
  ),
  relationships: serialized.relationships.map(
    deserializeApplication_application_CharityCareApplication_person_relationships
  ),
  documentFiles: serialized.documentFiles.map(
    deserializeApplication_application_CharityCareApplication_person_documentFiles
  ),
  openApplications: serialized.openApplications.map(
    deserializeApplication_application_CharityCareApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializeApplication_application_CharityCareApplication_person_openHouseholdMemberApplications
  ),
})
export const serializeApplication_application_CharityCareApplication_person = (
  deserialized: Application_application_CharityCareApplication_person
): Application_application_CharityCareApplication_personOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeApplication_application_CharityCareApplication_person_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeApplication_application_CharityCareApplication_person_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeApplication_application_CharityCareApplication_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeApplication_application_CharityCareApplication_person_deductions
  ),
  relationships: deserialized.relationships.map(
    serializeApplication_application_CharityCareApplication_person_relationships
  ),
  documentFiles: deserialized.documentFiles.map(
    serializeApplication_application_CharityCareApplication_person_documentFiles
  ),
  openApplications: deserialized.openApplications.map(
    serializeApplication_application_CharityCareApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializeApplication_application_CharityCareApplication_person_openHouseholdMemberApplications
  ),
})
export interface Application_application_CharityCareApplication_assignedTo {
  __typename: 'User'
  id: string
  email: string
  name: string | null
  isCurrentUser: boolean
}
export const deserializeApplication_application_CharityCareApplication_assignedTo = (
  serialized: Application_application_CharityCareApplication_assignedToOrig
): Application_application_CharityCareApplication_assignedTo => ({
  ...serialized,
})
export const serializeApplication_application_CharityCareApplication_assignedTo = (
  deserialized: Application_application_CharityCareApplication_assignedTo
): Application_application_CharityCareApplication_assignedToOrig => ({
  ...deserialized,
})
export interface Application_application_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeApplication_application_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards = (
  serialized: Application_application_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession_esignWizardsOrig
): Application_application_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeApplication_application_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards = (
  deserialized: Application_application_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards
): Application_application_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Application_application_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Application_application_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeApplication_application_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession = (
  serialized: Application_application_CharityCareApplication_householdMembers_person_phoneNumbers_esignSessionOrig
): Application_application_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeApplication_application_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeApplication_application_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession = (
  deserialized: Application_application_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession
): Application_application_CharityCareApplication_householdMembers_person_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeApplication_application_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards
  ),
})
export interface Application_application_CharityCareApplication_householdMembers_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: Application_application_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession | null
}
export const deserializeApplication_application_CharityCareApplication_householdMembers_person_phoneNumbers = (
  serialized: Application_application_CharityCareApplication_householdMembers_person_phoneNumbersOrig
): Application_application_CharityCareApplication_householdMembers_person_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeApplication_application_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeApplication_application_CharityCareApplication_householdMembers_person_phoneNumbers = (
  deserialized: Application_application_CharityCareApplication_householdMembers_person_phoneNumbers
): Application_application_CharityCareApplication_householdMembers_person_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeApplication_application_CharityCareApplication_householdMembers_person_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeApplication_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication = (
  serialized: Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplicationOrig
): Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeApplication_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication = (
  deserialized: Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication
): Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeApplication_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication = (
  serialized: Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplicationOrig
): Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeApplication_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication = (
  deserialized: Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication
): Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeApplication_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application_SlideApplication = (
  serialized: Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application_SlideApplicationOrig
): Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeApplication_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application_SlideApplication = (
  deserialized: Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application_SlideApplication
): Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application =
  | Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication
  | Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication
  | Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application_SlideApplication
export const deserializeApplication_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application = (
  serialized: Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes_applicationOrig
): Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeApplication_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeApplication_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeApplication_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application'
  )
}
export const serializeApplication_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application = (
  deserialized: Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application
): Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeApplication_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeApplication_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeApplication_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application'
  )
}
export interface Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application | null
}
export const deserializeApplication_application_CharityCareApplication_householdMembers_person_benefitOutcomes = (
  serialized: Application_application_CharityCareApplication_householdMembers_person_benefitOutcomesOrig
): Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeApplication_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeApplication_application_CharityCareApplication_householdMembers_person_benefitOutcomes = (
  deserialized: Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes
): Application_application_CharityCareApplication_householdMembers_person_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeApplication_application_CharityCareApplication_householdMembers_person_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface Application_application_CharityCareApplication_householdMembers_person_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeApplication_application_CharityCareApplication_householdMembers_person_incomeSources_esignSession_esignWizards = (
  serialized: Application_application_CharityCareApplication_householdMembers_person_incomeSources_esignSession_esignWizardsOrig
): Application_application_CharityCareApplication_householdMembers_person_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeApplication_application_CharityCareApplication_householdMembers_person_incomeSources_esignSession_esignWizards = (
  deserialized: Application_application_CharityCareApplication_householdMembers_person_incomeSources_esignSession_esignWizards
): Application_application_CharityCareApplication_householdMembers_person_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Application_application_CharityCareApplication_householdMembers_person_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Application_application_CharityCareApplication_householdMembers_person_incomeSources_esignSession_esignWizards[]
}
export const deserializeApplication_application_CharityCareApplication_householdMembers_person_incomeSources_esignSession = (
  serialized: Application_application_CharityCareApplication_householdMembers_person_incomeSources_esignSessionOrig
): Application_application_CharityCareApplication_householdMembers_person_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeApplication_application_CharityCareApplication_householdMembers_person_incomeSources_esignSession_esignWizards
  ),
})
export const serializeApplication_application_CharityCareApplication_householdMembers_person_incomeSources_esignSession = (
  deserialized: Application_application_CharityCareApplication_householdMembers_person_incomeSources_esignSession
): Application_application_CharityCareApplication_householdMembers_person_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeApplication_application_CharityCareApplication_householdMembers_person_incomeSources_esignSession_esignWizards
  ),
})
export interface Application_application_CharityCareApplication_householdMembers_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: Application_application_CharityCareApplication_householdMembers_person_incomeSources_esignSession | null
}
export const deserializeApplication_application_CharityCareApplication_householdMembers_person_incomeSources = (
  serialized: Application_application_CharityCareApplication_householdMembers_person_incomeSourcesOrig
): Application_application_CharityCareApplication_householdMembers_person_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeApplication_application_CharityCareApplication_householdMembers_person_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeApplication_application_CharityCareApplication_householdMembers_person_incomeSources = (
  deserialized: Application_application_CharityCareApplication_householdMembers_person_incomeSources
): Application_application_CharityCareApplication_householdMembers_person_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeApplication_application_CharityCareApplication_householdMembers_person_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Application_application_CharityCareApplication_householdMembers_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeApplication_application_CharityCareApplication_householdMembers_person_deductions = (
  serialized: Application_application_CharityCareApplication_householdMembers_person_deductionsOrig
): Application_application_CharityCareApplication_householdMembers_person_deductions => ({
  ...serialized,
})
export const serializeApplication_application_CharityCareApplication_householdMembers_person_deductions = (
  deserialized: Application_application_CharityCareApplication_householdMembers_person_deductions
): Application_application_CharityCareApplication_householdMembers_person_deductionsOrig => ({
  ...deserialized,
})
export interface Application_application_CharityCareApplication_householdMembers_person_documentFiles {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeApplication_application_CharityCareApplication_householdMembers_person_documentFiles = (
  serialized: Application_application_CharityCareApplication_householdMembers_person_documentFilesOrig
): Application_application_CharityCareApplication_householdMembers_person_documentFiles => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeApplication_application_CharityCareApplication_householdMembers_person_documentFiles = (
  deserialized: Application_application_CharityCareApplication_householdMembers_person_documentFiles
): Application_application_CharityCareApplication_householdMembers_person_documentFilesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface Application_application_CharityCareApplication_householdMembers_person {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: Application_application_CharityCareApplication_householdMembers_person_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: Application_application_CharityCareApplication_householdMembers_person_benefitOutcomes[]
  incomeSources: Application_application_CharityCareApplication_householdMembers_person_incomeSources[]
  deductions: Application_application_CharityCareApplication_householdMembers_person_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
  documentFiles: Application_application_CharityCareApplication_householdMembers_person_documentFiles[]
}
export const deserializeApplication_application_CharityCareApplication_householdMembers_person = (
  serialized: Application_application_CharityCareApplication_householdMembers_personOrig
): Application_application_CharityCareApplication_householdMembers_person => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeApplication_application_CharityCareApplication_householdMembers_person_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeApplication_application_CharityCareApplication_householdMembers_person_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeApplication_application_CharityCareApplication_householdMembers_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeApplication_application_CharityCareApplication_householdMembers_person_deductions
  ),
  documentFiles: serialized.documentFiles.map(
    deserializeApplication_application_CharityCareApplication_householdMembers_person_documentFiles
  ),
})
export const serializeApplication_application_CharityCareApplication_householdMembers_person = (
  deserialized: Application_application_CharityCareApplication_householdMembers_person
): Application_application_CharityCareApplication_householdMembers_personOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeApplication_application_CharityCareApplication_householdMembers_person_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeApplication_application_CharityCareApplication_householdMembers_person_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeApplication_application_CharityCareApplication_householdMembers_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeApplication_application_CharityCareApplication_householdMembers_person_deductions
  ),
  documentFiles: deserialized.documentFiles.map(
    serializeApplication_application_CharityCareApplication_householdMembers_person_documentFiles
  ),
})
export interface Application_application_CharityCareApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  wantsCoverage: boolean | null
  person: Application_application_CharityCareApplication_householdMembers_person
  createdAt: Date
}
export const deserializeApplication_application_CharityCareApplication_householdMembers = (
  serialized: Application_application_CharityCareApplication_householdMembersOrig
): Application_application_CharityCareApplication_householdMembers => ({
  ...serialized,
  person: deserializeApplication_application_CharityCareApplication_householdMembers_person(
    serialized.person
  ),
  createdAt: parseDate(serialized.createdAt),
})
export const serializeApplication_application_CharityCareApplication_householdMembers = (
  deserialized: Application_application_CharityCareApplication_householdMembers
): Application_application_CharityCareApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializeApplication_application_CharityCareApplication_householdMembers_person(
    deserialized.person
  ),
  createdAt: formatISO(deserialized.createdAt),
})
export interface Application_application_CharityCareApplication_documents_files {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeApplication_application_CharityCareApplication_documents_files = (
  serialized: Application_application_CharityCareApplication_documents_filesOrig
): Application_application_CharityCareApplication_documents_files => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeApplication_application_CharityCareApplication_documents_files = (
  deserialized: Application_application_CharityCareApplication_documents_files
): Application_application_CharityCareApplication_documents_filesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface Application_application_CharityCareApplication_documents_person {
  __typename: 'Person'
  id: string
}
export const deserializeApplication_application_CharityCareApplication_documents_person = (
  serialized: Application_application_CharityCareApplication_documents_personOrig
): Application_application_CharityCareApplication_documents_person => ({
  ...serialized,
})
export const serializeApplication_application_CharityCareApplication_documents_person = (
  deserialized: Application_application_CharityCareApplication_documents_person
): Application_application_CharityCareApplication_documents_personOrig => ({
  ...deserialized,
})
export interface Application_application_CharityCareApplication_documents_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializeApplication_application_CharityCareApplication_documents_application = (
  serialized: Application_application_CharityCareApplication_documents_applicationOrig
): Application_application_CharityCareApplication_documents_application => ({
  ...serialized,
})
export const serializeApplication_application_CharityCareApplication_documents_application = (
  deserialized: Application_application_CharityCareApplication_documents_application
): Application_application_CharityCareApplication_documents_applicationOrig => ({
  ...deserialized,
})
export interface Application_application_CharityCareApplication_documents {
  __typename: 'Document'
  id: string
  documentType: string
  complete: boolean | null
  files: Application_application_CharityCareApplication_documents_files[]
  updatedAt: Date
  notes: string | null
  person: Application_application_CharityCareApplication_documents_person | null
  application: Application_application_CharityCareApplication_documents_application
}
export const deserializeApplication_application_CharityCareApplication_documents = (
  serialized: Application_application_CharityCareApplication_documentsOrig
): Application_application_CharityCareApplication_documents => ({
  ...serialized,
  files: serialized.files.map(
    deserializeApplication_application_CharityCareApplication_documents_files
  ),
  updatedAt: parseDate(serialized.updatedAt),
  person:
    serialized.person != null
      ? deserializeApplication_application_CharityCareApplication_documents_person(
          serialized.person
        )
      : serialized.person,
  application: deserializeApplication_application_CharityCareApplication_documents_application(
    serialized.application
  ),
})
export const serializeApplication_application_CharityCareApplication_documents = (
  deserialized: Application_application_CharityCareApplication_documents
): Application_application_CharityCareApplication_documentsOrig => ({
  ...deserialized,
  files: deserialized.files.map(
    serializeApplication_application_CharityCareApplication_documents_files
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  person:
    deserialized.person != null
      ? serializeApplication_application_CharityCareApplication_documents_person(
          deserialized.person
        )
      : deserialized.person,
  application: serializeApplication_application_CharityCareApplication_documents_application(
    deserialized.application
  ),
})
export interface Application_application_CharityCareApplication_documentFiles_documents {
  __typename: 'Document'
  id: string
}
export const deserializeApplication_application_CharityCareApplication_documentFiles_documents = (
  serialized: Application_application_CharityCareApplication_documentFiles_documentsOrig
): Application_application_CharityCareApplication_documentFiles_documents => ({
  ...serialized,
})
export const serializeApplication_application_CharityCareApplication_documentFiles_documents = (
  deserialized: Application_application_CharityCareApplication_documentFiles_documents
): Application_application_CharityCareApplication_documentFiles_documentsOrig => ({
  ...deserialized,
})
export interface Application_application_CharityCareApplication_documentFiles {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
  documents: Application_application_CharityCareApplication_documentFiles_documents[]
}
export const deserializeApplication_application_CharityCareApplication_documentFiles = (
  serialized: Application_application_CharityCareApplication_documentFilesOrig
): Application_application_CharityCareApplication_documentFiles => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
  documents: serialized.documents.map(
    deserializeApplication_application_CharityCareApplication_documentFiles_documents
  ),
})
export const serializeApplication_application_CharityCareApplication_documentFiles = (
  deserialized: Application_application_CharityCareApplication_documentFiles
): Application_application_CharityCareApplication_documentFilesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
  documents: deserialized.documents.map(
    serializeApplication_application_CharityCareApplication_documentFiles_documents
  ),
})
export interface Application_application_CharityCareApplication_benefitOutcomes_person {
  __typename: 'Person'
  id: string
}
export const deserializeApplication_application_CharityCareApplication_benefitOutcomes_person = (
  serialized: Application_application_CharityCareApplication_benefitOutcomes_personOrig
): Application_application_CharityCareApplication_benefitOutcomes_person => ({
  ...serialized,
})
export const serializeApplication_application_CharityCareApplication_benefitOutcomes_person = (
  deserialized: Application_application_CharityCareApplication_benefitOutcomes_person
): Application_application_CharityCareApplication_benefitOutcomes_personOrig => ({
  ...deserialized,
})
export interface Application_application_CharityCareApplication_benefitOutcomes_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializeApplication_application_CharityCareApplication_benefitOutcomes_application = (
  serialized: Application_application_CharityCareApplication_benefitOutcomes_applicationOrig
): Application_application_CharityCareApplication_benefitOutcomes_application => ({
  ...serialized,
})
export const serializeApplication_application_CharityCareApplication_benefitOutcomes_application = (
  deserialized: Application_application_CharityCareApplication_benefitOutcomes_application
): Application_application_CharityCareApplication_benefitOutcomes_applicationOrig => ({
  ...deserialized,
})
export interface Application_application_CharityCareApplication_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  person: Application_application_CharityCareApplication_benefitOutcomes_person
  application: Application_application_CharityCareApplication_benefitOutcomes_application | null
}
export const deserializeApplication_application_CharityCareApplication_benefitOutcomes = (
  serialized: Application_application_CharityCareApplication_benefitOutcomesOrig
): Application_application_CharityCareApplication_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  person: deserializeApplication_application_CharityCareApplication_benefitOutcomes_person(
    serialized.person
  ),
  application:
    serialized.application != null
      ? deserializeApplication_application_CharityCareApplication_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeApplication_application_CharityCareApplication_benefitOutcomes = (
  deserialized: Application_application_CharityCareApplication_benefitOutcomes
): Application_application_CharityCareApplication_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  person: serializeApplication_application_CharityCareApplication_benefitOutcomes_person(
    deserialized.person
  ),
  application:
    deserialized.application != null
      ? serializeApplication_application_CharityCareApplication_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface Application_application_CharityCareApplication_accountOnDateOfService {
  __typename: 'Account'
  id: string
  hospitalAccountId: string | null
  dateOfService: Date
  timeOfService: string | null
  serviceTimeZone: string
  facility: string
  department: string
  location: string | null
  insuranceType: string
  status: string
  createdAt: Date
  updatedAt: Date
  notes: string | null
  accountAmount: number | null
  njmmisCheck: string | null
  previousInsurance: string | null
  invoiceMonth: string | null
  invoiceYear: string | null
  dischargeDate: Date | null
  isScheduled: boolean
}
export const deserializeApplication_application_CharityCareApplication_accountOnDateOfService = (
  serialized: Application_application_CharityCareApplication_accountOnDateOfServiceOrig
): Application_application_CharityCareApplication_accountOnDateOfService => ({
  ...serialized,
  dateOfService: parseDate(serialized.dateOfService),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  njmmisCheck:
    serialized.njmmisCheck != null
      ? deserializeNjmmisCheckResult(serialized.njmmisCheck)
      : serialized.njmmisCheck,
  dischargeDate:
    serialized.dischargeDate != null
      ? parseDate(serialized.dischargeDate)
      : serialized.dischargeDate,
})
export const serializeApplication_application_CharityCareApplication_accountOnDateOfService = (
  deserialized: Application_application_CharityCareApplication_accountOnDateOfService
): Application_application_CharityCareApplication_accountOnDateOfServiceOrig => ({
  ...deserialized,
  dateOfService: formatISODate(deserialized.dateOfService),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  njmmisCheck:
    deserialized.njmmisCheck != null
      ? serializeNjmmisCheckResult(deserialized.njmmisCheck)
      : deserialized.njmmisCheck,
  dischargeDate:
    deserialized.dischargeDate != null
      ? formatISODate(deserialized.dischargeDate)
      : deserialized.dischargeDate,
})
export interface Application_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  person: Application_application_CharityCareApplication_person
  assignedTo: Application_application_CharityCareApplication_assignedTo | null
  householdMembers: Application_application_CharityCareApplication_householdMembers[]
  documents: Application_application_CharityCareApplication_documents[]
  documentFiles: Application_application_CharityCareApplication_documentFiles[]
  benefitOutcomes: Application_application_CharityCareApplication_benefitOutcomes[]
  accountOnDateOfService: Application_application_CharityCareApplication_accountOnDateOfService | null
  initialDateOfService: Date | null
  dateOfApplication: Date | null
  requestedDateOfApplication: Date | null
  notes: string | null
  facility: string
  coveragePeriod: number | null
  charityCareType: string
}
export const deserializeApplication_application_CharityCareApplication = (
  serialized: Application_application_CharityCareApplicationOrig
): Application_application_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  person: deserializeApplication_application_CharityCareApplication_person(
    serialized.person
  ),
  assignedTo:
    serialized.assignedTo != null
      ? deserializeApplication_application_CharityCareApplication_assignedTo(
          serialized.assignedTo
        )
      : serialized.assignedTo,
  householdMembers: serialized.householdMembers.map(
    deserializeApplication_application_CharityCareApplication_householdMembers
  ),
  documents: serialized.documents.map(
    deserializeApplication_application_CharityCareApplication_documents
  ),
  documentFiles: serialized.documentFiles.map(
    deserializeApplication_application_CharityCareApplication_documentFiles
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeApplication_application_CharityCareApplication_benefitOutcomes
  ),
  accountOnDateOfService:
    serialized.accountOnDateOfService != null
      ? deserializeApplication_application_CharityCareApplication_accountOnDateOfService(
          serialized.accountOnDateOfService
        )
      : serialized.accountOnDateOfService,
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
  requestedDateOfApplication:
    serialized.requestedDateOfApplication != null
      ? parseDate(serialized.requestedDateOfApplication)
      : serialized.requestedDateOfApplication,
})
export const serializeApplication_application_CharityCareApplication = (
  deserialized: Application_application_CharityCareApplication
): Application_application_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  person: serializeApplication_application_CharityCareApplication_person(
    deserialized.person
  ),
  assignedTo:
    deserialized.assignedTo != null
      ? serializeApplication_application_CharityCareApplication_assignedTo(
          deserialized.assignedTo
        )
      : deserialized.assignedTo,
  householdMembers: deserialized.householdMembers.map(
    serializeApplication_application_CharityCareApplication_householdMembers
  ),
  documents: deserialized.documents.map(
    serializeApplication_application_CharityCareApplication_documents
  ),
  documentFiles: deserialized.documentFiles.map(
    serializeApplication_application_CharityCareApplication_documentFiles
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeApplication_application_CharityCareApplication_benefitOutcomes
  ),
  accountOnDateOfService:
    deserialized.accountOnDateOfService != null
      ? serializeApplication_application_CharityCareApplication_accountOnDateOfService(
          deserialized.accountOnDateOfService
        )
      : deserialized.accountOnDateOfService,
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
  requestedDateOfApplication:
    deserialized.requestedDateOfApplication != null
      ? formatISODate(deserialized.requestedDateOfApplication)
      : deserialized.requestedDateOfApplication,
})
export interface Application_application_SlideApplication_person_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeApplication_application_SlideApplication_person_phoneNumbers_esignSession_esignWizards = (
  serialized: Application_application_SlideApplication_person_phoneNumbers_esignSession_esignWizardsOrig
): Application_application_SlideApplication_person_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeApplication_application_SlideApplication_person_phoneNumbers_esignSession_esignWizards = (
  deserialized: Application_application_SlideApplication_person_phoneNumbers_esignSession_esignWizards
): Application_application_SlideApplication_person_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Application_application_SlideApplication_person_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Application_application_SlideApplication_person_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeApplication_application_SlideApplication_person_phoneNumbers_esignSession = (
  serialized: Application_application_SlideApplication_person_phoneNumbers_esignSessionOrig
): Application_application_SlideApplication_person_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeApplication_application_SlideApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeApplication_application_SlideApplication_person_phoneNumbers_esignSession = (
  deserialized: Application_application_SlideApplication_person_phoneNumbers_esignSession
): Application_application_SlideApplication_person_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeApplication_application_SlideApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export interface Application_application_SlideApplication_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: Application_application_SlideApplication_person_phoneNumbers_esignSession | null
}
export const deserializeApplication_application_SlideApplication_person_phoneNumbers = (
  serialized: Application_application_SlideApplication_person_phoneNumbersOrig
): Application_application_SlideApplication_person_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeApplication_application_SlideApplication_person_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeApplication_application_SlideApplication_person_phoneNumbers = (
  deserialized: Application_application_SlideApplication_person_phoneNumbers
): Application_application_SlideApplication_person_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeApplication_application_SlideApplication_person_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Application_application_SlideApplication_person_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeApplication_application_SlideApplication_person_benefitOutcomes_application_MedicaidApplication = (
  serialized: Application_application_SlideApplication_person_benefitOutcomes_application_MedicaidApplicationOrig
): Application_application_SlideApplication_person_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeApplication_application_SlideApplication_person_benefitOutcomes_application_MedicaidApplication = (
  deserialized: Application_application_SlideApplication_person_benefitOutcomes_application_MedicaidApplication
): Application_application_SlideApplication_person_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface Application_application_SlideApplication_person_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeApplication_application_SlideApplication_person_benefitOutcomes_application_CharityCareApplication = (
  serialized: Application_application_SlideApplication_person_benefitOutcomes_application_CharityCareApplicationOrig
): Application_application_SlideApplication_person_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeApplication_application_SlideApplication_person_benefitOutcomes_application_CharityCareApplication = (
  deserialized: Application_application_SlideApplication_person_benefitOutcomes_application_CharityCareApplication
): Application_application_SlideApplication_person_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface Application_application_SlideApplication_person_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeApplication_application_SlideApplication_person_benefitOutcomes_application_SlideApplication = (
  serialized: Application_application_SlideApplication_person_benefitOutcomes_application_SlideApplicationOrig
): Application_application_SlideApplication_person_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeApplication_application_SlideApplication_person_benefitOutcomes_application_SlideApplication = (
  deserialized: Application_application_SlideApplication_person_benefitOutcomes_application_SlideApplication
): Application_application_SlideApplication_person_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type Application_application_SlideApplication_person_benefitOutcomes_application =
  | Application_application_SlideApplication_person_benefitOutcomes_application_MedicaidApplication
  | Application_application_SlideApplication_person_benefitOutcomes_application_CharityCareApplication
  | Application_application_SlideApplication_person_benefitOutcomes_application_SlideApplication
export const deserializeApplication_application_SlideApplication_person_benefitOutcomes_application = (
  serialized: Application_application_SlideApplication_person_benefitOutcomes_applicationOrig
): Application_application_SlideApplication_person_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeApplication_application_SlideApplication_person_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeApplication_application_SlideApplication_person_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeApplication_application_SlideApplication_person_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Application_application_SlideApplication_person_benefitOutcomes_application'
  )
}
export const serializeApplication_application_SlideApplication_person_benefitOutcomes_application = (
  deserialized: Application_application_SlideApplication_person_benefitOutcomes_application
): Application_application_SlideApplication_person_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeApplication_application_SlideApplication_person_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeApplication_application_SlideApplication_person_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeApplication_application_SlideApplication_person_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Application_application_SlideApplication_person_benefitOutcomes_application'
  )
}
export interface Application_application_SlideApplication_person_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: Application_application_SlideApplication_person_benefitOutcomes_application | null
}
export const deserializeApplication_application_SlideApplication_person_benefitOutcomes = (
  serialized: Application_application_SlideApplication_person_benefitOutcomesOrig
): Application_application_SlideApplication_person_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeApplication_application_SlideApplication_person_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeApplication_application_SlideApplication_person_benefitOutcomes = (
  deserialized: Application_application_SlideApplication_person_benefitOutcomes
): Application_application_SlideApplication_person_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeApplication_application_SlideApplication_person_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface Application_application_SlideApplication_person_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeApplication_application_SlideApplication_person_incomeSources_esignSession_esignWizards = (
  serialized: Application_application_SlideApplication_person_incomeSources_esignSession_esignWizardsOrig
): Application_application_SlideApplication_person_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeApplication_application_SlideApplication_person_incomeSources_esignSession_esignWizards = (
  deserialized: Application_application_SlideApplication_person_incomeSources_esignSession_esignWizards
): Application_application_SlideApplication_person_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Application_application_SlideApplication_person_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Application_application_SlideApplication_person_incomeSources_esignSession_esignWizards[]
}
export const deserializeApplication_application_SlideApplication_person_incomeSources_esignSession = (
  serialized: Application_application_SlideApplication_person_incomeSources_esignSessionOrig
): Application_application_SlideApplication_person_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeApplication_application_SlideApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export const serializeApplication_application_SlideApplication_person_incomeSources_esignSession = (
  deserialized: Application_application_SlideApplication_person_incomeSources_esignSession
): Application_application_SlideApplication_person_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeApplication_application_SlideApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export interface Application_application_SlideApplication_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: Application_application_SlideApplication_person_incomeSources_esignSession | null
}
export const deserializeApplication_application_SlideApplication_person_incomeSources = (
  serialized: Application_application_SlideApplication_person_incomeSourcesOrig
): Application_application_SlideApplication_person_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeApplication_application_SlideApplication_person_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeApplication_application_SlideApplication_person_incomeSources = (
  deserialized: Application_application_SlideApplication_person_incomeSources
): Application_application_SlideApplication_person_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeApplication_application_SlideApplication_person_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Application_application_SlideApplication_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeApplication_application_SlideApplication_person_deductions = (
  serialized: Application_application_SlideApplication_person_deductionsOrig
): Application_application_SlideApplication_person_deductions => ({
  ...serialized,
})
export const serializeApplication_application_SlideApplication_person_deductions = (
  deserialized: Application_application_SlideApplication_person_deductions
): Application_application_SlideApplication_person_deductionsOrig => ({
  ...deserialized,
})
export interface Application_application_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeApplication_application_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards = (
  serialized: Application_application_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizardsOrig
): Application_application_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeApplication_application_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards = (
  deserialized: Application_application_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards
): Application_application_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Application_application_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Application_application_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeApplication_application_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession = (
  serialized: Application_application_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSessionOrig
): Application_application_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeApplication_application_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeApplication_application_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession = (
  deserialized: Application_application_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession
): Application_application_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeApplication_application_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards
  ),
})
export interface Application_application_SlideApplication_person_relationships_otherPerson_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: Application_application_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession | null
}
export const deserializeApplication_application_SlideApplication_person_relationships_otherPerson_phoneNumbers = (
  serialized: Application_application_SlideApplication_person_relationships_otherPerson_phoneNumbersOrig
): Application_application_SlideApplication_person_relationships_otherPerson_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeApplication_application_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeApplication_application_SlideApplication_person_relationships_otherPerson_phoneNumbers = (
  deserialized: Application_application_SlideApplication_person_relationships_otherPerson_phoneNumbers
): Application_application_SlideApplication_person_relationships_otherPerson_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeApplication_application_SlideApplication_person_relationships_otherPerson_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeApplication_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication = (
  serialized: Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplicationOrig
): Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeApplication_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication = (
  deserialized: Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication
): Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeApplication_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication = (
  serialized: Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplicationOrig
): Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeApplication_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication = (
  deserialized: Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication
): Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeApplication_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication = (
  serialized: Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplicationOrig
): Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeApplication_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication = (
  deserialized: Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication
): Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application =
  | Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication
  | Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication
  | Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication
export const deserializeApplication_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application = (
  serialized: Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_applicationOrig
): Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeApplication_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeApplication_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeApplication_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application'
  )
}
export const serializeApplication_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application = (
  deserialized: Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application
): Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeApplication_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeApplication_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeApplication_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application'
  )
}
export interface Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application | null
}
export const deserializeApplication_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes = (
  serialized: Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomesOrig
): Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeApplication_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeApplication_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes = (
  deserialized: Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes
): Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeApplication_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface Application_application_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeApplication_application_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards = (
  serialized: Application_application_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizardsOrig
): Application_application_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeApplication_application_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards = (
  deserialized: Application_application_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards
): Application_application_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Application_application_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Application_application_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards[]
}
export const deserializeApplication_application_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession = (
  serialized: Application_application_SlideApplication_person_relationships_otherPerson_incomeSources_esignSessionOrig
): Application_application_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeApplication_application_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards
  ),
})
export const serializeApplication_application_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession = (
  deserialized: Application_application_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession
): Application_application_SlideApplication_person_relationships_otherPerson_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeApplication_application_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards
  ),
})
export interface Application_application_SlideApplication_person_relationships_otherPerson_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: Application_application_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession | null
}
export const deserializeApplication_application_SlideApplication_person_relationships_otherPerson_incomeSources = (
  serialized: Application_application_SlideApplication_person_relationships_otherPerson_incomeSourcesOrig
): Application_application_SlideApplication_person_relationships_otherPerson_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeApplication_application_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeApplication_application_SlideApplication_person_relationships_otherPerson_incomeSources = (
  deserialized: Application_application_SlideApplication_person_relationships_otherPerson_incomeSources
): Application_application_SlideApplication_person_relationships_otherPerson_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeApplication_application_SlideApplication_person_relationships_otherPerson_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Application_application_SlideApplication_person_relationships_otherPerson_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeApplication_application_SlideApplication_person_relationships_otherPerson_deductions = (
  serialized: Application_application_SlideApplication_person_relationships_otherPerson_deductionsOrig
): Application_application_SlideApplication_person_relationships_otherPerson_deductions => ({
  ...serialized,
})
export const serializeApplication_application_SlideApplication_person_relationships_otherPerson_deductions = (
  deserialized: Application_application_SlideApplication_person_relationships_otherPerson_deductions
): Application_application_SlideApplication_person_relationships_otherPerson_deductionsOrig => ({
  ...deserialized,
})
export interface Application_application_SlideApplication_person_relationships_otherPerson {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: Application_application_SlideApplication_person_relationships_otherPerson_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: Application_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes[]
  incomeSources: Application_application_SlideApplication_person_relationships_otherPerson_incomeSources[]
  deductions: Application_application_SlideApplication_person_relationships_otherPerson_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
}
export const deserializeApplication_application_SlideApplication_person_relationships_otherPerson = (
  serialized: Application_application_SlideApplication_person_relationships_otherPersonOrig
): Application_application_SlideApplication_person_relationships_otherPerson => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeApplication_application_SlideApplication_person_relationships_otherPerson_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeApplication_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeApplication_application_SlideApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeApplication_application_SlideApplication_person_relationships_otherPerson_deductions
  ),
})
export const serializeApplication_application_SlideApplication_person_relationships_otherPerson = (
  deserialized: Application_application_SlideApplication_person_relationships_otherPerson
): Application_application_SlideApplication_person_relationships_otherPersonOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeApplication_application_SlideApplication_person_relationships_otherPerson_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeApplication_application_SlideApplication_person_relationships_otherPerson_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeApplication_application_SlideApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeApplication_application_SlideApplication_person_relationships_otherPerson_deductions
  ),
})
export interface Application_application_SlideApplication_person_relationships {
  __typename: 'Relationship'
  id: string
  relationshipType: string | null
  reverseRelationshipType: string | null
  liveTogether: boolean | null
  otherPerson: Application_application_SlideApplication_person_relationships_otherPerson
}
export const deserializeApplication_application_SlideApplication_person_relationships = (
  serialized: Application_application_SlideApplication_person_relationshipsOrig
): Application_application_SlideApplication_person_relationships => ({
  ...serialized,
  otherPerson: deserializeApplication_application_SlideApplication_person_relationships_otherPerson(
    serialized.otherPerson
  ),
})
export const serializeApplication_application_SlideApplication_person_relationships = (
  deserialized: Application_application_SlideApplication_person_relationships
): Application_application_SlideApplication_person_relationshipsOrig => ({
  ...deserialized,
  otherPerson: serializeApplication_application_SlideApplication_person_relationships_otherPerson(
    deserialized.otherPerson
  ),
})
export interface Application_application_SlideApplication_person_documentFiles {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeApplication_application_SlideApplication_person_documentFiles = (
  serialized: Application_application_SlideApplication_person_documentFilesOrig
): Application_application_SlideApplication_person_documentFiles => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeApplication_application_SlideApplication_person_documentFiles = (
  deserialized: Application_application_SlideApplication_person_documentFiles
): Application_application_SlideApplication_person_documentFilesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface Application_application_SlideApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializeApplication_application_SlideApplication_person_openApplications_MedicaidApplication = (
  serialized: Application_application_SlideApplication_person_openApplications_MedicaidApplicationOrig
): Application_application_SlideApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeApplication_application_SlideApplication_person_openApplications_MedicaidApplication = (
  deserialized: Application_application_SlideApplication_person_openApplications_MedicaidApplication
): Application_application_SlideApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Application_application_SlideApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeApplication_application_SlideApplication_person_openApplications_CharityCareApplication = (
  serialized: Application_application_SlideApplication_person_openApplications_CharityCareApplicationOrig
): Application_application_SlideApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeApplication_application_SlideApplication_person_openApplications_CharityCareApplication = (
  deserialized: Application_application_SlideApplication_person_openApplications_CharityCareApplication
): Application_application_SlideApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Application_application_SlideApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeApplication_application_SlideApplication_person_openApplications_SlideApplication = (
  serialized: Application_application_SlideApplication_person_openApplications_SlideApplicationOrig
): Application_application_SlideApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeApplication_application_SlideApplication_person_openApplications_SlideApplication = (
  deserialized: Application_application_SlideApplication_person_openApplications_SlideApplication
): Application_application_SlideApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Application_application_SlideApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeApplication_application_SlideApplication_person_openApplications_RyanWhiteApplication = (
  serialized: Application_application_SlideApplication_person_openApplications_RyanWhiteApplicationOrig
): Application_application_SlideApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeApplication_application_SlideApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: Application_application_SlideApplication_person_openApplications_RyanWhiteApplication
): Application_application_SlideApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type Application_application_SlideApplication_person_openApplications =
  | Application_application_SlideApplication_person_openApplications_MedicaidApplication
  | Application_application_SlideApplication_person_openApplications_CharityCareApplication
  | Application_application_SlideApplication_person_openApplications_SlideApplication
  | Application_application_SlideApplication_person_openApplications_RyanWhiteApplication
export const deserializeApplication_application_SlideApplication_person_openApplications = (
  serialized: Application_application_SlideApplication_person_openApplicationsOrig
): Application_application_SlideApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializeApplication_application_SlideApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeApplication_application_SlideApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeApplication_application_SlideApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeApplication_application_SlideApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Application_application_SlideApplication_person_openApplications'
  )
}
export const serializeApplication_application_SlideApplication_person_openApplications = (
  deserialized: Application_application_SlideApplication_person_openApplications
): Application_application_SlideApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializeApplication_application_SlideApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeApplication_application_SlideApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeApplication_application_SlideApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeApplication_application_SlideApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Application_application_SlideApplication_person_openApplications'
  )
}
export interface Application_application_SlideApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializeApplication_application_SlideApplication_person_openHouseholdMemberApplications = (
  serialized: Application_application_SlideApplication_person_openHouseholdMemberApplicationsOrig
): Application_application_SlideApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeApplication_application_SlideApplication_person_openHouseholdMemberApplications = (
  deserialized: Application_application_SlideApplication_person_openHouseholdMemberApplications
): Application_application_SlideApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Application_application_SlideApplication_person {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: Application_application_SlideApplication_person_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: Application_application_SlideApplication_person_benefitOutcomes[]
  incomeSources: Application_application_SlideApplication_person_incomeSources[]
  deductions: Application_application_SlideApplication_person_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
  relationships: Application_application_SlideApplication_person_relationships[]
  documentFiles: Application_application_SlideApplication_person_documentFiles[]
  openApplications: Application_application_SlideApplication_person_openApplications[]
  openHouseholdMemberApplications: Application_application_SlideApplication_person_openHouseholdMemberApplications[]
}
export const deserializeApplication_application_SlideApplication_person = (
  serialized: Application_application_SlideApplication_personOrig
): Application_application_SlideApplication_person => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeApplication_application_SlideApplication_person_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeApplication_application_SlideApplication_person_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeApplication_application_SlideApplication_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeApplication_application_SlideApplication_person_deductions
  ),
  relationships: serialized.relationships.map(
    deserializeApplication_application_SlideApplication_person_relationships
  ),
  documentFiles: serialized.documentFiles.map(
    deserializeApplication_application_SlideApplication_person_documentFiles
  ),
  openApplications: serialized.openApplications.map(
    deserializeApplication_application_SlideApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializeApplication_application_SlideApplication_person_openHouseholdMemberApplications
  ),
})
export const serializeApplication_application_SlideApplication_person = (
  deserialized: Application_application_SlideApplication_person
): Application_application_SlideApplication_personOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeApplication_application_SlideApplication_person_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeApplication_application_SlideApplication_person_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeApplication_application_SlideApplication_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeApplication_application_SlideApplication_person_deductions
  ),
  relationships: deserialized.relationships.map(
    serializeApplication_application_SlideApplication_person_relationships
  ),
  documentFiles: deserialized.documentFiles.map(
    serializeApplication_application_SlideApplication_person_documentFiles
  ),
  openApplications: deserialized.openApplications.map(
    serializeApplication_application_SlideApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializeApplication_application_SlideApplication_person_openHouseholdMemberApplications
  ),
})
export interface Application_application_SlideApplication_assignedTo {
  __typename: 'User'
  id: string
  email: string
  name: string | null
  isCurrentUser: boolean
}
export const deserializeApplication_application_SlideApplication_assignedTo = (
  serialized: Application_application_SlideApplication_assignedToOrig
): Application_application_SlideApplication_assignedTo => ({...serialized})
export const serializeApplication_application_SlideApplication_assignedTo = (
  deserialized: Application_application_SlideApplication_assignedTo
): Application_application_SlideApplication_assignedToOrig => ({
  ...deserialized,
})
export interface Application_application_SlideApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeApplication_application_SlideApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards = (
  serialized: Application_application_SlideApplication_householdMembers_person_phoneNumbers_esignSession_esignWizardsOrig
): Application_application_SlideApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeApplication_application_SlideApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards = (
  deserialized: Application_application_SlideApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards
): Application_application_SlideApplication_householdMembers_person_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Application_application_SlideApplication_householdMembers_person_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Application_application_SlideApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeApplication_application_SlideApplication_householdMembers_person_phoneNumbers_esignSession = (
  serialized: Application_application_SlideApplication_householdMembers_person_phoneNumbers_esignSessionOrig
): Application_application_SlideApplication_householdMembers_person_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeApplication_application_SlideApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeApplication_application_SlideApplication_householdMembers_person_phoneNumbers_esignSession = (
  deserialized: Application_application_SlideApplication_householdMembers_person_phoneNumbers_esignSession
): Application_application_SlideApplication_householdMembers_person_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeApplication_application_SlideApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards
  ),
})
export interface Application_application_SlideApplication_householdMembers_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: Application_application_SlideApplication_householdMembers_person_phoneNumbers_esignSession | null
}
export const deserializeApplication_application_SlideApplication_householdMembers_person_phoneNumbers = (
  serialized: Application_application_SlideApplication_householdMembers_person_phoneNumbersOrig
): Application_application_SlideApplication_householdMembers_person_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeApplication_application_SlideApplication_householdMembers_person_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeApplication_application_SlideApplication_householdMembers_person_phoneNumbers = (
  deserialized: Application_application_SlideApplication_householdMembers_person_phoneNumbers
): Application_application_SlideApplication_householdMembers_person_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeApplication_application_SlideApplication_householdMembers_person_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Application_application_SlideApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeApplication_application_SlideApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication = (
  serialized: Application_application_SlideApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplicationOrig
): Application_application_SlideApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeApplication_application_SlideApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication = (
  deserialized: Application_application_SlideApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication
): Application_application_SlideApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface Application_application_SlideApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeApplication_application_SlideApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication = (
  serialized: Application_application_SlideApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplicationOrig
): Application_application_SlideApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeApplication_application_SlideApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication = (
  deserialized: Application_application_SlideApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication
): Application_application_SlideApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface Application_application_SlideApplication_householdMembers_person_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeApplication_application_SlideApplication_householdMembers_person_benefitOutcomes_application_SlideApplication = (
  serialized: Application_application_SlideApplication_householdMembers_person_benefitOutcomes_application_SlideApplicationOrig
): Application_application_SlideApplication_householdMembers_person_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeApplication_application_SlideApplication_householdMembers_person_benefitOutcomes_application_SlideApplication = (
  deserialized: Application_application_SlideApplication_householdMembers_person_benefitOutcomes_application_SlideApplication
): Application_application_SlideApplication_householdMembers_person_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type Application_application_SlideApplication_householdMembers_person_benefitOutcomes_application =
  | Application_application_SlideApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication
  | Application_application_SlideApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication
  | Application_application_SlideApplication_householdMembers_person_benefitOutcomes_application_SlideApplication
export const deserializeApplication_application_SlideApplication_householdMembers_person_benefitOutcomes_application = (
  serialized: Application_application_SlideApplication_householdMembers_person_benefitOutcomes_applicationOrig
): Application_application_SlideApplication_householdMembers_person_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeApplication_application_SlideApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeApplication_application_SlideApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeApplication_application_SlideApplication_householdMembers_person_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Application_application_SlideApplication_householdMembers_person_benefitOutcomes_application'
  )
}
export const serializeApplication_application_SlideApplication_householdMembers_person_benefitOutcomes_application = (
  deserialized: Application_application_SlideApplication_householdMembers_person_benefitOutcomes_application
): Application_application_SlideApplication_householdMembers_person_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeApplication_application_SlideApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeApplication_application_SlideApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeApplication_application_SlideApplication_householdMembers_person_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Application_application_SlideApplication_householdMembers_person_benefitOutcomes_application'
  )
}
export interface Application_application_SlideApplication_householdMembers_person_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: Application_application_SlideApplication_householdMembers_person_benefitOutcomes_application | null
}
export const deserializeApplication_application_SlideApplication_householdMembers_person_benefitOutcomes = (
  serialized: Application_application_SlideApplication_householdMembers_person_benefitOutcomesOrig
): Application_application_SlideApplication_householdMembers_person_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeApplication_application_SlideApplication_householdMembers_person_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeApplication_application_SlideApplication_householdMembers_person_benefitOutcomes = (
  deserialized: Application_application_SlideApplication_householdMembers_person_benefitOutcomes
): Application_application_SlideApplication_householdMembers_person_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeApplication_application_SlideApplication_householdMembers_person_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface Application_application_SlideApplication_householdMembers_person_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeApplication_application_SlideApplication_householdMembers_person_incomeSources_esignSession_esignWizards = (
  serialized: Application_application_SlideApplication_householdMembers_person_incomeSources_esignSession_esignWizardsOrig
): Application_application_SlideApplication_householdMembers_person_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeApplication_application_SlideApplication_householdMembers_person_incomeSources_esignSession_esignWizards = (
  deserialized: Application_application_SlideApplication_householdMembers_person_incomeSources_esignSession_esignWizards
): Application_application_SlideApplication_householdMembers_person_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Application_application_SlideApplication_householdMembers_person_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Application_application_SlideApplication_householdMembers_person_incomeSources_esignSession_esignWizards[]
}
export const deserializeApplication_application_SlideApplication_householdMembers_person_incomeSources_esignSession = (
  serialized: Application_application_SlideApplication_householdMembers_person_incomeSources_esignSessionOrig
): Application_application_SlideApplication_householdMembers_person_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeApplication_application_SlideApplication_householdMembers_person_incomeSources_esignSession_esignWizards
  ),
})
export const serializeApplication_application_SlideApplication_householdMembers_person_incomeSources_esignSession = (
  deserialized: Application_application_SlideApplication_householdMembers_person_incomeSources_esignSession
): Application_application_SlideApplication_householdMembers_person_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeApplication_application_SlideApplication_householdMembers_person_incomeSources_esignSession_esignWizards
  ),
})
export interface Application_application_SlideApplication_householdMembers_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: Application_application_SlideApplication_householdMembers_person_incomeSources_esignSession | null
}
export const deserializeApplication_application_SlideApplication_householdMembers_person_incomeSources = (
  serialized: Application_application_SlideApplication_householdMembers_person_incomeSourcesOrig
): Application_application_SlideApplication_householdMembers_person_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeApplication_application_SlideApplication_householdMembers_person_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeApplication_application_SlideApplication_householdMembers_person_incomeSources = (
  deserialized: Application_application_SlideApplication_householdMembers_person_incomeSources
): Application_application_SlideApplication_householdMembers_person_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeApplication_application_SlideApplication_householdMembers_person_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Application_application_SlideApplication_householdMembers_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeApplication_application_SlideApplication_householdMembers_person_deductions = (
  serialized: Application_application_SlideApplication_householdMembers_person_deductionsOrig
): Application_application_SlideApplication_householdMembers_person_deductions => ({
  ...serialized,
})
export const serializeApplication_application_SlideApplication_householdMembers_person_deductions = (
  deserialized: Application_application_SlideApplication_householdMembers_person_deductions
): Application_application_SlideApplication_householdMembers_person_deductionsOrig => ({
  ...deserialized,
})
export interface Application_application_SlideApplication_householdMembers_person_documentFiles {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeApplication_application_SlideApplication_householdMembers_person_documentFiles = (
  serialized: Application_application_SlideApplication_householdMembers_person_documentFilesOrig
): Application_application_SlideApplication_householdMembers_person_documentFiles => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeApplication_application_SlideApplication_householdMembers_person_documentFiles = (
  deserialized: Application_application_SlideApplication_householdMembers_person_documentFiles
): Application_application_SlideApplication_householdMembers_person_documentFilesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface Application_application_SlideApplication_householdMembers_person {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: Application_application_SlideApplication_householdMembers_person_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: Application_application_SlideApplication_householdMembers_person_benefitOutcomes[]
  incomeSources: Application_application_SlideApplication_householdMembers_person_incomeSources[]
  deductions: Application_application_SlideApplication_householdMembers_person_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
  documentFiles: Application_application_SlideApplication_householdMembers_person_documentFiles[]
}
export const deserializeApplication_application_SlideApplication_householdMembers_person = (
  serialized: Application_application_SlideApplication_householdMembers_personOrig
): Application_application_SlideApplication_householdMembers_person => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeApplication_application_SlideApplication_householdMembers_person_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeApplication_application_SlideApplication_householdMembers_person_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeApplication_application_SlideApplication_householdMembers_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeApplication_application_SlideApplication_householdMembers_person_deductions
  ),
  documentFiles: serialized.documentFiles.map(
    deserializeApplication_application_SlideApplication_householdMembers_person_documentFiles
  ),
})
export const serializeApplication_application_SlideApplication_householdMembers_person = (
  deserialized: Application_application_SlideApplication_householdMembers_person
): Application_application_SlideApplication_householdMembers_personOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeApplication_application_SlideApplication_householdMembers_person_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeApplication_application_SlideApplication_householdMembers_person_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeApplication_application_SlideApplication_householdMembers_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeApplication_application_SlideApplication_householdMembers_person_deductions
  ),
  documentFiles: deserialized.documentFiles.map(
    serializeApplication_application_SlideApplication_householdMembers_person_documentFiles
  ),
})
export interface Application_application_SlideApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  wantsCoverage: boolean | null
  person: Application_application_SlideApplication_householdMembers_person
  createdAt: Date
}
export const deserializeApplication_application_SlideApplication_householdMembers = (
  serialized: Application_application_SlideApplication_householdMembersOrig
): Application_application_SlideApplication_householdMembers => ({
  ...serialized,
  person: deserializeApplication_application_SlideApplication_householdMembers_person(
    serialized.person
  ),
  createdAt: parseDate(serialized.createdAt),
})
export const serializeApplication_application_SlideApplication_householdMembers = (
  deserialized: Application_application_SlideApplication_householdMembers
): Application_application_SlideApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializeApplication_application_SlideApplication_householdMembers_person(
    deserialized.person
  ),
  createdAt: formatISO(deserialized.createdAt),
})
export interface Application_application_SlideApplication_documents_files {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeApplication_application_SlideApplication_documents_files = (
  serialized: Application_application_SlideApplication_documents_filesOrig
): Application_application_SlideApplication_documents_files => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeApplication_application_SlideApplication_documents_files = (
  deserialized: Application_application_SlideApplication_documents_files
): Application_application_SlideApplication_documents_filesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface Application_application_SlideApplication_documents_person {
  __typename: 'Person'
  id: string
}
export const deserializeApplication_application_SlideApplication_documents_person = (
  serialized: Application_application_SlideApplication_documents_personOrig
): Application_application_SlideApplication_documents_person => ({
  ...serialized,
})
export const serializeApplication_application_SlideApplication_documents_person = (
  deserialized: Application_application_SlideApplication_documents_person
): Application_application_SlideApplication_documents_personOrig => ({
  ...deserialized,
})
export interface Application_application_SlideApplication_documents_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializeApplication_application_SlideApplication_documents_application = (
  serialized: Application_application_SlideApplication_documents_applicationOrig
): Application_application_SlideApplication_documents_application => ({
  ...serialized,
})
export const serializeApplication_application_SlideApplication_documents_application = (
  deserialized: Application_application_SlideApplication_documents_application
): Application_application_SlideApplication_documents_applicationOrig => ({
  ...deserialized,
})
export interface Application_application_SlideApplication_documents {
  __typename: 'Document'
  id: string
  documentType: string
  complete: boolean | null
  files: Application_application_SlideApplication_documents_files[]
  updatedAt: Date
  notes: string | null
  person: Application_application_SlideApplication_documents_person | null
  application: Application_application_SlideApplication_documents_application
}
export const deserializeApplication_application_SlideApplication_documents = (
  serialized: Application_application_SlideApplication_documentsOrig
): Application_application_SlideApplication_documents => ({
  ...serialized,
  files: serialized.files.map(
    deserializeApplication_application_SlideApplication_documents_files
  ),
  updatedAt: parseDate(serialized.updatedAt),
  person:
    serialized.person != null
      ? deserializeApplication_application_SlideApplication_documents_person(
          serialized.person
        )
      : serialized.person,
  application: deserializeApplication_application_SlideApplication_documents_application(
    serialized.application
  ),
})
export const serializeApplication_application_SlideApplication_documents = (
  deserialized: Application_application_SlideApplication_documents
): Application_application_SlideApplication_documentsOrig => ({
  ...deserialized,
  files: deserialized.files.map(
    serializeApplication_application_SlideApplication_documents_files
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  person:
    deserialized.person != null
      ? serializeApplication_application_SlideApplication_documents_person(
          deserialized.person
        )
      : deserialized.person,
  application: serializeApplication_application_SlideApplication_documents_application(
    deserialized.application
  ),
})
export interface Application_application_SlideApplication_documentFiles_documents {
  __typename: 'Document'
  id: string
}
export const deserializeApplication_application_SlideApplication_documentFiles_documents = (
  serialized: Application_application_SlideApplication_documentFiles_documentsOrig
): Application_application_SlideApplication_documentFiles_documents => ({
  ...serialized,
})
export const serializeApplication_application_SlideApplication_documentFiles_documents = (
  deserialized: Application_application_SlideApplication_documentFiles_documents
): Application_application_SlideApplication_documentFiles_documentsOrig => ({
  ...deserialized,
})
export interface Application_application_SlideApplication_documentFiles {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
  documents: Application_application_SlideApplication_documentFiles_documents[]
}
export const deserializeApplication_application_SlideApplication_documentFiles = (
  serialized: Application_application_SlideApplication_documentFilesOrig
): Application_application_SlideApplication_documentFiles => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
  documents: serialized.documents.map(
    deserializeApplication_application_SlideApplication_documentFiles_documents
  ),
})
export const serializeApplication_application_SlideApplication_documentFiles = (
  deserialized: Application_application_SlideApplication_documentFiles
): Application_application_SlideApplication_documentFilesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
  documents: deserialized.documents.map(
    serializeApplication_application_SlideApplication_documentFiles_documents
  ),
})
export interface Application_application_SlideApplication_benefitOutcomes_person {
  __typename: 'Person'
  id: string
}
export const deserializeApplication_application_SlideApplication_benefitOutcomes_person = (
  serialized: Application_application_SlideApplication_benefitOutcomes_personOrig
): Application_application_SlideApplication_benefitOutcomes_person => ({
  ...serialized,
})
export const serializeApplication_application_SlideApplication_benefitOutcomes_person = (
  deserialized: Application_application_SlideApplication_benefitOutcomes_person
): Application_application_SlideApplication_benefitOutcomes_personOrig => ({
  ...deserialized,
})
export interface Application_application_SlideApplication_benefitOutcomes_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializeApplication_application_SlideApplication_benefitOutcomes_application = (
  serialized: Application_application_SlideApplication_benefitOutcomes_applicationOrig
): Application_application_SlideApplication_benefitOutcomes_application => ({
  ...serialized,
})
export const serializeApplication_application_SlideApplication_benefitOutcomes_application = (
  deserialized: Application_application_SlideApplication_benefitOutcomes_application
): Application_application_SlideApplication_benefitOutcomes_applicationOrig => ({
  ...deserialized,
})
export interface Application_application_SlideApplication_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  person: Application_application_SlideApplication_benefitOutcomes_person
  application: Application_application_SlideApplication_benefitOutcomes_application | null
}
export const deserializeApplication_application_SlideApplication_benefitOutcomes = (
  serialized: Application_application_SlideApplication_benefitOutcomesOrig
): Application_application_SlideApplication_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  person: deserializeApplication_application_SlideApplication_benefitOutcomes_person(
    serialized.person
  ),
  application:
    serialized.application != null
      ? deserializeApplication_application_SlideApplication_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeApplication_application_SlideApplication_benefitOutcomes = (
  deserialized: Application_application_SlideApplication_benefitOutcomes
): Application_application_SlideApplication_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  person: serializeApplication_application_SlideApplication_benefitOutcomes_person(
    deserialized.person
  ),
  application:
    deserialized.application != null
      ? serializeApplication_application_SlideApplication_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface Application_application_SlideApplication_accountOnDateOfService {
  __typename: 'Account'
  id: string
  hospitalAccountId: string | null
  dateOfService: Date
  timeOfService: string | null
  serviceTimeZone: string
  facility: string
  department: string
  location: string | null
  insuranceType: string
  status: string
  createdAt: Date
  updatedAt: Date
  notes: string | null
  accountAmount: number | null
  njmmisCheck: string | null
  previousInsurance: string | null
  invoiceMonth: string | null
  invoiceYear: string | null
  dischargeDate: Date | null
  isScheduled: boolean
}
export const deserializeApplication_application_SlideApplication_accountOnDateOfService = (
  serialized: Application_application_SlideApplication_accountOnDateOfServiceOrig
): Application_application_SlideApplication_accountOnDateOfService => ({
  ...serialized,
  dateOfService: parseDate(serialized.dateOfService),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  njmmisCheck:
    serialized.njmmisCheck != null
      ? deserializeNjmmisCheckResult(serialized.njmmisCheck)
      : serialized.njmmisCheck,
  dischargeDate:
    serialized.dischargeDate != null
      ? parseDate(serialized.dischargeDate)
      : serialized.dischargeDate,
})
export const serializeApplication_application_SlideApplication_accountOnDateOfService = (
  deserialized: Application_application_SlideApplication_accountOnDateOfService
): Application_application_SlideApplication_accountOnDateOfServiceOrig => ({
  ...deserialized,
  dateOfService: formatISODate(deserialized.dateOfService),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  njmmisCheck:
    deserialized.njmmisCheck != null
      ? serializeNjmmisCheckResult(deserialized.njmmisCheck)
      : deserialized.njmmisCheck,
  dischargeDate:
    deserialized.dischargeDate != null
      ? formatISODate(deserialized.dischargeDate)
      : deserialized.dischargeDate,
})
export interface Application_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  person: Application_application_SlideApplication_person
  assignedTo: Application_application_SlideApplication_assignedTo | null
  householdMembers: Application_application_SlideApplication_householdMembers[]
  documents: Application_application_SlideApplication_documents[]
  documentFiles: Application_application_SlideApplication_documentFiles[]
  benefitOutcomes: Application_application_SlideApplication_benefitOutcomes[]
  accountOnDateOfService: Application_application_SlideApplication_accountOnDateOfService | null
  initialDateOfService: Date | null
  receivedDate: Date | null
  notes: string | null
  facility: string
  slideType: string
  dateOfApplication: Date | null
  coveragePeriod: number | null
}
export const deserializeApplication_application_SlideApplication = (
  serialized: Application_application_SlideApplicationOrig
): Application_application_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  person: deserializeApplication_application_SlideApplication_person(
    serialized.person
  ),
  assignedTo:
    serialized.assignedTo != null
      ? deserializeApplication_application_SlideApplication_assignedTo(
          serialized.assignedTo
        )
      : serialized.assignedTo,
  householdMembers: serialized.householdMembers.map(
    deserializeApplication_application_SlideApplication_householdMembers
  ),
  documents: serialized.documents.map(
    deserializeApplication_application_SlideApplication_documents
  ),
  documentFiles: serialized.documentFiles.map(
    deserializeApplication_application_SlideApplication_documentFiles
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeApplication_application_SlideApplication_benefitOutcomes
  ),
  accountOnDateOfService:
    serialized.accountOnDateOfService != null
      ? deserializeApplication_application_SlideApplication_accountOnDateOfService(
          serialized.accountOnDateOfService
        )
      : serialized.accountOnDateOfService,
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  receivedDate:
    serialized.receivedDate != null
      ? parseDate(serialized.receivedDate)
      : serialized.receivedDate,
  slideType: deserializeSlideType(serialized.slideType),
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
})
export const serializeApplication_application_SlideApplication = (
  deserialized: Application_application_SlideApplication
): Application_application_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  person: serializeApplication_application_SlideApplication_person(
    deserialized.person
  ),
  assignedTo:
    deserialized.assignedTo != null
      ? serializeApplication_application_SlideApplication_assignedTo(
          deserialized.assignedTo
        )
      : deserialized.assignedTo,
  householdMembers: deserialized.householdMembers.map(
    serializeApplication_application_SlideApplication_householdMembers
  ),
  documents: deserialized.documents.map(
    serializeApplication_application_SlideApplication_documents
  ),
  documentFiles: deserialized.documentFiles.map(
    serializeApplication_application_SlideApplication_documentFiles
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeApplication_application_SlideApplication_benefitOutcomes
  ),
  accountOnDateOfService:
    deserialized.accountOnDateOfService != null
      ? serializeApplication_application_SlideApplication_accountOnDateOfService(
          deserialized.accountOnDateOfService
        )
      : deserialized.accountOnDateOfService,
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  receivedDate:
    deserialized.receivedDate != null
      ? formatISODate(deserialized.receivedDate)
      : deserialized.receivedDate,
  slideType: serializeSlideType(deserialized.slideType),
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
})
export interface Application_application_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeApplication_application_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizards = (
  serialized: Application_application_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizardsOrig
): Application_application_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeApplication_application_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizards = (
  deserialized: Application_application_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizards
): Application_application_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Application_application_RyanWhiteApplication_person_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Application_application_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeApplication_application_RyanWhiteApplication_person_phoneNumbers_esignSession = (
  serialized: Application_application_RyanWhiteApplication_person_phoneNumbers_esignSessionOrig
): Application_application_RyanWhiteApplication_person_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeApplication_application_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeApplication_application_RyanWhiteApplication_person_phoneNumbers_esignSession = (
  deserialized: Application_application_RyanWhiteApplication_person_phoneNumbers_esignSession
): Application_application_RyanWhiteApplication_person_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeApplication_application_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export interface Application_application_RyanWhiteApplication_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: Application_application_RyanWhiteApplication_person_phoneNumbers_esignSession | null
}
export const deserializeApplication_application_RyanWhiteApplication_person_phoneNumbers = (
  serialized: Application_application_RyanWhiteApplication_person_phoneNumbersOrig
): Application_application_RyanWhiteApplication_person_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeApplication_application_RyanWhiteApplication_person_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeApplication_application_RyanWhiteApplication_person_phoneNumbers = (
  deserialized: Application_application_RyanWhiteApplication_person_phoneNumbers
): Application_application_RyanWhiteApplication_person_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeApplication_application_RyanWhiteApplication_person_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Application_application_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeApplication_application_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplication = (
  serialized: Application_application_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplicationOrig
): Application_application_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeApplication_application_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplication = (
  deserialized: Application_application_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplication
): Application_application_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface Application_application_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeApplication_application_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplication = (
  serialized: Application_application_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplicationOrig
): Application_application_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeApplication_application_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplication = (
  deserialized: Application_application_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplication
): Application_application_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface Application_application_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeApplication_application_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplication = (
  serialized: Application_application_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplicationOrig
): Application_application_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeApplication_application_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplication = (
  deserialized: Application_application_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplication
): Application_application_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type Application_application_RyanWhiteApplication_person_benefitOutcomes_application =
  | Application_application_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplication
  | Application_application_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplication
  | Application_application_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplication
export const deserializeApplication_application_RyanWhiteApplication_person_benefitOutcomes_application = (
  serialized: Application_application_RyanWhiteApplication_person_benefitOutcomes_applicationOrig
): Application_application_RyanWhiteApplication_person_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeApplication_application_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeApplication_application_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeApplication_application_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Application_application_RyanWhiteApplication_person_benefitOutcomes_application'
  )
}
export const serializeApplication_application_RyanWhiteApplication_person_benefitOutcomes_application = (
  deserialized: Application_application_RyanWhiteApplication_person_benefitOutcomes_application
): Application_application_RyanWhiteApplication_person_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeApplication_application_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeApplication_application_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeApplication_application_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Application_application_RyanWhiteApplication_person_benefitOutcomes_application'
  )
}
export interface Application_application_RyanWhiteApplication_person_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: Application_application_RyanWhiteApplication_person_benefitOutcomes_application | null
}
export const deserializeApplication_application_RyanWhiteApplication_person_benefitOutcomes = (
  serialized: Application_application_RyanWhiteApplication_person_benefitOutcomesOrig
): Application_application_RyanWhiteApplication_person_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeApplication_application_RyanWhiteApplication_person_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeApplication_application_RyanWhiteApplication_person_benefitOutcomes = (
  deserialized: Application_application_RyanWhiteApplication_person_benefitOutcomes
): Application_application_RyanWhiteApplication_person_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeApplication_application_RyanWhiteApplication_person_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface Application_application_RyanWhiteApplication_person_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeApplication_application_RyanWhiteApplication_person_incomeSources_esignSession_esignWizards = (
  serialized: Application_application_RyanWhiteApplication_person_incomeSources_esignSession_esignWizardsOrig
): Application_application_RyanWhiteApplication_person_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeApplication_application_RyanWhiteApplication_person_incomeSources_esignSession_esignWizards = (
  deserialized: Application_application_RyanWhiteApplication_person_incomeSources_esignSession_esignWizards
): Application_application_RyanWhiteApplication_person_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Application_application_RyanWhiteApplication_person_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Application_application_RyanWhiteApplication_person_incomeSources_esignSession_esignWizards[]
}
export const deserializeApplication_application_RyanWhiteApplication_person_incomeSources_esignSession = (
  serialized: Application_application_RyanWhiteApplication_person_incomeSources_esignSessionOrig
): Application_application_RyanWhiteApplication_person_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeApplication_application_RyanWhiteApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export const serializeApplication_application_RyanWhiteApplication_person_incomeSources_esignSession = (
  deserialized: Application_application_RyanWhiteApplication_person_incomeSources_esignSession
): Application_application_RyanWhiteApplication_person_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeApplication_application_RyanWhiteApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export interface Application_application_RyanWhiteApplication_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: Application_application_RyanWhiteApplication_person_incomeSources_esignSession | null
}
export const deserializeApplication_application_RyanWhiteApplication_person_incomeSources = (
  serialized: Application_application_RyanWhiteApplication_person_incomeSourcesOrig
): Application_application_RyanWhiteApplication_person_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeApplication_application_RyanWhiteApplication_person_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeApplication_application_RyanWhiteApplication_person_incomeSources = (
  deserialized: Application_application_RyanWhiteApplication_person_incomeSources
): Application_application_RyanWhiteApplication_person_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeApplication_application_RyanWhiteApplication_person_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Application_application_RyanWhiteApplication_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeApplication_application_RyanWhiteApplication_person_deductions = (
  serialized: Application_application_RyanWhiteApplication_person_deductionsOrig
): Application_application_RyanWhiteApplication_person_deductions => ({
  ...serialized,
})
export const serializeApplication_application_RyanWhiteApplication_person_deductions = (
  deserialized: Application_application_RyanWhiteApplication_person_deductions
): Application_application_RyanWhiteApplication_person_deductionsOrig => ({
  ...deserialized,
})
export interface Application_application_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards = (
  serialized: Application_application_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizardsOrig
): Application_application_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards = (
  deserialized: Application_application_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards
): Application_application_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Application_application_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Application_application_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession = (
  serialized: Application_application_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSessionOrig
): Application_application_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession = (
  deserialized: Application_application_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession
): Application_application_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession_esignWizards
  ),
})
export interface Application_application_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: Application_application_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession | null
}
export const deserializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers = (
  serialized: Application_application_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbersOrig
): Application_application_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers = (
  deserialized: Application_application_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers
): Application_application_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication = (
  serialized: Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplicationOrig
): Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication = (
  deserialized: Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication
): Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication = (
  serialized: Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplicationOrig
): Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication = (
  deserialized: Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication
): Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication = (
  serialized: Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplicationOrig
): Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication = (
  deserialized: Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication
): Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application =
  | Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication
  | Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication
  | Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication
export const deserializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application = (
  serialized: Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_applicationOrig
): Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application'
  )
}
export const serializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application = (
  deserialized: Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application
): Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application'
  )
}
export interface Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application | null
}
export const deserializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes = (
  serialized: Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomesOrig
): Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes = (
  deserialized: Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes
): Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface Application_application_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards = (
  serialized: Application_application_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizardsOrig
): Application_application_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards = (
  deserialized: Application_application_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards
): Application_application_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Application_application_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Application_application_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards[]
}
export const deserializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession = (
  serialized: Application_application_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSessionOrig
): Application_application_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards
  ),
})
export const serializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession = (
  deserialized: Application_application_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession
): Application_application_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession_esignWizards
  ),
})
export interface Application_application_RyanWhiteApplication_person_relationships_otherPerson_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: Application_application_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession | null
}
export const deserializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_incomeSources = (
  serialized: Application_application_RyanWhiteApplication_person_relationships_otherPerson_incomeSourcesOrig
): Application_application_RyanWhiteApplication_person_relationships_otherPerson_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_incomeSources = (
  deserialized: Application_application_RyanWhiteApplication_person_relationships_otherPerson_incomeSources
): Application_application_RyanWhiteApplication_person_relationships_otherPerson_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Application_application_RyanWhiteApplication_person_relationships_otherPerson_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_deductions = (
  serialized: Application_application_RyanWhiteApplication_person_relationships_otherPerson_deductionsOrig
): Application_application_RyanWhiteApplication_person_relationships_otherPerson_deductions => ({
  ...serialized,
})
export const serializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_deductions = (
  deserialized: Application_application_RyanWhiteApplication_person_relationships_otherPerson_deductions
): Application_application_RyanWhiteApplication_person_relationships_otherPerson_deductionsOrig => ({
  ...deserialized,
})
export interface Application_application_RyanWhiteApplication_person_relationships_otherPerson {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: Application_application_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: Application_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes[]
  incomeSources: Application_application_RyanWhiteApplication_person_relationships_otherPerson_incomeSources[]
  deductions: Application_application_RyanWhiteApplication_person_relationships_otherPerson_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
}
export const deserializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson = (
  serialized: Application_application_RyanWhiteApplication_person_relationships_otherPersonOrig
): Application_application_RyanWhiteApplication_person_relationships_otherPerson => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_deductions
  ),
})
export const serializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson = (
  deserialized: Application_application_RyanWhiteApplication_person_relationships_otherPerson
): Application_application_RyanWhiteApplication_person_relationships_otherPersonOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson_deductions
  ),
})
export interface Application_application_RyanWhiteApplication_person_relationships {
  __typename: 'Relationship'
  id: string
  relationshipType: string | null
  reverseRelationshipType: string | null
  liveTogether: boolean | null
  otherPerson: Application_application_RyanWhiteApplication_person_relationships_otherPerson
}
export const deserializeApplication_application_RyanWhiteApplication_person_relationships = (
  serialized: Application_application_RyanWhiteApplication_person_relationshipsOrig
): Application_application_RyanWhiteApplication_person_relationships => ({
  ...serialized,
  otherPerson: deserializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson(
    serialized.otherPerson
  ),
})
export const serializeApplication_application_RyanWhiteApplication_person_relationships = (
  deserialized: Application_application_RyanWhiteApplication_person_relationships
): Application_application_RyanWhiteApplication_person_relationshipsOrig => ({
  ...deserialized,
  otherPerson: serializeApplication_application_RyanWhiteApplication_person_relationships_otherPerson(
    deserialized.otherPerson
  ),
})
export interface Application_application_RyanWhiteApplication_person_documentFiles {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeApplication_application_RyanWhiteApplication_person_documentFiles = (
  serialized: Application_application_RyanWhiteApplication_person_documentFilesOrig
): Application_application_RyanWhiteApplication_person_documentFiles => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeApplication_application_RyanWhiteApplication_person_documentFiles = (
  deserialized: Application_application_RyanWhiteApplication_person_documentFiles
): Application_application_RyanWhiteApplication_person_documentFilesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface Application_application_RyanWhiteApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializeApplication_application_RyanWhiteApplication_person_openApplications_MedicaidApplication = (
  serialized: Application_application_RyanWhiteApplication_person_openApplications_MedicaidApplicationOrig
): Application_application_RyanWhiteApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeApplication_application_RyanWhiteApplication_person_openApplications_MedicaidApplication = (
  deserialized: Application_application_RyanWhiteApplication_person_openApplications_MedicaidApplication
): Application_application_RyanWhiteApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Application_application_RyanWhiteApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeApplication_application_RyanWhiteApplication_person_openApplications_CharityCareApplication = (
  serialized: Application_application_RyanWhiteApplication_person_openApplications_CharityCareApplicationOrig
): Application_application_RyanWhiteApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeApplication_application_RyanWhiteApplication_person_openApplications_CharityCareApplication = (
  deserialized: Application_application_RyanWhiteApplication_person_openApplications_CharityCareApplication
): Application_application_RyanWhiteApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Application_application_RyanWhiteApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeApplication_application_RyanWhiteApplication_person_openApplications_SlideApplication = (
  serialized: Application_application_RyanWhiteApplication_person_openApplications_SlideApplicationOrig
): Application_application_RyanWhiteApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeApplication_application_RyanWhiteApplication_person_openApplications_SlideApplication = (
  deserialized: Application_application_RyanWhiteApplication_person_openApplications_SlideApplication
): Application_application_RyanWhiteApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Application_application_RyanWhiteApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeApplication_application_RyanWhiteApplication_person_openApplications_RyanWhiteApplication = (
  serialized: Application_application_RyanWhiteApplication_person_openApplications_RyanWhiteApplicationOrig
): Application_application_RyanWhiteApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeApplication_application_RyanWhiteApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: Application_application_RyanWhiteApplication_person_openApplications_RyanWhiteApplication
): Application_application_RyanWhiteApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type Application_application_RyanWhiteApplication_person_openApplications =
  | Application_application_RyanWhiteApplication_person_openApplications_MedicaidApplication
  | Application_application_RyanWhiteApplication_person_openApplications_CharityCareApplication
  | Application_application_RyanWhiteApplication_person_openApplications_SlideApplication
  | Application_application_RyanWhiteApplication_person_openApplications_RyanWhiteApplication
export const deserializeApplication_application_RyanWhiteApplication_person_openApplications = (
  serialized: Application_application_RyanWhiteApplication_person_openApplicationsOrig
): Application_application_RyanWhiteApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializeApplication_application_RyanWhiteApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeApplication_application_RyanWhiteApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeApplication_application_RyanWhiteApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeApplication_application_RyanWhiteApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Application_application_RyanWhiteApplication_person_openApplications'
  )
}
export const serializeApplication_application_RyanWhiteApplication_person_openApplications = (
  deserialized: Application_application_RyanWhiteApplication_person_openApplications
): Application_application_RyanWhiteApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializeApplication_application_RyanWhiteApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeApplication_application_RyanWhiteApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeApplication_application_RyanWhiteApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeApplication_application_RyanWhiteApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Application_application_RyanWhiteApplication_person_openApplications'
  )
}
export interface Application_application_RyanWhiteApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializeApplication_application_RyanWhiteApplication_person_openHouseholdMemberApplications = (
  serialized: Application_application_RyanWhiteApplication_person_openHouseholdMemberApplicationsOrig
): Application_application_RyanWhiteApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeApplication_application_RyanWhiteApplication_person_openHouseholdMemberApplications = (
  deserialized: Application_application_RyanWhiteApplication_person_openHouseholdMemberApplications
): Application_application_RyanWhiteApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface Application_application_RyanWhiteApplication_person {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: Application_application_RyanWhiteApplication_person_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: Application_application_RyanWhiteApplication_person_benefitOutcomes[]
  incomeSources: Application_application_RyanWhiteApplication_person_incomeSources[]
  deductions: Application_application_RyanWhiteApplication_person_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
  relationships: Application_application_RyanWhiteApplication_person_relationships[]
  documentFiles: Application_application_RyanWhiteApplication_person_documentFiles[]
  openApplications: Application_application_RyanWhiteApplication_person_openApplications[]
  openHouseholdMemberApplications: Application_application_RyanWhiteApplication_person_openHouseholdMemberApplications[]
}
export const deserializeApplication_application_RyanWhiteApplication_person = (
  serialized: Application_application_RyanWhiteApplication_personOrig
): Application_application_RyanWhiteApplication_person => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeApplication_application_RyanWhiteApplication_person_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeApplication_application_RyanWhiteApplication_person_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeApplication_application_RyanWhiteApplication_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeApplication_application_RyanWhiteApplication_person_deductions
  ),
  relationships: serialized.relationships.map(
    deserializeApplication_application_RyanWhiteApplication_person_relationships
  ),
  documentFiles: serialized.documentFiles.map(
    deserializeApplication_application_RyanWhiteApplication_person_documentFiles
  ),
  openApplications: serialized.openApplications.map(
    deserializeApplication_application_RyanWhiteApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializeApplication_application_RyanWhiteApplication_person_openHouseholdMemberApplications
  ),
})
export const serializeApplication_application_RyanWhiteApplication_person = (
  deserialized: Application_application_RyanWhiteApplication_person
): Application_application_RyanWhiteApplication_personOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeApplication_application_RyanWhiteApplication_person_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeApplication_application_RyanWhiteApplication_person_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeApplication_application_RyanWhiteApplication_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeApplication_application_RyanWhiteApplication_person_deductions
  ),
  relationships: deserialized.relationships.map(
    serializeApplication_application_RyanWhiteApplication_person_relationships
  ),
  documentFiles: deserialized.documentFiles.map(
    serializeApplication_application_RyanWhiteApplication_person_documentFiles
  ),
  openApplications: deserialized.openApplications.map(
    serializeApplication_application_RyanWhiteApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializeApplication_application_RyanWhiteApplication_person_openHouseholdMemberApplications
  ),
})
export interface Application_application_RyanWhiteApplication_assignedTo {
  __typename: 'User'
  id: string
  email: string
  name: string | null
  isCurrentUser: boolean
}
export const deserializeApplication_application_RyanWhiteApplication_assignedTo = (
  serialized: Application_application_RyanWhiteApplication_assignedToOrig
): Application_application_RyanWhiteApplication_assignedTo => ({...serialized})
export const serializeApplication_application_RyanWhiteApplication_assignedTo = (
  deserialized: Application_application_RyanWhiteApplication_assignedTo
): Application_application_RyanWhiteApplication_assignedToOrig => ({
  ...deserialized,
})
export interface Application_application_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeApplication_application_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards = (
  serialized: Application_application_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession_esignWizardsOrig
): Application_application_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeApplication_application_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards = (
  deserialized: Application_application_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards
): Application_application_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Application_application_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Application_application_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeApplication_application_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession = (
  serialized: Application_application_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSessionOrig
): Application_application_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeApplication_application_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeApplication_application_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession = (
  deserialized: Application_application_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession
): Application_application_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeApplication_application_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession_esignWizards
  ),
})
export interface Application_application_RyanWhiteApplication_householdMembers_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: Application_application_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession | null
}
export const deserializeApplication_application_RyanWhiteApplication_householdMembers_person_phoneNumbers = (
  serialized: Application_application_RyanWhiteApplication_householdMembers_person_phoneNumbersOrig
): Application_application_RyanWhiteApplication_householdMembers_person_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeApplication_application_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeApplication_application_RyanWhiteApplication_householdMembers_person_phoneNumbers = (
  deserialized: Application_application_RyanWhiteApplication_householdMembers_person_phoneNumbers
): Application_application_RyanWhiteApplication_householdMembers_person_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeApplication_application_RyanWhiteApplication_householdMembers_person_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeApplication_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication = (
  serialized: Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplicationOrig
): Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeApplication_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication = (
  deserialized: Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication
): Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeApplication_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication = (
  serialized: Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplicationOrig
): Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeApplication_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication = (
  deserialized: Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication
): Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeApplication_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_SlideApplication = (
  serialized: Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_SlideApplicationOrig
): Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeApplication_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_SlideApplication = (
  deserialized: Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_SlideApplication
): Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application =
  | Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication
  | Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication
  | Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_SlideApplication
export const deserializeApplication_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application = (
  serialized: Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_applicationOrig
): Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeApplication_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeApplication_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeApplication_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application'
  )
}
export const serializeApplication_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application = (
  deserialized: Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application
): Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeApplication_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeApplication_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeApplication_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application'
  )
}
export interface Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application | null
}
export const deserializeApplication_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes = (
  serialized: Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomesOrig
): Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeApplication_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeApplication_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes = (
  deserialized: Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes
): Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeApplication_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface Application_application_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeApplication_application_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession_esignWizards = (
  serialized: Application_application_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession_esignWizardsOrig
): Application_application_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeApplication_application_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession_esignWizards = (
  deserialized: Application_application_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession_esignWizards
): Application_application_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface Application_application_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: Application_application_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession_esignWizards[]
}
export const deserializeApplication_application_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession = (
  serialized: Application_application_RyanWhiteApplication_householdMembers_person_incomeSources_esignSessionOrig
): Application_application_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeApplication_application_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession_esignWizards
  ),
})
export const serializeApplication_application_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession = (
  deserialized: Application_application_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession
): Application_application_RyanWhiteApplication_householdMembers_person_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeApplication_application_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession_esignWizards
  ),
})
export interface Application_application_RyanWhiteApplication_householdMembers_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: Application_application_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession | null
}
export const deserializeApplication_application_RyanWhiteApplication_householdMembers_person_incomeSources = (
  serialized: Application_application_RyanWhiteApplication_householdMembers_person_incomeSourcesOrig
): Application_application_RyanWhiteApplication_householdMembers_person_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeApplication_application_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeApplication_application_RyanWhiteApplication_householdMembers_person_incomeSources = (
  deserialized: Application_application_RyanWhiteApplication_householdMembers_person_incomeSources
): Application_application_RyanWhiteApplication_householdMembers_person_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeApplication_application_RyanWhiteApplication_householdMembers_person_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface Application_application_RyanWhiteApplication_householdMembers_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeApplication_application_RyanWhiteApplication_householdMembers_person_deductions = (
  serialized: Application_application_RyanWhiteApplication_householdMembers_person_deductionsOrig
): Application_application_RyanWhiteApplication_householdMembers_person_deductions => ({
  ...serialized,
})
export const serializeApplication_application_RyanWhiteApplication_householdMembers_person_deductions = (
  deserialized: Application_application_RyanWhiteApplication_householdMembers_person_deductions
): Application_application_RyanWhiteApplication_householdMembers_person_deductionsOrig => ({
  ...deserialized,
})
export interface Application_application_RyanWhiteApplication_householdMembers_person_documentFiles {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeApplication_application_RyanWhiteApplication_householdMembers_person_documentFiles = (
  serialized: Application_application_RyanWhiteApplication_householdMembers_person_documentFilesOrig
): Application_application_RyanWhiteApplication_householdMembers_person_documentFiles => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeApplication_application_RyanWhiteApplication_householdMembers_person_documentFiles = (
  deserialized: Application_application_RyanWhiteApplication_householdMembers_person_documentFiles
): Application_application_RyanWhiteApplication_householdMembers_person_documentFilesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface Application_application_RyanWhiteApplication_householdMembers_person {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: Application_application_RyanWhiteApplication_householdMembers_person_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: Application_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes[]
  incomeSources: Application_application_RyanWhiteApplication_householdMembers_person_incomeSources[]
  deductions: Application_application_RyanWhiteApplication_householdMembers_person_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
  documentFiles: Application_application_RyanWhiteApplication_householdMembers_person_documentFiles[]
}
export const deserializeApplication_application_RyanWhiteApplication_householdMembers_person = (
  serialized: Application_application_RyanWhiteApplication_householdMembers_personOrig
): Application_application_RyanWhiteApplication_householdMembers_person => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeApplication_application_RyanWhiteApplication_householdMembers_person_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeApplication_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeApplication_application_RyanWhiteApplication_householdMembers_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeApplication_application_RyanWhiteApplication_householdMembers_person_deductions
  ),
  documentFiles: serialized.documentFiles.map(
    deserializeApplication_application_RyanWhiteApplication_householdMembers_person_documentFiles
  ),
})
export const serializeApplication_application_RyanWhiteApplication_householdMembers_person = (
  deserialized: Application_application_RyanWhiteApplication_householdMembers_person
): Application_application_RyanWhiteApplication_householdMembers_personOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeApplication_application_RyanWhiteApplication_householdMembers_person_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeApplication_application_RyanWhiteApplication_householdMembers_person_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeApplication_application_RyanWhiteApplication_householdMembers_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeApplication_application_RyanWhiteApplication_householdMembers_person_deductions
  ),
  documentFiles: deserialized.documentFiles.map(
    serializeApplication_application_RyanWhiteApplication_householdMembers_person_documentFiles
  ),
})
export interface Application_application_RyanWhiteApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  wantsCoverage: boolean | null
  person: Application_application_RyanWhiteApplication_householdMembers_person
  createdAt: Date
}
export const deserializeApplication_application_RyanWhiteApplication_householdMembers = (
  serialized: Application_application_RyanWhiteApplication_householdMembersOrig
): Application_application_RyanWhiteApplication_householdMembers => ({
  ...serialized,
  person: deserializeApplication_application_RyanWhiteApplication_householdMembers_person(
    serialized.person
  ),
  createdAt: parseDate(serialized.createdAt),
})
export const serializeApplication_application_RyanWhiteApplication_householdMembers = (
  deserialized: Application_application_RyanWhiteApplication_householdMembers
): Application_application_RyanWhiteApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializeApplication_application_RyanWhiteApplication_householdMembers_person(
    deserialized.person
  ),
  createdAt: formatISO(deserialized.createdAt),
})
export interface Application_application_RyanWhiteApplication_documents_files {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeApplication_application_RyanWhiteApplication_documents_files = (
  serialized: Application_application_RyanWhiteApplication_documents_filesOrig
): Application_application_RyanWhiteApplication_documents_files => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeApplication_application_RyanWhiteApplication_documents_files = (
  deserialized: Application_application_RyanWhiteApplication_documents_files
): Application_application_RyanWhiteApplication_documents_filesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface Application_application_RyanWhiteApplication_documents_person {
  __typename: 'Person'
  id: string
}
export const deserializeApplication_application_RyanWhiteApplication_documents_person = (
  serialized: Application_application_RyanWhiteApplication_documents_personOrig
): Application_application_RyanWhiteApplication_documents_person => ({
  ...serialized,
})
export const serializeApplication_application_RyanWhiteApplication_documents_person = (
  deserialized: Application_application_RyanWhiteApplication_documents_person
): Application_application_RyanWhiteApplication_documents_personOrig => ({
  ...deserialized,
})
export interface Application_application_RyanWhiteApplication_documents_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializeApplication_application_RyanWhiteApplication_documents_application = (
  serialized: Application_application_RyanWhiteApplication_documents_applicationOrig
): Application_application_RyanWhiteApplication_documents_application => ({
  ...serialized,
})
export const serializeApplication_application_RyanWhiteApplication_documents_application = (
  deserialized: Application_application_RyanWhiteApplication_documents_application
): Application_application_RyanWhiteApplication_documents_applicationOrig => ({
  ...deserialized,
})
export interface Application_application_RyanWhiteApplication_documents {
  __typename: 'Document'
  id: string
  documentType: string
  complete: boolean | null
  files: Application_application_RyanWhiteApplication_documents_files[]
  updatedAt: Date
  notes: string | null
  person: Application_application_RyanWhiteApplication_documents_person | null
  application: Application_application_RyanWhiteApplication_documents_application
}
export const deserializeApplication_application_RyanWhiteApplication_documents = (
  serialized: Application_application_RyanWhiteApplication_documentsOrig
): Application_application_RyanWhiteApplication_documents => ({
  ...serialized,
  files: serialized.files.map(
    deserializeApplication_application_RyanWhiteApplication_documents_files
  ),
  updatedAt: parseDate(serialized.updatedAt),
  person:
    serialized.person != null
      ? deserializeApplication_application_RyanWhiteApplication_documents_person(
          serialized.person
        )
      : serialized.person,
  application: deserializeApplication_application_RyanWhiteApplication_documents_application(
    serialized.application
  ),
})
export const serializeApplication_application_RyanWhiteApplication_documents = (
  deserialized: Application_application_RyanWhiteApplication_documents
): Application_application_RyanWhiteApplication_documentsOrig => ({
  ...deserialized,
  files: deserialized.files.map(
    serializeApplication_application_RyanWhiteApplication_documents_files
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  person:
    deserialized.person != null
      ? serializeApplication_application_RyanWhiteApplication_documents_person(
          deserialized.person
        )
      : deserialized.person,
  application: serializeApplication_application_RyanWhiteApplication_documents_application(
    deserialized.application
  ),
})
export interface Application_application_RyanWhiteApplication_documentFiles_documents {
  __typename: 'Document'
  id: string
}
export const deserializeApplication_application_RyanWhiteApplication_documentFiles_documents = (
  serialized: Application_application_RyanWhiteApplication_documentFiles_documentsOrig
): Application_application_RyanWhiteApplication_documentFiles_documents => ({
  ...serialized,
})
export const serializeApplication_application_RyanWhiteApplication_documentFiles_documents = (
  deserialized: Application_application_RyanWhiteApplication_documentFiles_documents
): Application_application_RyanWhiteApplication_documentFiles_documentsOrig => ({
  ...deserialized,
})
export interface Application_application_RyanWhiteApplication_documentFiles {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
  documents: Application_application_RyanWhiteApplication_documentFiles_documents[]
}
export const deserializeApplication_application_RyanWhiteApplication_documentFiles = (
  serialized: Application_application_RyanWhiteApplication_documentFilesOrig
): Application_application_RyanWhiteApplication_documentFiles => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
  documents: serialized.documents.map(
    deserializeApplication_application_RyanWhiteApplication_documentFiles_documents
  ),
})
export const serializeApplication_application_RyanWhiteApplication_documentFiles = (
  deserialized: Application_application_RyanWhiteApplication_documentFiles
): Application_application_RyanWhiteApplication_documentFilesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
  documents: deserialized.documents.map(
    serializeApplication_application_RyanWhiteApplication_documentFiles_documents
  ),
})
export interface Application_application_RyanWhiteApplication_benefitOutcomes_person {
  __typename: 'Person'
  id: string
}
export const deserializeApplication_application_RyanWhiteApplication_benefitOutcomes_person = (
  serialized: Application_application_RyanWhiteApplication_benefitOutcomes_personOrig
): Application_application_RyanWhiteApplication_benefitOutcomes_person => ({
  ...serialized,
})
export const serializeApplication_application_RyanWhiteApplication_benefitOutcomes_person = (
  deserialized: Application_application_RyanWhiteApplication_benefitOutcomes_person
): Application_application_RyanWhiteApplication_benefitOutcomes_personOrig => ({
  ...deserialized,
})
export interface Application_application_RyanWhiteApplication_benefitOutcomes_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializeApplication_application_RyanWhiteApplication_benefitOutcomes_application = (
  serialized: Application_application_RyanWhiteApplication_benefitOutcomes_applicationOrig
): Application_application_RyanWhiteApplication_benefitOutcomes_application => ({
  ...serialized,
})
export const serializeApplication_application_RyanWhiteApplication_benefitOutcomes_application = (
  deserialized: Application_application_RyanWhiteApplication_benefitOutcomes_application
): Application_application_RyanWhiteApplication_benefitOutcomes_applicationOrig => ({
  ...deserialized,
})
export interface Application_application_RyanWhiteApplication_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  person: Application_application_RyanWhiteApplication_benefitOutcomes_person
  application: Application_application_RyanWhiteApplication_benefitOutcomes_application | null
}
export const deserializeApplication_application_RyanWhiteApplication_benefitOutcomes = (
  serialized: Application_application_RyanWhiteApplication_benefitOutcomesOrig
): Application_application_RyanWhiteApplication_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  person: deserializeApplication_application_RyanWhiteApplication_benefitOutcomes_person(
    serialized.person
  ),
  application:
    serialized.application != null
      ? deserializeApplication_application_RyanWhiteApplication_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeApplication_application_RyanWhiteApplication_benefitOutcomes = (
  deserialized: Application_application_RyanWhiteApplication_benefitOutcomes
): Application_application_RyanWhiteApplication_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  person: serializeApplication_application_RyanWhiteApplication_benefitOutcomes_person(
    deserialized.person
  ),
  application:
    deserialized.application != null
      ? serializeApplication_application_RyanWhiteApplication_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface Application_application_RyanWhiteApplication_accountOnDateOfService {
  __typename: 'Account'
  id: string
  hospitalAccountId: string | null
  dateOfService: Date
  timeOfService: string | null
  serviceTimeZone: string
  facility: string
  department: string
  location: string | null
  insuranceType: string
  status: string
  createdAt: Date
  updatedAt: Date
  notes: string | null
  accountAmount: number | null
  njmmisCheck: string | null
  previousInsurance: string | null
  invoiceMonth: string | null
  invoiceYear: string | null
  dischargeDate: Date | null
  isScheduled: boolean
}
export const deserializeApplication_application_RyanWhiteApplication_accountOnDateOfService = (
  serialized: Application_application_RyanWhiteApplication_accountOnDateOfServiceOrig
): Application_application_RyanWhiteApplication_accountOnDateOfService => ({
  ...serialized,
  dateOfService: parseDate(serialized.dateOfService),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  njmmisCheck:
    serialized.njmmisCheck != null
      ? deserializeNjmmisCheckResult(serialized.njmmisCheck)
      : serialized.njmmisCheck,
  dischargeDate:
    serialized.dischargeDate != null
      ? parseDate(serialized.dischargeDate)
      : serialized.dischargeDate,
})
export const serializeApplication_application_RyanWhiteApplication_accountOnDateOfService = (
  deserialized: Application_application_RyanWhiteApplication_accountOnDateOfService
): Application_application_RyanWhiteApplication_accountOnDateOfServiceOrig => ({
  ...deserialized,
  dateOfService: formatISODate(deserialized.dateOfService),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  njmmisCheck:
    deserialized.njmmisCheck != null
      ? serializeNjmmisCheckResult(deserialized.njmmisCheck)
      : deserialized.njmmisCheck,
  dischargeDate:
    deserialized.dischargeDate != null
      ? formatISODate(deserialized.dischargeDate)
      : deserialized.dischargeDate,
})
export interface Application_application_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  person: Application_application_RyanWhiteApplication_person
  assignedTo: Application_application_RyanWhiteApplication_assignedTo | null
  householdMembers: Application_application_RyanWhiteApplication_householdMembers[]
  documents: Application_application_RyanWhiteApplication_documents[]
  documentFiles: Application_application_RyanWhiteApplication_documentFiles[]
  benefitOutcomes: Application_application_RyanWhiteApplication_benefitOutcomes[]
  accountOnDateOfService: Application_application_RyanWhiteApplication_accountOnDateOfService | null
  initialDateOfService: Date | null
  receivedDate: Date | null
  notes: string | null
  facility: string
  dateOfApplication: Date | null
  coveragePeriod: number | null
}
export const deserializeApplication_application_RyanWhiteApplication = (
  serialized: Application_application_RyanWhiteApplicationOrig
): Application_application_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  person: deserializeApplication_application_RyanWhiteApplication_person(
    serialized.person
  ),
  assignedTo:
    serialized.assignedTo != null
      ? deserializeApplication_application_RyanWhiteApplication_assignedTo(
          serialized.assignedTo
        )
      : serialized.assignedTo,
  householdMembers: serialized.householdMembers.map(
    deserializeApplication_application_RyanWhiteApplication_householdMembers
  ),
  documents: serialized.documents.map(
    deserializeApplication_application_RyanWhiteApplication_documents
  ),
  documentFiles: serialized.documentFiles.map(
    deserializeApplication_application_RyanWhiteApplication_documentFiles
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeApplication_application_RyanWhiteApplication_benefitOutcomes
  ),
  accountOnDateOfService:
    serialized.accountOnDateOfService != null
      ? deserializeApplication_application_RyanWhiteApplication_accountOnDateOfService(
          serialized.accountOnDateOfService
        )
      : serialized.accountOnDateOfService,
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  receivedDate:
    serialized.receivedDate != null
      ? parseDate(serialized.receivedDate)
      : serialized.receivedDate,
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
})
export const serializeApplication_application_RyanWhiteApplication = (
  deserialized: Application_application_RyanWhiteApplication
): Application_application_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  person: serializeApplication_application_RyanWhiteApplication_person(
    deserialized.person
  ),
  assignedTo:
    deserialized.assignedTo != null
      ? serializeApplication_application_RyanWhiteApplication_assignedTo(
          deserialized.assignedTo
        )
      : deserialized.assignedTo,
  householdMembers: deserialized.householdMembers.map(
    serializeApplication_application_RyanWhiteApplication_householdMembers
  ),
  documents: deserialized.documents.map(
    serializeApplication_application_RyanWhiteApplication_documents
  ),
  documentFiles: deserialized.documentFiles.map(
    serializeApplication_application_RyanWhiteApplication_documentFiles
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeApplication_application_RyanWhiteApplication_benefitOutcomes
  ),
  accountOnDateOfService:
    deserialized.accountOnDateOfService != null
      ? serializeApplication_application_RyanWhiteApplication_accountOnDateOfService(
          deserialized.accountOnDateOfService
        )
      : deserialized.accountOnDateOfService,
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  receivedDate:
    deserialized.receivedDate != null
      ? formatISODate(deserialized.receivedDate)
      : deserialized.receivedDate,
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
})
export type Application_application =
  | Application_application_MedicaidApplication
  | Application_application_MonitorApplication
  | Application_application_CharityCareApplication
  | Application_application_SlideApplication
  | Application_application_RyanWhiteApplication
export const deserializeApplication_application = (
  serialized: Application_applicationOrig
): Application_application => {
  if (false || serialized.__typename === 'MedicaidApplication')
    return deserializeApplication_application_MedicaidApplication(serialized)
  if (false || serialized.__typename === 'MonitorApplication')
    return deserializeApplication_application_MonitorApplication(serialized)
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeApplication_application_CharityCareApplication(serialized)
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeApplication_application_SlideApplication(serialized)
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeApplication_application_RyanWhiteApplication(serialized)
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` + 'Application_application'
  )
}
export const serializeApplication_application = (
  deserialized: Application_application
): Application_applicationOrig => {
  if (false || deserialized.__typename === 'MedicaidApplication')
    return serializeApplication_application_MedicaidApplication(deserialized)
  if (false || deserialized.__typename === 'MonitorApplication')
    return serializeApplication_application_MonitorApplication(deserialized)
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeApplication_application_CharityCareApplication(deserialized)
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeApplication_application_SlideApplication(deserialized)
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeApplication_application_RyanWhiteApplication(deserialized)
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` + 'Application_application'
  )
}
export interface Application {
  /**
   * Application
   */
  application: Application_application
}
export const deserializeApplication = (
  serialized: ApplicationOrig
): Application => ({
  ...serialized,
  application: deserializeApplication_application(serialized.application),
})
export const serializeApplication = (
  deserialized: Application
): ApplicationOrig => ({
  ...deserialized,
  application: serializeApplication_application(deserialized.application),
})
export interface ApplicationVariables {
  id: string
}
export const deserializeApplicationVariables = (
  serialized: ApplicationVariablesOrig
): ApplicationVariables => ({...serialized})
export const serializeApplicationVariables = (
  deserialized: ApplicationVariables
): ApplicationVariablesOrig => ({...deserialized})
